(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-cedarshed-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-cedarshed");
    if (!root) return;

    const productEl = document.getElementById("hsrCedarshedProduct");
    const expeditedEl = document.getElementById("hsrCedarshedExpedited");
    const btn = document.getElementById("hsrGoCedarshed");
    const clr = document.getElementById("hsrClearCedarshed");
    const err = document.getElementById("hsrErrCedarshed");
    const out = document.getElementById("hsrOutCedarshed");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_cedarshed_live_v3_20260317";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    let hasEstimated = false;
    let detectedProductValue = "";

    const FALLBACK_DATA = {
      standard: {
        productionWeeksMin: 2,
        productionWeeksMax: 2,
        shippingWeeksMin: 1,
        shippingWeeksMax: 1,
        productionDisplay: "2 weeks",
        shippingDisplay: "1 week"
      },
      expedited: {
        productionWeeksMin: 1,
        productionWeeksMax: 1,
        shippingWeeksMin: 1,
        shippingWeeksMax: 1,
        productionDisplay: "1 week",
        shippingDisplay: "1 week"
      },
      shipsFrom: "just north of Seattle, Washington in BC Canada",
      expeditedAvailabilityNote:
        "Expedited production availability varies based on order volume and season.",
      metalRoofNote:
        "Metal roof variants typically add 1 additional week to the expedited timeline.",
      contactNote:
        "Please contact us before ordering to confirm current expedited availability."
    };

    const showErr = (on, msg) => {
      err.textContent = msg || "";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();

        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    const weeksToBusinessDays = (weeks) => Number(weeks) * 5;

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");

        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;

        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    function normalizeText(text) {
      return String(text || "")
        .replace(/\u00a0/g, " ")
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
    }

    function normalizeForMatch(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/&amp;|&/g, " and ")
        .replace(/[\u2018\u2019']/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function extractCedarshedSection(text) {
      const normalized = normalizeText(text);
      const startIndex = normalized.search(/Cedarsheds/i);

      if (startIndex === -1) {
        return normalized;
      }

      const afterStart = normalized.slice(startIndex);
      const endMatch = afterStart.match(/\bMilky Products\b/i);

      if (!endMatch) {
        return afterStart;
      }

      return afterStart.slice(0, endMatch.index);
    }

    function formatWeeks(min, max) {
      if (Number(min) === Number(max)) {
        return Number(min) === 1 ? "1 week" : `${min} weeks`;
      }

      return `${min} to ${max} weeks`;
    }

    function parseWeeksPair(text, regex) {
      const match = text.match(regex);
      if (!match) return null;

      const min = Number(match[1]);
      const max = match[2] ? Number(match[2]) : min;

      return {
        min,
        max,
        display: formatWeeks(min, max)
      };
    }

    function getCurrentPathHandle() {
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? match[1].replace(/-/g, " ") : "";
    }

    function getPageProductCandidates() {
      const selectors = [
        '[data-product-title]',
        '.product-title',
        '.product__title',
        '.product-single__title',
        '.product_title',
        '.product-meta__title',
        'main h1',
        'h1'
      ];

      const values = [];

      const pushValue = (value) => {
        const clean = normalizeText(value);
        if (!clean) return;
        if (!values.includes(clean)) values.push(clean);
      };

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          pushValue(el.getAttribute("data-product-title"));
          pushValue(el.textContent);
        });
      });

      const ogTitle = document.querySelector('meta[property="og:title"]');
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');

      if (ogTitle) pushValue(ogTitle.getAttribute("content"));
      if (twitterTitle) pushValue(twitterTitle.getAttribute("content"));

      pushValue(document.title);
      pushValue(getCurrentPathHandle());

      return values;
    }

    function scoreOptionAgainstCandidate(optionText, candidateText) {
      const optionNorm = normalizeForMatch(optionText);
      const candidateNorm = normalizeForMatch(candidateText);

      if (!optionNorm || !candidateNorm) return 0;
      if (optionNorm === candidateNorm) return 1000;
      if (candidateNorm.includes(optionNorm)) return 900;
      if (optionNorm.includes(candidateNorm)) return 700;

      const optionTokens = optionNorm
        .split(" ")
        .filter((token) => token.length > 2);

      const candidateTokens = new Set(
        candidateNorm.split(" ").filter((token) => token.length > 2)
      );

      let overlap = 0;
      optionTokens.forEach((token) => {
        if (candidateTokens.has(token)) overlap += 1;
      });

      let score = overlap * 25;

      if (optionTokens.length && optionTokens.every((token) => candidateTokens.has(token))) {
        score += 300;
      }

      return score;
    }

    function detectCurrentCedarshedProduct() {
      const options = Array.from(productEl.options).filter((option) => option.value);
      const candidates = getPageProductCandidates();

      let bestValue = "";
      let bestScore = 0;

      candidates.forEach((candidate) => {
        options.forEach((option) => {
          const score = scoreOptionAgainstCandidate(option.value, candidate);

          if (score > bestScore) {
            bestScore = score;
            bestValue = option.value;
          }
        });
      });

      return bestScore >= 300 ? bestValue : "";
    }

    function applyDetectedProduct(retries = 0) {
      const detected = detectCurrentCedarshedProduct();

      if (detected) {
        detectedProductValue = detected;
        productEl.value = detected;
        return;
      }

      if (retries < 10) {
        setTimeout(() => {
          applyDetectedProduct(retries + 1);
        }, 300);
      }
    }

    async function fetchFreshCedarshedData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const rawText = doc.body ? doc.body.innerText || doc.body.textContent || html : html;
      const cedarshedText = extractCedarshedSection(rawText);

      const data = JSON.parse(JSON.stringify(FALLBACK_DATA));

      const standardProduction = parseWeeksPair(
        cedarshedText,
        /lead\s+time\s+for\s+production\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const standardShipping = parseWeeksPair(
        cedarshedText,
        /shipping\s+time\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const expeditedProduction = parseWeeksPair(
        cedarshedText,
        /expedited\s+production.*?shortens?\s+the\s+production\s+lead\s+time\s+to\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const expeditedShipping = parseWeeksPair(
        cedarshedText,
        /expedited\s+production.*?shipping\s+time\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const shipsFromMatch = cedarshedText.match(
        /shipped\s+from\s+(.+?)\s+and\s+the\s+shipping\s+time\s+is/i
      );

      const availabilityMatch = cedarshedText.match(
        /(Expedited production availability varies based on order volume and season\.)/i
      );

      const metalRoofMatch = cedarshedText.match(
        /(Metal roof variants typically add 1 additional week to the expedited timeline\.)/i
      );

      const contactMatch = cedarshedText.match(
        /(Please contact us before ordering to confirm current expedited availability\.)/i
      );

      if (standardProduction) {
        data.standard.productionWeeksMin = standardProduction.min;
        data.standard.productionWeeksMax = standardProduction.max;
        data.standard.productionDisplay = standardProduction.display;
      }

      if (standardShipping) {
        data.standard.shippingWeeksMin = standardShipping.min;
        data.standard.shippingWeeksMax = standardShipping.max;
        data.standard.shippingDisplay = standardShipping.display;
      }

      if (expeditedProduction) {
        data.expedited.productionWeeksMin = expeditedProduction.min;
        data.expedited.productionWeeksMax = expeditedProduction.max;
        data.expedited.productionDisplay = expeditedProduction.display;
      }

      if (expeditedShipping) {
        data.expedited.shippingWeeksMin = expeditedShipping.min;
        data.expedited.shippingWeeksMax = expeditedShipping.max;
        data.expedited.shippingDisplay = expeditedShipping.display;
      } else {
        data.expedited.shippingWeeksMin = data.standard.shippingWeeksMin;
        data.expedited.shippingWeeksMax = data.standard.shippingWeeksMax;
        data.expedited.shippingDisplay = data.standard.shippingDisplay;
      }

      if (shipsFromMatch && shipsFromMatch[1]) {
        data.shipsFrom = shipsFromMatch[1].trim();
      }

      if (availabilityMatch && availabilityMatch[1]) {
        data.expeditedAvailabilityNote = availabilityMatch[1].trim();
      }

      if (metalRoofMatch && metalRoofMatch[1]) {
        data.metalRoofNote = metalRoofMatch[1].trim();
      }

      if (contactMatch && contactMatch[1]) {
        data.contactNote = contactMatch[1].trim();
      }

      writeCache(data);
      return data;
    }

    async function getCedarshedData() {
      const cached = readCache();
      if (cached) return cached;

      return fetchFreshCedarshedData();
    }

    function renderTable(productTitle, data, useExpedited) {
      const selected = useExpedited ? data.expedited : data.standard;
      const today = new Date();

      const earliestBD =
        weeksToBusinessDays(selected.productionWeeksMin) +
        weeksToBusinessDays(selected.shippingWeeksMin);

      const latestBD =
        weeksToBusinessDays(selected.productionWeeksMax) +
        weeksToBusinessDays(selected.shippingWeeksMax);

      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const deliveryWindow =
        fmtDate(earliest) === fmtDate(latest)
          ? fmtDate(earliest)
          : `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      const expeditedRow = useExpedited
        ? `<tr><th>Expedited shipping</th><td>Selected</td></tr>`
        : "";

      const expeditedAlert = useExpedited
        ? `
          <div class="hsr-alert">
            <p>${data.expeditedAvailabilityNote}</p>
            <p>${data.metalRoofNote}</p>
            <p>${data.contactNote}</p>
          </div>
        `
        : "";

      out.innerHTML = `
        <table aria-label="Cedarshed delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Production lead time</th><td>${selected.productionDisplay}</td></tr>
            <tr><th>Shipping time</th><td>${selected.shippingDisplay}</td></tr>
            <tr><th>Ships from</th><td>${data.shipsFrom}</td></tr>
            ${expeditedRow}
            <tr><th>Estimated delivery window</th><td><strong>${deliveryWindow}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Carrier timing and destination can still affect final delivery.
        </p>
        ${expeditedAlert}
      `;
    }

    async function runEstimate() {
      const productName = String(productEl.value || "").trim();
      const useExpedited = !!expeditedEl.checked;

      if (!productName) {
        out.innerHTML = "";
        showErr(true, "Please choose a Cedarshed product.");
        return false;
      }

      showErr(false);

      try {
        const data = await getCedarshedData();
        renderTable(productName, data, useExpedited);
      } catch (e) {
        renderTable(productName, FALLBACK_DATA, useExpedited);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "hsr_delivery_estimate_cedarshed",
        cedarshed_product_name: productName,
        cedarshed_expedited_selected: useExpedited
      });

      return true;
    }

    btn.addEventListener("click", async () => {
      hasEstimated = await runEstimate();
    });

    expeditedEl.addEventListener("change", async () => {
      if (!hasEstimated) return;
      await runEstimate();
    });

    clr.addEventListener("click", () => {
      productEl.value = detectedProductValue || "";
      expeditedEl.checked = false;
      out.innerHTML = "";
      showErr(false);
      hasEstimated = false;
    });

    window.hsrCedarshedClearLeadTimeCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
      } catch (e) {}
    };

    window.hsrCedarshedReadLeadTimeCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };

    applyDetectedProduct();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-cedarshed-gardener-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-cedarshed");
    if (!root) return;

    const productEl = document.getElementById("hsrCedarshedProduct");
    const expeditedEl = document.getElementById("hsrCedarshedExpedited");
    const btn = document.getElementById("hsrGoCedarshed");
    const clr = document.getElementById("hsrClearCedarshed");
    const err = document.getElementById("hsrErrCedarshed");
    const out = document.getElementById("hsrOutCedarshed");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_cedarshed_live_v3_20260317";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    let hasEstimated = false;

    const FALLBACK_DATA = {
      standard: {
        productionWeeksMin: 2,
        productionWeeksMax: 2,
        shippingWeeksMin: 1,
        shippingWeeksMax: 1,
        productionDisplay: "2 weeks",
        shippingDisplay: "1 week"
      },
      expedited: {
        productionWeeksMin: 1,
        productionWeeksMax: 1,
        shippingWeeksMin: 1,
        shippingWeeksMax: 1,
        productionDisplay: "1 week",
        shippingDisplay: "1 week"
      },
      shipsFrom: "just north of Seattle, Washington in BC Canada",
      expeditedAvailabilityNote:
        "Expedited production availability varies based on order volume and season.",
      metalRoofNote:
        "Metal roof variants typically add 1 additional week to the expedited timeline.",
      contactNote:
        "Please contact us before ordering to confirm current expedited availability."
    };

    const showErr = (on, msg) => {
      err.textContent = msg || "";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();

        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }

      return d;
    };

    const fmtDate = d =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    const weeksToBusinessDays = weeks => Number(weeks) * 5;

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");

        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;

        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    function normalizeText(text) {
      return String(text || "")
        .replace(/\u00a0/g, " ")
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
    }

    function extractCedarshedSection(text) {
      const normalized = normalizeText(text);
      const startIndex = normalized.search(/Cedarsheds/i);

      if (startIndex === -1) {
        return normalized;
      }

      const afterStart = normalized.slice(startIndex);
      const endMatch = afterStart.match(/\bMilky Products\b/i);

      if (!endMatch) {
        return afterStart;
      }

      return afterStart.slice(0, endMatch.index);
    }

    function formatWeeks(min, max) {
      if (Number(min) === Number(max)) {
        return Number(min) === 1 ? "1 week" : `${min} weeks`;
      }

      return `${min} to ${max} weeks`;
    }

    function parseWeeksPair(text, regex) {
      const match = text.match(regex);
      if (!match) return null;

      const min = Number(match[1]);
      const max = match[2] ? Number(match[2]) : min;

      return {
        min,
        max,
        display: formatWeeks(min, max)
      };
    }

    async function fetchFreshCedarshedData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const rawText = doc.body ? doc.body.innerText || doc.body.textContent || html : html;
      const cedarshedText = extractCedarshedSection(rawText);

      const data = JSON.parse(JSON.stringify(FALLBACK_DATA));

      const standardProduction = parseWeeksPair(
        cedarshedText,
        /lead\s+time\s+for\s+production\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const standardShipping = parseWeeksPair(
        cedarshedText,
        /shipping\s+time\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const expeditedProduction = parseWeeksPair(
        cedarshedText,
        /expedited\s+production.*?shortens?\s+the\s+production\s+lead\s+time\s+to\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const expeditedShipping = parseWeeksPair(
        cedarshedText,
        /expedited\s+production.*?shipping\s+time\s+is\s+(\d+)(?:\s+to\s+(\d+))?\s+weeks?/i
      );

      const shipsFromMatch = cedarshedText.match(
        /shipped\s+from\s+(.+?)\s+and\s+the\s+shipping\s+time\s+is/i
      );

      const availabilityMatch = cedarshedText.match(
        /(Expedited production availability varies based on order volume and season\.)/i
      );

      const metalRoofMatch = cedarshedText.match(
        /(Metal roof variants typically add 1 additional week to the expedited timeline\.)/i
      );

      const contactMatch = cedarshedText.match(
        /(Please contact us before ordering to confirm current expedited availability\.)/i
      );

      if (standardProduction) {
        data.standard.productionWeeksMin = standardProduction.min;
        data.standard.productionWeeksMax = standardProduction.max;
        data.standard.productionDisplay = standardProduction.display;
      }

      if (standardShipping) {
        data.standard.shippingWeeksMin = standardShipping.min;
        data.standard.shippingWeeksMax = standardShipping.max;
        data.standard.shippingDisplay = standardShipping.display;
      }

      if (expeditedProduction) {
        data.expedited.productionWeeksMin = expeditedProduction.min;
        data.expedited.productionWeeksMax = expeditedProduction.max;
        data.expedited.productionDisplay = expeditedProduction.display;
      }

      if (expeditedShipping) {
        data.expedited.shippingWeeksMin = expeditedShipping.min;
        data.expedited.shippingWeeksMax = expeditedShipping.max;
        data.expedited.shippingDisplay = expeditedShipping.display;
      } else {
        data.expedited.shippingWeeksMin = data.standard.shippingWeeksMin;
        data.expedited.shippingWeeksMax = data.standard.shippingWeeksMax;
        data.expedited.shippingDisplay = data.standard.shippingDisplay;
      }

      if (shipsFromMatch && shipsFromMatch[1]) {
        data.shipsFrom = shipsFromMatch[1].trim();
      }

      if (availabilityMatch && availabilityMatch[1]) {
        data.expeditedAvailabilityNote = availabilityMatch[1].trim();
      }

      if (metalRoofMatch && metalRoofMatch[1]) {
        data.metalRoofNote = metalRoofMatch[1].trim();
      }

      if (contactMatch && contactMatch[1]) {
        data.contactNote = contactMatch[1].trim();
      }

      writeCache(data);
      return data;
    }

    async function getCedarshedData() {
      const cached = readCache();
      if (cached) return cached;

      return fetchFreshCedarshedData();
    }

    function renderTable(productTitle, data, useExpedited) {
      const selected = useExpedited ? data.expedited : data.standard;
      const today = new Date();

      const earliestBD =
        weeksToBusinessDays(selected.productionWeeksMin) +
        weeksToBusinessDays(selected.shippingWeeksMin);

      const latestBD =
        weeksToBusinessDays(selected.productionWeeksMax) +
        weeksToBusinessDays(selected.shippingWeeksMax);

      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const deliveryWindow =
        fmtDate(earliest) === fmtDate(latest)
          ? fmtDate(earliest)
          : `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      const expeditedRow = useExpedited
        ? `<tr><th>Expedited shipping</th><td>Selected</td></tr>`
        : "";

      const expeditedAlert = useExpedited
        ? `
          <div class="hsr-alert">
            <p>${data.expeditedAvailabilityNote}</p>
            <p>${data.metalRoofNote}</p>
            <p>${data.contactNote}</p>
          </div>
        `
        : "";

      out.innerHTML = `
        <table aria-label="Cedarshed delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Production lead time</th><td>${selected.productionDisplay}</td></tr>
            <tr><th>Shipping time</th><td>${selected.shippingDisplay}</td></tr>
            <tr><th>Ships from</th><td>${data.shipsFrom}</td></tr>
            ${expeditedRow}
            <tr><th>Estimated delivery window</th><td><strong>${deliveryWindow}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Carrier timing and destination can still affect final delivery.
        </p>
        ${expeditedAlert}
      `;
    }

    async function runEstimate() {
      const productName = String(productEl.value || "").trim();
      const useExpedited = !!expeditedEl.checked;

      if (!productName) {
        out.innerHTML = "";
        showErr(true, "Please choose a Cedarshed product.");
        return false;
      }

      showErr(false);

      try {
        const data = await getCedarshedData();
        renderTable(productName, data, useExpedited);
      } catch (e) {
        renderTable(productName, FALLBACK_DATA, useExpedited);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "hsr_delivery_estimate_cedarshed",
        cedarshed_product_name: productName,
        cedarshed_expedited_selected: useExpedited
      });

      return true;
    }

    btn.addEventListener("click", async () => {
      hasEstimated = await runEstimate();
    });

    expeditedEl.addEventListener("change", async () => {
      if (!hasEstimated) return;
      await runEstimate();
    });

    clr.addEventListener("click", () => {
      productEl.value = "";
      expeditedEl.checked = false;
      out.innerHTML = "";
      showErr(false);
      hasEstimated = false;
    });

    window.hsrCedarshedClearLeadTimeCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
      } catch (e) {}
    };

    window.hsrCedarshedReadLeadTimeCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ezfit-coop-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-ezfit");
    if (!root) return;

    const zipEl = document.getElementById("hsrZip-ezfit");
    const productEl = document.getElementById("hsrProduct-ezfit");
    const btn = document.getElementById("hsrGo-ezfit");
    const clr = document.getElementById("hsrClear-ezfit");
    const err = document.getElementById("hsrErr-ezfit");
    const out = document.getElementById("hsrOut-ezfit");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_ezfit_production_live_v8_20260909";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
    const OLD_CACHE_KEYS = [
      "hsr_ezfit_production_live_v7_20260311",
      "hsr_ezfit_production_live_v6_20260311",
      "hsr_ezfit_production_live_v5_20260311",
      "hsr_ezfit_live_leadtime_v1",
      "hsr_ezfit_live_leadtime_v2",
      "hsr_ezfit_live_leadtime_v3",
      "hsr_ezfit_live_leadtime_v4_20260311_refresh",
      "hsr_leadtime_cache_v1",
      "hsr_leadtime_cache_ezfit_v1"
    ];

    const PRODUCT_MAP = {
      riverside: { label: "EZ-Fit Riverside Shed Kit", mode: "regular" },
      homestead: { label: "EZ-Fit Homestead Shed Kit", mode: "regular" },
      heritage: { label: "EZ-Fit Heritage Shed Kit", mode: "regular" },
      greenhouse: { label: "EZ-Fit Greenhouse Shed Kit", mode: "regular" },
      skyview: { label: "EZ-Fit Skyview Shed Kit", mode: "regular" },
      woodsman: { label: "EZ-Fit Woodsman Shed Kit", mode: "regular" },
      craftsman: { label: "EZ-Fit Craftsman Storage Shed Kit", mode: "regular" },
      dog_kennel_4x7: { label: "EZ-Fit 4x7 Dog Kennel Kit with Run", mode: "regular" },
      dog_kennel_5x8: { label: "EZ-Fit 5x8 Dog Kennel Kit with Run", mode: "regular" },
      chicken_coop_5x8: { label: "EZ-Fit 5x8 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_4x6: { label: "EZ-Fit 4x6 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_3x4: { label: "EZ-Fit Portable 3x4 Chicken Coop Kit", mode: "regular" },
      playhouse_7x6: { label: "EZ-Fit 7x6 Playhouse Kit", mode: "regular" },
      riverside_quickship: { label: "EZ-Fit Riverside Shed Kit - QUICK-SHIP", mode: "quickship" },
      homestead_quickship: { label: "EZ-Fit Homestead Shed Kit - QUICK-SHIP", mode: "quickship" },
      heritage_quickship: { label: "EZ-Fit Heritage Shed Kit - QUICK-SHIP", mode: "quickship" },
      greenhouse_quickship: { label: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP", mode: "quickship" }
    };

    const STATE_TRANSIT = {
      OH: { min: 1, max: 2 },

      IN: { min: 2, max: 3 },
      MI: { min: 2, max: 3 },
      PA: { min: 2, max: 3 },
      WV: { min: 2, max: 3 },
      KY: { min: 2, max: 3 },

      IL: { min: 3, max: 4 },
      WI: { min: 3, max: 4 },
      NY: { min: 3, max: 4 },
      VA: { min: 3, max: 4 },
      MD: { min: 3, max: 4 },
      DE: { min: 3, max: 4 },
      NJ: { min: 3, max: 4 },
      TN: { min: 3, max: 4 },
      NC: { min: 3, max: 4 },
      DC: { min: 3, max: 4 },

      AL: { min: 4, max: 5 },
      AR: { min: 4, max: 5 },
      CT: { min: 4, max: 5 },
      GA: { min: 4, max: 5 },
      IA: { min: 4, max: 5 },
      LA: { min: 4, max: 5 },
      MA: { min: 4, max: 5 },
      MS: { min: 4, max: 5 },
      MO: { min: 4, max: 5 },
      NH: { min: 4, max: 5 },
      RI: { min: 4, max: 5 },
      SC: { min: 4, max: 5 },
      VT: { min: 4, max: 5 },

      FL: { min: 5, max: 6 },
      KS: { min: 5, max: 6 },
      ME: { min: 5, max: 6 },
      MN: { min: 5, max: 6 },
      NE: { min: 5, max: 6 },
      OK: { min: 5, max: 6 },
      SD: { min: 5, max: 6 },

      CO: { min: 6, max: 7 },
      ND: { min: 6, max: 7 },
      NM: { min: 6, max: 7 },
      TX: { min: 6, max: 7 },
      WY: { min: 6, max: 7 },

      AZ: { min: 7, max: 8 },
      ID: { min: 7, max: 8 },
      MT: { min: 7, max: 8 },
      NV: { min: 7, max: 8 },
      UT: { min: 7, max: 8 },

      CA: { min: 7, max: 9 },
      OR: { min: 7, max: 9 },
      WA: { min: 7, max: 9 },

      AK: { min: null, max: null, blocked: true },
      HI: { min: null, max: null, blocked: true }
    };

    const STATE_NAMES = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "Washington DC",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming"
    };

    const ZIP_STATE_RANGES = [
      ["AK", 995, 999],
      ["AL", 350, 369],
      ["AR", 716, 729],
      ["AZ", 850, 865],
      ["CA", 900, 961],
      ["CO", 800, 816],
      ["CT", 60, 69],
      ["DC", 200, 205],
      ["DE", 197, 199],
      ["FL", 320, 349],
      ["GA", 300, 319],
      ["HI", 967, 968],
      ["IA", 500, 528],
      ["ID", 832, 838],
      ["IL", 600, 629],
      ["IN", 460, 479],
      ["KS", 660, 679],
      ["KY", 400, 427],
      ["LA", 700, 714],
      ["MA", 10, 27],
      ["MD", 206, 219],
      ["ME", 39, 49],
      ["MI", 480, 499],
      ["MN", 550, 567],
      ["MO", 630, 658],
      ["MS", 386, 397],
      ["MT", 590, 599],
      ["NC", 270, 289],
      ["ND", 580, 588],
      ["NE", 680, 693],
      ["NH", 30, 38],
      ["NJ", 70, 89],
      ["NM", 870, 884],
      ["NV", 889, 898],
      ["NY", 100, 149],
      ["OH", 430, 459],
      ["OK", 730, 749],
      ["OR", 970, 979],
      ["PA", 150, 196],
      ["RI", 28, 29],
      ["SC", 290, 299],
      ["SD", 570, 577],
      ["TN", 370, 385],
      ["TX", 750, 799],
      ["TX", 885, 885],
      ["UT", 840, 847],
      ["VA", 201, 246],
      ["VT", 50, 59],
      ["WA", 980, 994],
      ["WI", 530, 549],
      ["WV", 247, 268],
      ["WY", 820, 831]
    ];

    const normalize = (s) =>
      String(s || "")
        .toLowerCase()
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\u00a0/g, " ")
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanZip = (v) => String(v || "").replace(/\D/g, "").slice(0, 5);
    const isValidZip = (v) => /^\d{5}$/.test(v);

    const showErr = (on, msg) => {
      err.textContent = msg || "Enter a valid 5-digit ZIP.";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    function clearOldCaches() {
      try {
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    }

    function getStateFromZip(zip) {
      const prefix = Number(zip.slice(0, 3));
      for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
        const [state, min, max] = ZIP_STATE_RANGES[i];
        if (prefix >= min && prefix <= max) return state;
      }
      return "";
    }

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;
        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    async function fetchFreshProductionData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const text = normalize(doc.body ? doc.body.textContent : html);

      const regularMatch = text.match(
        /ez fit sheds[\s\S]{0,1800}?standard production lead time[\s\S]{0,400}?is\s+(\d+)\s+business days/
      );

      const quickshipMatch = text.match(
        /ez fit sheds[\s\S]{0,3000}?quick\s*ship sheds and greenhouses[\s\S]{0,500}?(\d+)\s+business days/
      );

      if (!regularMatch || !quickshipMatch) {
        throw new Error("Could not parse EZ-Fit production lead times");
      }

      const data = {
        regular: {
          productionMinBd: Number(regularMatch[1]),
          productionMaxBd: Number(regularMatch[1])
        },
        quickship: {
          productionMinBd: Number(quickshipMatch[1]),
          productionMaxBd: Number(quickshipMatch[1])
        }
      };

      writeCache(data);
      return data;
    }

    async function getProductionData() {
      clearOldCaches();

      const cached = readCache();
      if (cached) return cached;

      return fetchFreshProductionData();
    }

    function getCurrentProductHandleFromUrl() {
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).trim() : "";
    }

    function getCurrentProductTitleFromPage() {
      const selectors = [
        "h1.productView-title",
        ".productView-title",
        "h1.product-single__title",
        ".product-single__title",
        "main h1",
        "h1"
      ];

      for (let i = 0; i < selectors.length; i += 1) {
        const el = document.querySelector(selectors[i]);
        if (el && el.textContent && el.textContent.trim()) {
          return el.textContent.trim();
        }
      }

      return document.title || "";
    }

    function detectDefaultProductKey() {
      const currentHandle = getCurrentProductHandleFromUrl();
      const currentTitle = getCurrentProductTitleFromPage();

      const handleNorm = normalize(currentHandle);
      const titleNorm = normalize(currentTitle);
      const combined = `${handleNorm} ${titleNorm}`;

      const hasSize = (a, b) => {
        return (
          combined.includes(`${a}x${b}`) ||
          combined.includes(`${a} x ${b}`)
        );
      };

      const hasAny = (phrases) => phrases.some((phrase) => combined.includes(phrase));

      if (
        handleNorm === "ez fit portable 3x4 chicken coop kit" ||
        handleNorm === "ez fit sheds chicken coop 3 x 4 diy kit"
      ) {
        return "chicken_coop_3x4";
      }

      if (
        handleNorm === "ez fit 4x6 portable chicken coop kit" ||
        handleNorm === "ez fit chicken coop run 4 x 6 diy chicken pen kit"
      ) {
        return "chicken_coop_4x6";
      }

      if (
        handleNorm === "ez fit 5x8 portable chicken coop kit" ||
        handleNorm === "ez fit chicken coop run 5 x 8 diy chicken pen kit"
      ) {
        return "chicken_coop_5x8";
      }

      if (hasSize(3, 4) && hasAny(["chicken coop", "chicken pen", "coop"])) {
        return "chicken_coop_3x4";
      }

      if (hasSize(4, 6) && hasAny(["chicken coop", "chicken pen", "coop"])) {
        return "chicken_coop_4x6";
      }

      if (hasSize(5, 8) && hasAny(["chicken coop", "chicken pen", "coop"])) {
        return "chicken_coop_5x8";
      }

      if (hasSize(4, 7) && hasAny(["dog kennel", "kennel"])) {
        return "dog_kennel_4x7";
      }

      if (hasSize(5, 8) && hasAny(["dog kennel", "kennel"])) {
        return "dog_kennel_5x8";
      }

      if (hasSize(7, 6) && hasAny(["playhouse"])) {
        return "playhouse_7x6";
      }

      if (combined.includes("riverside") && combined.includes("quick ship")) {
        return "riverside_quickship";
      }
      if (combined.includes("homestead") && combined.includes("quick ship")) {
        return "homestead_quickship";
      }
      if (combined.includes("heritage") && combined.includes("quick ship")) {
        return "heritage_quickship";
      }
      if (combined.includes("greenhouse") && combined.includes("quick ship")) {
        return "greenhouse_quickship";
      }

      if (combined.includes("riverside")) {
        return "riverside";
      }
      if (combined.includes("homestead")) {
        return "homestead";
      }
      if (combined.includes("heritage")) {
        return "heritage";
      }
      if (combined.includes("skyview")) {
        return "skyview";
      }
      if (combined.includes("woodsman")) {
        return "woodsman";
      }
      if (combined.includes("craftsman")) {
        return "craftsman";
      }
      if (combined.includes("greenhouse")) {
        return "greenhouse";
      }

      return "";
    }

    function renderTable(
      productTitle,
      modeLabel,
      destinationStateName,
      prodMin,
      prodMax,
      transitMin,
      transitMax
    ) {
      const today = new Date();

      const earliestBD = (prodMin || 0) + (transitMin || 0);
      const latestBD = (prodMax || 0) + (transitMax || 0);

      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const prodText =
        prodMin === prodMax
          ? `${prodMin} business days`
          : `${prodMin} to ${prodMax} business days`;

      const transitText =
        transitMin === transitMax
          ? `${transitMin} business days`
          : `${transitMin} to ${transitMax} business days`;

      const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      out.innerHTML = `
        <table aria-label="Delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Lead-time type</th><td>${modeLabel}</td></tr>
            <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
            <tr><th>Production lead time</th><td>${prodText}</td></tr>
            <tr><th>Transit time</th><td>${transitText}</td></tr>
            <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Holidays and carrier delays can shift delivery.
        </p>
      `;
    }

    const detectedDefaultProduct = detectDefaultProductKey();

    if (detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]) {
      productEl.value = detectedDefaultProduct;
    }

    btn.addEventListener("click", async () => {
      const zip = cleanZip(zipEl.value);
      const selectedKey = productEl.value;

      zipEl.value = zip;

      if (!isValidZip(zip)) {
        out.innerHTML = "";
        showErr(true, "Enter a valid 5-digit ZIP.");
        return;
      }

      if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
        out.innerHTML = "";
        showErr(true, "Please choose the exact EZ-Fit product.");
        return;
      }

      const destinationState = getStateFromZip(zip);

      if (!destinationState) {
        out.innerHTML = "";
        showErr(true, "Could not match that ZIP code to a supported U.S. state.");
        return;
      }

      const transit = STATE_TRANSIT[destinationState];

      if (!transit || transit.blocked) {
        out.innerHTML = "";
        showErr(true, "We do not currently ship EZ-Fit products to Alaska or Hawaii.");
        return;
      }

      showErr(false);

      try {
        const production = await getProductionData();
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod = production[selectedProduct.mode];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load EZ-Fit production lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          selectedProduct.mode === "quickship" ? "Quick-Ship" : "Regular",
          STATE_NAMES[destinationState] || destinationState,
          prod.productionMinBd,
          prod.productionMaxBd,
          transit.min,
          transit.max
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "hsr_delivery_estimate_ezfit_state_transit",
          zip,
          destination_state: destinationState,
          selected_product_key: selectedKey,
          selected_product_label: selectedProduct.label,
          ezfit_mode: selectedProduct.mode
        });
      } catch (e) {
        out.innerHTML = "";
        showErr(true, "Could not load live EZ-Fit production lead time data. Try again.");
      }
    });

    clr.addEventListener("click", () => {
      zipEl.value = "";
      productEl.value =
        detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]
          ? detectedDefaultProduct
          : "";
      out.innerHTML = "";
      showErr(false);
    });

    window.hsrEzFitClearProductionCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    };

    window.hsrEzFitReadProductionCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ezfit-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-ezfit");
    if (!root) return;

    const zipEl = document.getElementById("hsrZip-ezfit");
    const productEl = document.getElementById("hsrProduct-ezfit");
    const btn = document.getElementById("hsrGo-ezfit");
    const clr = document.getElementById("hsrClear-ezfit");
    const err = document.getElementById("hsrErr-ezfit");
    const out = document.getElementById("hsrOut-ezfit");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_ezfit_production_live_v8_20260909";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
    const OLD_CACHE_KEYS = [
      "hsr_ezfit_production_live_v7_20260311",
      "hsr_ezfit_production_live_v6_20260311",
      "hsr_ezfit_production_live_v5_20260311",
      "hsr_ezfit_live_leadtime_v1",
      "hsr_ezfit_live_leadtime_v2",
      "hsr_ezfit_live_leadtime_v3",
      "hsr_ezfit_live_leadtime_v4_20260311_refresh",
      "hsr_leadtime_cache_v1",
      "hsr_leadtime_cache_ezfit_v1"
    ];

    const PRODUCT_MAP = {
      riverside: { label: "EZ-Fit Riverside Shed Kit", mode: "regular" },
      homestead: { label: "EZ-Fit Homestead Shed Kit", mode: "regular" },
      heritage: { label: "EZ-Fit Heritage Shed Kit", mode: "regular" },
      greenhouse: { label: "EZ-Fit Greenhouse Shed Kit", mode: "regular" },
      skyview: { label: "EZ-Fit Skyview Shed Kit", mode: "regular" },
      woodsman: { label: "EZ-Fit Woodsman Shed Kit", mode: "regular" },
      craftsman: { label: "EZ-Fit Craftsman Storage Shed Kit", mode: "regular" },
      dog_kennel_4x7: { label: "EZ-Fit 4x7 Dog Kennel Kit with Run", mode: "regular" },
      dog_kennel_5x8: { label: "EZ-Fit 5x8 Dog Kennel Kit with Run", mode: "regular" },
      chicken_coop_5x8: { label: "EZ-Fit 5x8 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_4x6: { label: "EZ-Fit 4x6 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_3x4: { label: "EZ-Fit Portable 3x4 Chicken Coop Kit", mode: "regular" },
      playhouse_7x6: { label: "EZ-Fit 7x6 Playhouse Kit", mode: "regular" },
      riverside_quickship: { label: "EZ-Fit Riverside Shed Kit - QUICK-SHIP", mode: "quickship" },
      homestead_quickship: { label: "EZ-Fit Homestead Shed Kit - QUICK-SHIP", mode: "quickship" },
      heritage_quickship: { label: "EZ-Fit Heritage Shed Kit - QUICK-SHIP", mode: "quickship" },
      greenhouse_quickship: { label: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP", mode: "quickship" }
    };

    const STATE_TRANSIT = {
      OH: { min: 1, max: 2 },

      IN: { min: 2, max: 3 },
      MI: { min: 2, max: 3 },
      PA: { min: 2, max: 3 },
      WV: { min: 2, max: 3 },
      KY: { min: 2, max: 3 },

      IL: { min: 3, max: 4 },
      WI: { min: 3, max: 4 },
      NY: { min: 3, max: 4 },
      VA: { min: 3, max: 4 },
      MD: { min: 3, max: 4 },
      DE: { min: 3, max: 4 },
      NJ: { min: 3, max: 4 },
      TN: { min: 3, max: 4 },
      NC: { min: 3, max: 4 },
      DC: { min: 3, max: 4 },

      AL: { min: 4, max: 5 },
      AR: { min: 4, max: 5 },
      CT: { min: 4, max: 5 },
      GA: { min: 4, max: 5 },
      IA: { min: 4, max: 5 },
      LA: { min: 4, max: 5 },
      MA: { min: 4, max: 5 },
      MS: { min: 4, max: 5 },
      MO: { min: 4, max: 5 },
      NH: { min: 4, max: 5 },
      RI: { min: 4, max: 5 },
      SC: { min: 4, max: 5 },
      VT: { min: 4, max: 5 },

      FL: { min: 5, max: 6 },
      KS: { min: 5, max: 6 },
      ME: { min: 5, max: 6 },
      MN: { min: 5, max: 6 },
      NE: { min: 5, max: 6 },
      OK: { min: 5, max: 6 },
      SD: { min: 5, max: 6 },

      CO: { min: 6, max: 7 },
      ND: { min: 6, max: 7 },
      NM: { min: 6, max: 7 },
      TX: { min: 6, max: 7 },
      WY: { min: 6, max: 7 },

      AZ: { min: 7, max: 8 },
      ID: { min: 7, max: 8 },
      MT: { min: 7, max: 8 },
      NV: { min: 7, max: 8 },
      UT: { min: 7, max: 8 },

      CA: { min: 7, max: 9 },
      OR: { min: 7, max: 9 },
      WA: { min: 7, max: 9 },

      AK: { min: null, max: null, blocked: true },
      HI: { min: null, max: null, blocked: true }
    };

    const STATE_NAMES = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "Washington DC",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming"
    };

    const ZIP_STATE_RANGES = [
      ["AK", 995, 999],
      ["AL", 350, 369],
      ["AR", 716, 729],
      ["AZ", 850, 865],
      ["CA", 900, 961],
      ["CO", 800, 816],
      ["CT", 60, 69],
      ["DC", 200, 205],
      ["DE", 197, 199],
      ["FL", 320, 349],
      ["GA", 300, 319],
      ["HI", 967, 968],
      ["IA", 500, 528],
      ["ID", 832, 838],
      ["IL", 600, 629],
      ["IN", 460, 479],
      ["KS", 660, 679],
      ["KY", 400, 427],
      ["LA", 700, 714],
      ["MA", 10, 27],
      ["MD", 206, 219],
      ["ME", 39, 49],
      ["MI", 480, 499],
      ["MN", 550, 567],
      ["MO", 630, 658],
      ["MS", 386, 397],
      ["MT", 590, 599],
      ["NC", 270, 289],
      ["ND", 580, 588],
      ["NE", 680, 693],
      ["NH", 30, 38],
      ["NJ", 70, 89],
      ["NM", 870, 884],
      ["NV", 889, 898],
      ["NY", 100, 149],
      ["OH", 430, 459],
      ["OK", 730, 749],
      ["OR", 970, 979],
      ["PA", 150, 196],
      ["RI", 28, 29],
      ["SC", 290, 299],
      ["SD", 570, 577],
      ["TN", 370, 385],
      ["TX", 750, 799],
      ["TX", 885, 885],
      ["UT", 840, 847],
      ["VA", 201, 246],
      ["VT", 50, 59],
      ["WA", 980, 994],
      ["WI", 530, 549],
      ["WV", 247, 268],
      ["WY", 820, 831]
    ];

    const normalize = (s) =>
      String(s || "")
        .toLowerCase()
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\u00a0/g, " ")
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanZip = (v) => String(v || "").replace(/\D/g, "").slice(0, 5);
    const isValidZip = (v) => /^\d{5}$/.test(v);

    const showErr = (on, msg) => {
      err.textContent = msg || "Enter a valid 5-digit ZIP.";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    function clearOldCaches() {
      try {
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    }

    function getStateFromZip(zip) {
      const prefix = Number(zip.slice(0, 3));
      for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
        const [state, min, max] = ZIP_STATE_RANGES[i];
        if (prefix >= min && prefix <= max) return state;
      }
      return "";
    }

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;
        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    async function fetchFreshProductionData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const text = normalize(doc.body ? doc.body.textContent : html);

      const regularMatch = text.match(
        /ez fit sheds[\s\S]{0,1800}?standard production lead time[\s\S]{0,400}?is\s+(\d+)\s+business days/
      );

      const quickshipMatch = text.match(
        /ez fit sheds[\s\S]{0,3000}?quick\s*ship sheds and greenhouses[\s\S]{0,500}?(\d+)\s+business days/
      );

      if (!regularMatch || !quickshipMatch) {
        throw new Error("Could not parse EZ-Fit production lead times");
      }

      const data = {
        regular: {
          productionMinBd: Number(regularMatch[1]),
          productionMaxBd: Number(regularMatch[1])
        },
        quickship: {
          productionMinBd: Number(quickshipMatch[1]),
          productionMaxBd: Number(quickshipMatch[1])
        }
      };

      writeCache(data);
      return data;
    }

    async function getProductionData() {
      clearOldCaches();

      const cached = readCache();
      if (cached) return cached;

      return fetchFreshProductionData();
    }

    function getCurrentProductHandleFromUrl() {
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).trim() : "";
    }

    function getCurrentProductTitleFromPage() {
      const selectors = [
        "h1.productView-title",
        ".productView-title",
        "h1.product-single__title",
        ".product-single__title",
        "main h1",
        "h1"
      ];

      for (let i = 0; i < selectors.length; i += 1) {
        const el = document.querySelector(selectors[i]);
        if (el && el.textContent && el.textContent.trim()) {
          return el.textContent.trim();
        }
      }

      return document.title || "";
    }

    function detectDefaultProductKey() {
      const currentHandle = getCurrentProductHandleFromUrl();
      const currentTitle = getCurrentProductTitleFromPage();

      const handleNorm = normalize(currentHandle);
      const titleNorm = normalize(currentTitle);
      const combined = `${handleNorm} ${titleNorm}`;

      const exactHandleMap = {
        "ez fit riverside shed kit": "riverside",
        "ez fit homestead shed kit": "homestead",
        "ez fit heritage shed kit": "heritage",
        "ez fit greenhouse shed kit": "greenhouse",
        "ez fit skyview shed kit": "skyview",
        "ez fit woodsman shed kit": "woodsman",
        "ez fit craftsman storage shed kit": "craftsman",
        "ez fit 4x7 dog kennel kit with run": "dog_kennel_4x7",
        "ez fit 5x8 dog kennel kit with run": "dog_kennel_5x8",
        "ez fit 5x8 portable chicken coop kit": "chicken_coop_5x8",
        "ez fit 4x6 portable chicken coop kit": "chicken_coop_4x6",
        "ez fit portable 3x4 chicken coop kit": "chicken_coop_3x4",
        "ez fit 7x6 playhouse kit": "playhouse_7x6",
        "ez fit riverside shed kit quick ship": "riverside_quickship",
        "ez fit homestead shed kit quick ship": "homestead_quickship",
        "ez fit heritage shed kit quick ship": "heritage_quickship",
        "ez fit greenhouse shed kit quick ship": "greenhouse_quickship"
      };

      if (exactHandleMap[handleNorm]) {
        return exactHandleMap[handleNorm];
      }

      if (combined.includes("3x4 chicken coop") || combined.includes("portable 3x4 chicken coop")) {
        return "chicken_coop_3x4";
      }
      if (combined.includes("4x6 chicken coop") || combined.includes("portable 4x6 chicken coop")) {
        return "chicken_coop_4x6";
      }
      if (combined.includes("5x8 chicken coop") || combined.includes("portable 5x8 chicken coop")) {
        return "chicken_coop_5x8";
      }
      if (combined.includes("4x7 dog kennel")) {
        return "dog_kennel_4x7";
      }
      if (combined.includes("5x8 dog kennel")) {
        return "dog_kennel_5x8";
      }
      if (combined.includes("7x6 playhouse")) {
        return "playhouse_7x6";
      }
      if (combined.includes("riverside") && combined.includes("quick ship")) {
        return "riverside_quickship";
      }
      if (combined.includes("homestead") && combined.includes("quick ship")) {
        return "homestead_quickship";
      }
      if (combined.includes("heritage") && combined.includes("quick ship")) {
        return "heritage_quickship";
      }
      if (combined.includes("greenhouse") && combined.includes("quick ship")) {
        return "greenhouse_quickship";
      }
      if (combined.includes("riverside")) {
        return "riverside";
      }
      if (combined.includes("homestead")) {
        return "homestead";
      }
      if (combined.includes("heritage")) {
        return "heritage";
      }
      if (combined.includes("skyview")) {
        return "skyview";
      }
      if (combined.includes("woodsman")) {
        return "woodsman";
      }
      if (combined.includes("craftsman")) {
        return "craftsman";
      }
      if (combined.includes("greenhouse")) {
        return "greenhouse";
      }

      return "";
    }

    function renderTable(
      productTitle,
      modeLabel,
      destinationStateName,
      prodMin,
      prodMax,
      transitMin,
      transitMax
    ) {
      const today = new Date();

      const earliestBD = (prodMin || 0) + (transitMin || 0);
      const latestBD = (prodMax || 0) + (transitMax || 0);

      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const prodText =
        prodMin === prodMax
          ? `${prodMin} business days`
          : `${prodMin} to ${prodMax} business days`;

      const transitText =
        transitMin === transitMax
          ? `${transitMin} business days`
          : `${transitMin} to ${transitMax} business days`;

      const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      out.innerHTML = `
        <table aria-label="Delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Lead-time type</th><td>${modeLabel}</td></tr>
            <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
            <tr><th>Production lead time</th><td>${prodText}</td></tr>
            <tr><th>Transit time</th><td>${transitText}</td></tr>
            <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Holidays and carrier delays can shift delivery.
        </p>
      `;
    }

    const detectedDefaultProduct = detectDefaultProductKey();

    if (detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]) {
      productEl.value = detectedDefaultProduct;
    }

    btn.addEventListener("click", async () => {
      const zip = cleanZip(zipEl.value);
      const selectedKey = productEl.value;

      zipEl.value = zip;

      if (!isValidZip(zip)) {
        out.innerHTML = "";
        showErr(true, "Enter a valid 5-digit ZIP.");
        return;
      }

      if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
        out.innerHTML = "";
        showErr(true, "Please choose the exact EZ-Fit product.");
        return;
      }

      const destinationState = getStateFromZip(zip);

      if (!destinationState) {
        out.innerHTML = "";
        showErr(true, "Could not match that ZIP code to a supported U.S. state.");
        return;
      }

      const transit = STATE_TRANSIT[destinationState];

      if (!transit || transit.blocked) {
        out.innerHTML = "";
        showErr(true, "We do not currently ship EZ-Fit products to Alaska or Hawaii.");
        return;
      }

      showErr(false);

      try {
        const production = await getProductionData();
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod = production[selectedProduct.mode];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load EZ-Fit production lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          selectedProduct.mode === "quickship" ? "Quick-Ship" : "Regular",
          STATE_NAMES[destinationState] || destinationState,
          prod.productionMinBd,
          prod.productionMaxBd,
          transit.min,
          transit.max
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "hsr_delivery_estimate_ezfit_state_transit",
          zip,
          destination_state: destinationState,
          selected_product_key: selectedKey,
          selected_product_label: selectedProduct.label,
          ezfit_mode: selectedProduct.mode
        });
      } catch (e) {
        out.innerHTML = "";
        showErr(true, "Could not load live EZ-Fit production lead time data. Try again.");
      }
    });

    clr.addEventListener("click", () => {
      zipEl.value = "";
      productEl.value = detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct] ? detectedDefaultProduct : "";
      out.innerHTML = "";
      showErr(false);
    });

    window.hsrEzFitClearProductionCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    };

    window.hsrEzFitReadProductionCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ezfit-wide-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-{{ product.id }}");
    if (!root) return;

    const zipEl = document.getElementById("hsrZip-{{ product.id }}");
    const productEl = document.getElementById("hsrProduct-{{ product.id }}");
    const btn = document.getElementById("hsrGo-{{ product.id }}");
    const clr = document.getElementById("hsrClear-{{ product.id }}");
    const err = document.getElementById("hsrErr-{{ product.id }}");
    const out = document.getElementById("hsrOut-{{ product.id }}");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_ezfit_production_live_v8_20260909";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
    const OLD_CACHE_KEYS = [
      "hsr_ezfit_production_live_v7_20260311",
      "hsr_ezfit_production_live_v6_20260311",
      "hsr_ezfit_production_live_v5_20260311",
      "hsr_ezfit_live_leadtime_v1",
      "hsr_ezfit_live_leadtime_v2",
      "hsr_ezfit_live_leadtime_v3",
      "hsr_ezfit_live_leadtime_v4_20260311_refresh",
      "hsr_leadtime_cache_v1",
      "hsr_leadtime_cache_ezfit_v1"
    ];

    const PRODUCT_MAP = {
      riverside: { label: "EZ-Fit Riverside Shed Kit", mode: "regular" },
      homestead: { label: "EZ-Fit Homestead Shed Kit", mode: "regular" },
      heritage: { label: "EZ-Fit Heritage Shed Kit", mode: "regular" },
      greenhouse: { label: "EZ-Fit Greenhouse Shed Kit", mode: "regular" },
      skyview: { label: "EZ-Fit Skyview Shed Kit", mode: "regular" },
      woodsman: { label: "EZ-Fit Woodsman Shed Kit", mode: "regular" },
      craftsman: { label: "EZ-Fit Craftsman Storage Shed Kit", mode: "regular" },
      dog_kennel_4x7: { label: "EZ-Fit 4x7 Dog Kennel Kit with Run", mode: "regular" },
      dog_kennel_5x8: { label: "EZ-Fit 5x8 Dog Kennel Kit with Run", mode: "regular" },
      chicken_coop_5x8: { label: "EZ-Fit 5x8 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_4x6: { label: "EZ-Fit 4x6 Portable Chicken Coop Kit", mode: "regular" },
      chicken_coop_3x4: { label: "EZ-Fit Portable 3x4 Chicken Coop Kit", mode: "regular" },
      playhouse_7x6: { label: "EZ-Fit 7x6 Playhouse Kit", mode: "regular" },
      riverside_quickship: { label: "EZ-Fit Riverside Shed Kit - QUICK-SHIP", mode: "quickship" },
      homestead_quickship: { label: "EZ-Fit Homestead Shed Kit - QUICK-SHIP", mode: "quickship" },
      heritage_quickship: { label: "EZ-Fit Heritage Shed Kit - QUICK-SHIP", mode: "quickship" },
      greenhouse_quickship: { label: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP", mode: "quickship" }
    };

    const STATE_TRANSIT = {
      OH: { min: 1, max: 2 },

      IN: { min: 2, max: 3 },
      MI: { min: 2, max: 3 },
      PA: { min: 2, max: 3 },
      WV: { min: 2, max: 3 },
      KY: { min: 2, max: 3 },

      IL: { min: 3, max: 4 },
      WI: { min: 3, max: 4 },
      NY: { min: 3, max: 4 },
      VA: { min: 3, max: 4 },
      MD: { min: 3, max: 4 },
      DE: { min: 3, max: 4 },
      NJ: { min: 3, max: 4 },
      TN: { min: 3, max: 4 },
      NC: { min: 3, max: 4 },
      DC: { min: 3, max: 4 },

      AL: { min: 4, max: 5 },
      AR: { min: 4, max: 5 },
      CT: { min: 4, max: 5 },
      GA: { min: 4, max: 5 },
      IA: { min: 4, max: 5 },
      LA: { min: 4, max: 5 },
      MA: { min: 4, max: 5 },
      MS: { min: 4, max: 5 },
      MO: { min: 4, max: 5 },
      NH: { min: 4, max: 5 },
      RI: { min: 4, max: 5 },
      SC: { min: 4, max: 5 },
      VT: { min: 4, max: 5 },

      FL: { min: 5, max: 6 },
      KS: { min: 5, max: 6 },
      ME: { min: 5, max: 6 },
      MN: { min: 5, max: 6 },
      NE: { min: 5, max: 6 },
      OK: { min: 5, max: 6 },
      SD: { min: 5, max: 6 },

      CO: { min: 6, max: 7 },
      ND: { min: 6, max: 7 },
      NM: { min: 6, max: 7 },
      TX: { min: 6, max: 7 },
      WY: { min: 6, max: 7 },

      AZ: { min: 7, max: 8 },
      ID: { min: 7, max: 8 },
      MT: { min: 7, max: 8 },
      NV: { min: 7, max: 8 },
      UT: { min: 7, max: 8 },

      CA: { min: 7, max: 9 },
      OR: { min: 7, max: 9 },
      WA: { min: 7, max: 9 },

      AK: { min: null, max: null, blocked: true },
      HI: { min: null, max: null, blocked: true }
    };

    const STATE_NAMES = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "Washington DC",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming"
    };

    const ZIP_STATE_RANGES = [
      ["AK", 995, 999],
      ["AL", 350, 369],
      ["AR", 716, 729],
      ["AZ", 850, 865],
      ["CA", 900, 961],
      ["CO", 800, 816],
      ["CT", 60, 69],
      ["DC", 200, 205],
      ["DE", 197, 199],
      ["FL", 320, 349],
      ["GA", 300, 319],
      ["HI", 967, 968],
      ["IA", 500, 528],
      ["ID", 832, 838],
      ["IL", 600, 629],
      ["IN", 460, 479],
      ["KS", 660, 679],
      ["KY", 400, 427],
      ["LA", 700, 714],
      ["MA", 10, 27],
      ["MD", 206, 219],
      ["ME", 39, 49],
      ["MI", 480, 499],
      ["MN", 550, 567],
      ["MO", 630, 658],
      ["MS", 386, 397],
      ["MT", 590, 599],
      ["NC", 270, 289],
      ["ND", 580, 588],
      ["NE", 680, 693],
      ["NH", 30, 38],
      ["NJ", 70, 89],
      ["NM", 870, 884],
      ["NV", 889, 898],
      ["NY", 100, 149],
      ["OH", 430, 459],
      ["OK", 730, 749],
      ["OR", 970, 979],
      ["PA", 150, 196],
      ["RI", 28, 29],
      ["SC", 290, 299],
      ["SD", 570, 577],
      ["TN", 370, 385],
      ["TX", 750, 799],
      ["TX", 885, 885],
      ["UT", 840, 847],
      ["VA", 201, 246],
      ["VT", 50, 59],
      ["WA", 980, 994],
      ["WI", 530, 549],
      ["WV", 247, 268],
      ["WY", 820, 831]
    ];

    const normalize = (s) =>
      String(s || "")
        .toLowerCase()
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\u00a0/g, " ")
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanZip = (v) => String(v || "").replace(/\D/g, "").slice(0, 5);
    const isValidZip = (v) => /^\d{5}$/.test(v);

    const showErr = (on, msg) => {
      err.textContent = msg || "Enter a valid 5-digit ZIP.";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    function clearOldCaches() {
      try {
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    }

    function getStateFromZip(zip) {
      const prefix = Number(zip.slice(0, 3));
      for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
        const [state, min, max] = ZIP_STATE_RANGES[i];
        if (prefix >= min && prefix <= max) return state;
      }
      return "";
    }

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;
        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    async function fetchFreshProductionData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const text = normalize(doc.body ? doc.body.textContent : html);

      const regularMatch = text.match(
        /ez fit sheds[\s\S]{0,1800}?standard production lead time[\s\S]{0,400}?is\s+(\d+)\s+business days/
      );

      const quickshipMatch = text.match(
        /ez fit sheds[\s\S]{0,3000}?quick\s*ship sheds and greenhouses[\s\S]{0,500}?(\d+)\s+business days/
      );

      if (!regularMatch || !quickshipMatch) {
        throw new Error("Could not parse EZ-Fit production lead times");
      }

      const data = {
        regular: {
          productionMinBd: Number(regularMatch[1]),
          productionMaxBd: Number(regularMatch[1])
        },
        quickship: {
          productionMinBd: Number(quickshipMatch[1]),
          productionMaxBd: Number(quickshipMatch[1])
        }
      };

      writeCache(data);
      return data;
    }

    async function getProductionData() {
      clearOldCaches();

      const cached = readCache();
      if (cached) return cached;

      return fetchFreshProductionData();
    }

    function renderTable(
      productTitle,
      modeLabel,
      destinationStateName,
      prodMin,
      prodMax,
      transitMin,
      transitMax
    ) {
      const today = new Date();

      const earliestBD = (prodMin || 0) + (transitMin || 0);
      const latestBD = (prodMax || 0) + (transitMax || 0);

      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const prodText =
        prodMin === prodMax
          ? `${prodMin} business days`
          : `${prodMin} to ${prodMax} business days`;

      const transitText =
        transitMin === transitMax
          ? `${transitMin} business days`
          : `${transitMin} to ${transitMax} business days`;

      const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      out.innerHTML = `
        <table aria-label="Delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Lead-time type</th><td>${modeLabel}</td></tr>
            <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
            <tr><th>Production lead time</th><td>${prodText}</td></tr>
            <tr><th>Transit time</th><td>${transitText}</td></tr>
            <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Holidays and carrier delays can shift delivery.
        </p>
      `;
    }

    btn.addEventListener("click", async () => {
      const zip = cleanZip(zipEl.value);
      const selectedKey = productEl.value;

      zipEl.value = zip;

      if (!isValidZip(zip)) {
        out.innerHTML = "";
        showErr(true, "Enter a valid 5-digit ZIP.");
        return;
      }

      if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
        out.innerHTML = "";
        showErr(true, "Please choose the exact EZ-Fit product.");
        return;
      }

      const destinationState = getStateFromZip(zip);

      if (!destinationState) {
        out.innerHTML = "";
        showErr(true, "Could not match that ZIP code to a supported U.S. state.");
        return;
      }

      const transit = STATE_TRANSIT[destinationState];

      if (!transit || transit.blocked) {
        out.innerHTML = "";
        showErr(true, "We do not currently ship EZ-Fit products to Alaska or Hawaii.");
        return;
      }

      showErr(false);

      try {
        const production = await getProductionData();
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod = production[selectedProduct.mode];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load EZ-Fit production lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          selectedProduct.mode === "quickship" ? "Quick-Ship" : "Regular",
          STATE_NAMES[destinationState] || destinationState,
          prod.productionMinBd,
          prod.productionMaxBd,
          transit.min,
          transit.max
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "hsr_delivery_estimate_ezfit_state_transit",
          zip,
          destination_state: destinationState,
          selected_product_key: selectedKey,
          selected_product_label: selectedProduct.label,
          ezfit_mode: selectedProduct.mode
        });
      } catch (e) {
        out.innerHTML = "";
        showErr(true, "Could not load live EZ-Fit production lead time data. Try again.");
      }
    });

    clr.addEventListener("click", () => {
      zipEl.value = "";
      productEl.value = "";
      out.innerHTML = "";
      showErr(false);
    });

    window.hsrEzFitClearProductionCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
        OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
      } catch (e) {}
    };

    window.hsrEzFitReadProductionCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ezfit-woodsman-quick-ship-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
      const root = document.getElementById("hsr-delivery-ezfit");
      if (!root) return;

      const zipEl = document.getElementById("hsrZip-ezfit");
      const productEl = document.getElementById("hsrProduct-ezfit");
      const btn = document.getElementById("hsrGo-ezfit");
      const clr = document.getElementById("hsrClear-ezfit");
      const err = document.getElementById("hsrErr-ezfit");
      const out = document.getElementById("hsrOut-ezfit");

      const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
      const CACHE_KEY = "hsr_ezfit_production_live_v7_20260311";
      const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
      const OLD_CACHE_KEYS = [
        "hsr_ezfit_production_live_v6_20260311",
        "hsr_ezfit_production_live_v5_20260311",
        "hsr_ezfit_live_leadtime_v1",
        "hsr_ezfit_live_leadtime_v2",
        "hsr_ezfit_live_leadtime_v3",
        "hsr_ezfit_live_leadtime_v4_20260311_refresh",
        "hsr_leadtime_cache_v1",
        "hsr_leadtime_cache_ezfit_v1"
      ];

      const PRODUCT_MAP = {
        riverside: { label: "EZ-Fit Riverside Shed Kit", mode: "regular" },
        homestead: { label: "EZ-Fit Homestead Shed Kit", mode: "regular" },
        heritage: { label: "EZ-Fit Heritage Shed Kit", mode: "regular" },
        greenhouse: { label: "EZ-Fit Greenhouse Shed Kit", mode: "regular" },
        skyview: { label: "EZ-Fit Skyview Shed Kit", mode: "regular" },
        woodsman: { label: "EZ-Fit Woodsman Shed Kit", mode: "regular" },
        craftsman: { label: "EZ-Fit Craftsman Storage Shed Kit", mode: "regular" },
        dog_kennel_4x7: { label: "EZ-Fit 4x7 Dog Kennel Kit with Run", mode: "regular" },
        dog_kennel_5x8: { label: "EZ-Fit 5x8 Dog Kennel Kit with Run", mode: "regular" },
        chicken_coop_5x8: { label: "EZ-Fit 5x8 Portable Chicken Coop Kit", mode: "regular" },
        chicken_coop_4x6: { label: "EZ-Fit 4x6 Portable Chicken Coop Kit", mode: "regular" },
        chicken_coop_3x4: { label: "EZ-Fit Portable 3x4 Chicken Coop Kit", mode: "regular" },
        playhouse_7x6: { label: "EZ-Fit 7x6 Playhouse Kit", mode: "regular" },
        riverside_quickship: { label: "EZ-Fit Riverside Shed Kit - QUICK-SHIP", mode: "quickship" },
        homestead_quickship: { label: "EZ-Fit Homestead Shed Kit - QUICK-SHIP", mode: "quickship" },
        heritage_quickship: { label: "EZ-Fit Heritage Shed Kit - QUICK-SHIP", mode: "quickship" },
        greenhouse_quickship: { label: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP", mode: "quickship" },
        woodsman_quickship: { label: "EZ-Fit Woodsman Shed Kit - QUICK-SHIP", mode: "quickship" }
      };

      const STATE_TRANSIT = {
        OH: { min: 1, max: 2 },
        IN: { min: 2, max: 3 },
        MI: { min: 2, max: 3 },
        PA: { min: 2, max: 3 },
        WV: { min: 2, max: 3 },
        KY: { min: 2, max: 3 },
        IL: { min: 3, max: 4 },
        WI: { min: 3, max: 4 },
        NY: { min: 3, max: 4 },
        VA: { min: 3, max: 4 },
        MD: { min: 3, max: 4 },
        DE: { min: 3, max: 4 },
        NJ: { min: 3, max: 4 },
        TN: { min: 3, max: 4 },
        NC: { min: 3, max: 4 },
        DC: { min: 3, max: 4 },
        AL: { min: 4, max: 5 },
        AR: { min: 4, max: 5 },
        CT: { min: 4, max: 5 },
        GA: { min: 4, max: 5 },
        IA: { min: 4, max: 5 },
        LA: { min: 4, max: 5 },
        MA: { min: 4, max: 5 },
        MS: { min: 4, max: 5 },
        MO: { min: 4, max: 5 },
        NH: { min: 4, max: 5 },
        RI: { min: 4, max: 5 },
        SC: { min: 4, max: 5 },
        VT: { min: 4, max: 5 },
        FL: { min: 5, max: 6 },
        KS: { min: 5, max: 6 },
        ME: { min: 5, max: 6 },
        MN: { min: 5, max: 6 },
        NE: { min: 5, max: 6 },
        OK: { min: 5, max: 6 },
        SD: { min: 5, max: 6 },
        CO: { min: 6, max: 7 },
        ND: { min: 6, max: 7 },
        NM: { min: 6, max: 7 },
        TX: { min: 6, max: 7 },
        WY: { min: 6, max: 7 },
        AZ: { min: 7, max: 8 },
        ID: { min: 7, max: 8 },
        MT: { min: 7, max: 8 },
        NV: { min: 7, max: 8 },
        UT: { min: 7, max: 8 },
        CA: { min: 7, max: 9 },
        OR: { min: 7, max: 9 },
        WA: { min: 7, max: 9 },
        AK: { min: null, max: null, blocked: true },
        HI: { min: null, max: null, blocked: true }
      };

      const STATE_NAMES = {
        AK: "Alaska", AL: "Alabama", AR: "Arkansas", AZ: "Arizona", CA: "California",
        CO: "Colorado", CT: "Connecticut", DC: "Washington DC", DE: "Delaware", FL: "Florida",
        GA: "Georgia", HI: "Hawaii", IA: "Iowa", ID: "Idaho", IL: "Illinois", IN: "Indiana",
        KS: "Kansas", KY: "Kentucky", LA: "Louisiana", MA: "Massachusetts", MD: "Maryland",
        ME: "Maine", MI: "Michigan", MN: "Minnesota", MO: "Missouri", MS: "Mississippi",
        MT: "Montana", NC: "North Carolina", ND: "North Dakota", NE: "Nebraska",
        NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NV: "Nevada",
        NY: "New York", OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania",
        RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota", TN: "Tennessee",
        TX: "Texas", UT: "Utah", VA: "Virginia", VT: "Vermont", WA: "Washington",
        WI: "Wisconsin", WV: "West Virginia", WY: "Wyoming"
      };

      const ZIP_STATE_RANGES = [
        ["AK", 995, 999], ["AL", 350, 369], ["AR", 716, 729], ["AZ", 850, 865], ["CA", 900, 961],
        ["CO", 800, 816], ["CT", 60, 69], ["DC", 200, 205], ["DE", 197, 199], ["FL", 320, 349],
        ["GA", 300, 319], ["HI", 967, 968], ["IA", 500, 528], ["ID", 832, 838], ["IL", 600, 629],
        ["IN", 460, 479], ["KS", 660, 679], ["KY", 400, 427], ["LA", 700, 714], ["MA", 10, 27],
        ["MD", 206, 219], ["ME", 39, 49], ["MI", 480, 499], ["MN", 550, 567], ["MO", 630, 658],
        ["MS", 386, 397], ["MT", 590, 599], ["NC", 270, 289], ["ND", 580, 588], ["NE", 680, 693],
        ["NH", 30, 38], ["NJ", 70, 89], ["NM", 870, 884], ["NV", 889, 898], ["NY", 100, 149],
        ["OH", 430, 459], ["OK", 730, 749], ["OR", 970, 979], ["PA", 150, 196], ["RI", 28, 29],
        ["SC", 290, 299], ["SD", 570, 577], ["TN", 370, 385], ["TX", 750, 799], ["TX", 885, 885],
        ["UT", 840, 847], ["VA", 201, 246], ["VT", 50, 59], ["WA", 980, 994], ["WI", 530, 549],
        ["WV", 247, 268], ["WY", 820, 831]
      ];

      const normalize = (s) =>
        String(s || "")
          .toLowerCase()
          .replace(/[\u2010-\u2015]/g, "-")
          .replace(/\u00a0/g, " ")
          .replace(/&/g, "and")
          .replace(/[^a-z0-9]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();

      const cleanZip = (v) => String(v || "").replace(/\D/g, "").slice(0, 5);
      const isValidZip = (v) => /^\d{5}$/.test(v);

      const showErr = (on, msg) => {
        err.textContent = msg || "Enter a valid 5-digit ZIP.";
        err.classList.toggle("is-active", !!on);
      };

      const addBusinessDays = (startDate, businessDays) => {
        const d = new Date(startDate.getTime());
        let added = 0;
        while (added < businessDays) {
          d.setDate(d.getDate() + 1);
          const day = d.getDay();
          if (day !== 0 && day !== 6) added += 1;
        }
        return d;
      };

      const fmtDate = (d) =>
        d.toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric"
        });

      function clearOldCaches() {
        try {
          OLD_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
        } catch (e) {}
      }

      function getStateFromZip(zip) {
        const prefix = Number(zip.slice(0, 3));
        for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
          const [state, min, max] = ZIP_STATE_RANGES[i];
          if (prefix >= min && prefix <= max) return state;
        }
        return "";
      }

      function readCache() {
        try {
          const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
          if (!cached || !cached.ts || !cached.data) return null;
          if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;
          return cached.data;
        } catch (e) {
          return null;
        }
      }

      function writeCache(data) {
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data }));
        } catch (e) {}
      }

      async function fetchFreshProductionData() {
        const refreshUrl = LEAD_PAGE + (LEAD_PAGE.includes("?") ? "&" : "?") + "hsr_refresh=" + encodeURIComponent(Date.now());
        const res = await fetch(refreshUrl, { credentials: "same-origin", cache: "no-store" });
        if (!res.ok) throw new Error("Lead time page fetch failed");

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const text = normalize(doc.body ? doc.body.textContent : html);

        const regularMatch = text.match(/ez fit sheds[\s\S]{0,1800}?standard production lead time[\s\S]{0,400}?is\s+(\d+)\s+business days/);
        const quickshipMatch = text.match(/ez fit sheds[\s\S]{0,3000}?quick\s*ship sheds and greenhouses[\s\S]{0,500}?(\d+)\s+business days/);

        if (!regularMatch || !quickshipMatch) {
          throw new Error("Could not parse EZ-Fit production lead times");
        }

        const data = {
          regular: { productionMinBd: Number(regularMatch[1]), productionMaxBd: Number(regularMatch[1]) },
          quickship: { productionMinBd: Number(quickshipMatch[1]), productionMaxBd: Number(quickshipMatch[1]) }
        };

        writeCache(data);
        return data;
      }

      async function getProductionData() {
        clearOldCaches();
        const cached = readCache();
        if (cached) return cached;
        return fetchFreshProductionData();
      }

      function getCurrentProductHandleFromUrl() {
        const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
        return match ? decodeURIComponent(match[1]).trim() : "";
      }

      function getCurrentProductTitleFromPage() {
        const selectors = [
          "h1.productView-title",
          ".productView-title",
          "h1.product-single__title",
          ".product-single__title",
          "main h1",
          "h1"
        ];

        for (let i = 0; i < selectors.length; i += 1) {
          const el = document.querySelector(selectors[i]);
          if (el && el.textContent && el.textContent.trim()) return el.textContent.trim();
        }

        return document.title || "";
      }

      function detectDefaultProductKey() {
        const currentHandle = getCurrentProductHandleFromUrl();
        const currentTitle = getCurrentProductTitleFromPage();

        const handleNorm = normalize(currentHandle);
        const titleNorm = normalize(currentTitle);
        const combined = `${handleNorm} ${titleNorm}`;

        if (combined.includes("woodsman") && combined.includes("quick ship")) return "woodsman_quickship";
        if (combined.includes("riverside") && combined.includes("quick ship")) return "riverside_quickship";
        if (combined.includes("homestead") && combined.includes("quick ship")) return "homestead_quickship";
        if (combined.includes("heritage") && combined.includes("quick ship")) return "heritage_quickship";
        if (combined.includes("greenhouse") && combined.includes("quick ship")) return "greenhouse_quickship";
        if (combined.includes("woodsman")) return "woodsman";
        if (combined.includes("riverside")) return "riverside";
        if (combined.includes("homestead")) return "homestead";
        if (combined.includes("heritage")) return "heritage";
        if (combined.includes("skyview")) return "skyview";
        if (combined.includes("craftsman")) return "craftsman";
        if (combined.includes("greenhouse")) return "greenhouse";
        return "";
      }

      function renderTable(productTitle, modeLabel, destinationStateName, prodMin, prodMax, transitMin, transitMax) {
        const today = new Date();
        const earliestBD = (prodMin || 0) + (transitMin || 0);
        const latestBD = (prodMax || 0) + (transitMax || 0);

        const earliest = addBusinessDays(today, earliestBD);
        const latest = addBusinessDays(today, latestBD);

        const prodText = prodMin === prodMax ? `${prodMin} business days` : `${prodMin} to ${prodMax} business days`;
        const transitText = transitMin === transitMax ? `${transitMin} business days` : `${transitMin} to ${transitMax} business days`;
        const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

        out.innerHTML = `
          <table aria-label="Delivery estimate">
            <tbody>
              <tr><th>Product</th><td>${productTitle}</td></tr>
              <tr><th>Lead-time type</th><td>${modeLabel}</td></tr>
              <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
              <tr><th>Production lead time</th><td>${prodText}</td></tr>
              <tr><th>Transit time</th><td>${transitText}</td></tr>
              <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
            </tbody>
          </table>
          <p class="hsr-note" style="margin-top:10px;">Estimate only. Holidays and carrier delays can shift delivery.</p>
        `;
      }

      const detectedDefaultProduct = detectDefaultProductKey();
      if (detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]) {
        productEl.value = detectedDefaultProduct;
      }

      btn.addEventListener("click", async () => {
        const zip = cleanZip(zipEl.value);
        const selectedKey = productEl.value;
        zipEl.value = zip;

        if (!isValidZip(zip)) {
          out.innerHTML = "";
          showErr(true, "Enter a valid 5-digit ZIP.");
          return;
        }

        if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
          out.innerHTML = "";
          showErr(true, "Please choose the exact EZ-Fit product.");
          return;
        }

        const destinationState = getStateFromZip(zip);
        if (!destinationState) {
          out.innerHTML = "";
          showErr(true, "Could not match that ZIP code to a supported U.S. state.");
          return;
        }

        const transit = STATE_TRANSIT[destinationState];
        if (!transit || transit.blocked) {
          out.innerHTML = "";
          showErr(true, "We do not currently ship EZ-Fit products to Alaska or Hawaii.");
          return;
        }

        showErr(false);

        try {
          const production = await getProductionData();
          const selectedProduct = PRODUCT_MAP[selectedKey];
          const prod = production[selectedProduct.mode];

          if (!prod) {
            out.innerHTML = "";
            showErr(true, "Could not load EZ-Fit production lead time data. Try again.");
            return;
          }

          renderTable(
            selectedProduct.label,
            selectedProduct.mode === "quickship" ? "Quick-Ship" : "Regular",
            STATE_NAMES[destinationState] || destinationState,
            prod.productionMinBd,
            prod.productionMaxBd,
            transit.min,
            transit.max
          );
        } catch (e) {
          out.innerHTML = "";
          showErr(true, "Could not load live EZ-Fit production lead time data. Try again.");
        }
      });

      clr.addEventListener("click", () => {
        zipEl.value = "";
        productEl.value = detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct] ? detectedDefaultProduct : "";
        out.innerHTML = "";
        showErr(false);
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-greenhouse-comparison-tool-ezfit-assets"] && !Shopify.designMode) return;
  try {
    (function () {
      var P = [
  {
    i: "1",
    t: "Cedarshed Sunhouse Western Red Cedar Greenhouse",
    h: "cedarshed-sunhouses-western-red-cedar-greenhouse-kit",
    v: "Cedarshed",
    p: 4599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-sunhouse-western-red-cedar-greenhouse.jpg?v=1713909199",
    s: {
      m: "Western Red Cedar",
      g: "Thermoclear polycarbonate roof panels",
      r: "Gable with lean-to extension",
      l: "~2 weeks production + ~1 week delivery",
      w: "No",
    },
    q: [
      ["Sunhouse 8x8 with Cedar Roof Shingles", 4599, "bf0xcsvud"],
      ["Sunhouse 8x12 with Cedar Roof Shingles", 5719, "bf0xctl4l"],
      ["Sunhouse 8x16 with Cedar Roof Shingles", 6839, "bf0xcuaet"],
      ["Sunhouse 12x12 with Cedar Roof Shingles", 8029, "bf0xcuzp1"],
      ["Sunhouse 8x8 with OSB Roof", 4059, "eic16ku9h"],
      ["Sunhouse 8x12 with OSB Roof", 4909, "eic16zl85"],
      ["Sunhouse 8x16 with OSB Roof", 5749, "eic17rol1"],
      ["Sunhouse 12x12 with OSB Roof", 6809, "eic18an91"],
    ],
  },
  {
    i: "2",
    t: "EZ-Fit Greenhouse Kit",
    h: "ez-fit-greenhouse",
    v: "EZ-Fit",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-kit-main.jpg?v=1739993920",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "15 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x8", 5299, "ek8tfiy45"],
      ["8x10", 5799, "ek8tfjned"],
      ["8x12", 6399, "ek8tfkcol"],
      ["10x12", 7299, "ek8tfl1yt"],
      ["10x14", 7899, "ek8tflr91"],
      ["10x16", 8699, "ek8tfmgj9"],
      ["12x16", 9299, "f7u9dvigl"],
      ["12x20", 10599, "f7u9dw7qt"],
      ["12x24", 11699, "f7u9dwx11"],
    ],
  },
  {
    i: "3",
    t: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP",
    h: "ez-fit-greenhouse-shed-kit-quick-ship",
    v: "EZ-Fit",
    p: 5799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-shed-kit-main.jpg?v=1740156032",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "3 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x10", 5799, "fpyozghmd"],
      ["8x12", 6399, "fpyozh6wl"],
      ["10x12", 7299, "fpyozhw6t"],
      ["12x20", 10599, "fpyozilh1"],
    ],
  },
  {
    i: "4",
    t: "Little Cottage Co. 12x12 Octagon Greenhouse",
    h: "little-cottage-company-12-x-12-octagon-garden-shed-greenhouse",
    v: "Little Cottage Co.",
    p: 14799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/12x12-garden-shed-greenhouse-view.jpg?v=1759764620",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 14799, "e0sfsakvp"],
    ],
  },
  {
    i: "5",
    t: "Little Cottage Co. 8x8 Octagon Greenhouse Kit",
    h: "little-cottage-company-8-x-8-octagon-greenhouse-shed",
    v: "Little Cottage Co.",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-octagon-greenhouse-kit-view.jpg?v=1759763977",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 7899, "e0sib2j3p"],
    ],
  },
  {
    i: "6",
    t: "Little Cottage Co. Colonial Gable Greenhouse",
    h: "little-cottage-company-colonial-gable-greenhouse-shed-kit",
    v: "Little Cottage Co.",
    p: 6499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/colonial-gable-greenhouse-8x12-panelized-409604.webp?v=1695738864",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Corrugated polycarbonate roof panels",
      r: "Gable",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["8ft x 8ft", 6499, "e0umlipth"],
      ["8ft x 12ft", 7699, "e0umlk4dx"],
      ["8ft x 16ft", 9499, "e0umlliyd"],
      ["10ft x 12ft", 8299, "e0umlmxit"],
      ["10ft x 14ft", 9499, "e0umlnmt1"],
      ["10ft x 16ft", 10399, "e0umloc39"],
    ],
  },
  {
    i: "7",
    t: "Little Cottage Co. Petite Greenhouse Kit",
    h: "little-cottage-company-petite-greenhouse",
    v: "Little Cottage Co.",
    p: 2399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-company-petite-greenhouse-front.jpg?v=1759767147",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Lean-to / single slope",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 2399, "e0uoehhdh"],
    ],
  },
  {
    i: "8",
    t: "Outdoor Living Today 8x8 Cedar Greenhouse",
    h: "outdoor-living-today-8x8-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 3999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x8-cedar-greenhouse.webp?v=1712353579",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 3999, "fb1pvtqut"],
    ],
  },
  {
    i: "9",
    t: "Outdoor Living Today 8x12 Cedar Greenhouse",
    h: "outdoor-living-today-8x12-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 4999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x12-cedar-greenhouse.jpg?v=1712334460",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 4999, "fb0xgj12t"],
    ],
  },
  {
    i: "10",
    t: "Riverstone MONT Greenhouse",
    h: "riverstone-industries-monticello-black-greenhouse",
    v: "Riverstone",
    p: 3149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x8-mont-greenhouse.jpg?v=1756399184",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 3149, "evunpyat1"],
      ["8x12'", 4149, "evunpz039"],
      ["8x16'", 5099, "evunpzpdh"],
      ["8x20'", 6149, "evunq0enp"],
      ["8x24'", 6999, "evunq13xx"],
    ],
  },
  {
    i: "11",
    t: "Riverstone MONT Greenhouse - Premium Package",
    h: "riverstone-industries-monticello-black-greenhouse-premium",
    v: "Riverstone",
    p: 4149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x12-mont-greenhouse-side.webp?v=1725474944",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 4149, "evvp9sab9"],
      ["8x12'", 4999, "evvp9szlh"],
      ["8x16'", 6099, "evvp9tovp"],
      ["8x20'", 7199, "evvp9ue5x"],
      ["8x24'", 7949, "evvp9v3g5"],
    ],
  },
  {
    i: "12",
    t: "Riverstone MONT Greenhouse - Mojave Package",
    h: "riverstone-industries-monticello-mojave-greenhouse",
    v: "Riverstone",
    p: 6799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x16-mojave-black-greenhouse-top-view.webp?v=1725909423",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 6799, "evwwff705"],
      ["8x16'", 7299, "evwwffwad"],
      ["8x20'", 7799, "evwwfglkl"],
      ["8x24'", 8699, "evwwfhaut"],
    ],
  },
  {
    i: "13",
    t: "Riverstone MONT Greenhouse - Moheat Package",
    h: "riverstone-industries-monticello-moheat-edition-black-finish-greenhouse-with-heater",
    v: "Riverstone",
    p: 7549,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-moheat-greenhouse-main.jpg?v=1726177659",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 7549, "ew0pryf5h"],
      ["8x16'", 8049, "ew0prz4fp"],
      ["8x20'", 8549, "ew0prztpx"],
      ["8x24'", 9349, "ew0ps0j05"],
    ],
  },
  {
    i: "14",
    t: "Riverstone MONT Greenhouse - Growers Package",
    h: "riverstone-industries-monticello-greenhouse-growers-edition",
    v: "Riverstone",
    p: 6399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-greenhouse-growers-edition.jpg?v=1726589737",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 6399, "ew1t134tx"],
      ["8x12'", 7099, "ew1t13u45"],
      ["8x16'", 8299, "ew1t14jed"],
      ["8x20'", 9099, "ew1t158ol"],
      ["8x24'", 9999, "ew1t15xyt"],
    ],
  },
  {
    i: "15",
    t: "Grandio Element 6x4 Greenhouse",
    h: "grandio-element-6x4-greenhouse",
    v: "Grandio",
    p: 1099,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-element-6x4-greenhouse-front-view.jpg?v=1729783640",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic Kit", 1099, "fn5jo4gfp"],
      ["Premium Kit", 1368, "fn5jo55px"],
    ],
  },
  {
    i: "16",
    t: "Grandio Element 6x8 Greenhouse",
    h: "grandio-element-6x8-greenhouse",
    v: "Grandio",
    p: 1699,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-6x8-element-greenhouse-kit-main.webp?v=1732143404",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1699, "fn5k7xbn9"],
      ["Premium", 2048, "fn5k7y0xh"],
    ],
  },
  {
    i: "17",
    t: "Grandio Element 6x12 Greenhouse",
    h: "grandio-element-6x12-greenhouse",
    v: "Grandio",
    p: 2299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-grandio-element-6x12-basic.jpg?v=1729724584",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2299, "fn81cuzp1"],
      ["Premium", 2728, "fn81cvoz9"],
    ],
  },
  {
    i: "18",
    t: "Grandio Ascent 8x8 Greenhouse",
    h: "grandio-ascent-8x8-greenhouse",
    v: "Grandio",
    p: 1999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x8-greenhouse-kit-main.jpg?v=1730932966",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1999, "fn8ducpx1"],
      ["Premium", 2348, "fn8dudf79"],
    ],
  },
  {
    i: "19",
    t: "Grandio Ascent 8x12 Greenhouse",
    h: "grandio-ascent-8x12-greenhouse",
    v: "Grandio",
    p: 2799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x12-greenhouse-kit.jpg?v=1731015892",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2799, "fn8grke9h"],
      ["Premium", 3228, "fn8grl3jp"],
    ],
  },
  {
    i: "20",
    t: "Grandio Ascent 8x16 Greenhouse",
    h: "grandio-ascent-8x16-greenhouse",
    v: "Grandio",
    p: 3599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x16-greenhouse-kit.jpg?v=1731097686",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3599, "fn8i0ecs5"],
      ["Premium", 4118, "fn8i0f22d"],
    ],
  },
  {
    i: "21",
    t: "Grandio Ascent 8x20 Greenhouse",
    h: "grandio-ascent-8x20-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x20-greenhouse-kit.jpg?v=1731441637",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8j3ebed"],
      ["Premium", 4998, "fn8j3f0ol"],
    ],
  },
  {
    i: "22",
    t: "Grandio Ascent 8x24 Greenhouse",
    h: "grandio-ascent-8x24-greenhouse",
    v: "Grandio",
    p: 5199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x24-greenhouse-kit-main.jpg?v=1732641939",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5199, "fn8jn4dh1"],
      ["Premium", 5888, "fn8jn52r9"],
    ],
  },
  {
    i: "23",
    t: "Grandio Elite 8x8 Greenhouse",
    h: "grandio-elite-8x8-greenhouse",
    v: "Grandio",
    p: 2599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x8-greenhouse-kit-main.jpg?v=1730142085",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2599, "fn8k35ovp"],
      ["Premium", 2948, "fn8k36e5x"],
    ],
  },
  {
    i: "24",
    t: "Grandio Elite 8x12 Greenhouse",
    h: "grandio-elite-8x12-greenhouse",
    v: "Grandio",
    p: 3499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x12-greenhouses-kit.jpg?v=1730236532",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3499, "fn8kc2nn9"],
      ["Premium", 3928, "fn8kc3cxh"],
    ],
  },
  {
    i: "25",
    t: "Grandio Elite 8x16 Greenhouse",
    h: "grandio-elite-8x16-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x16-greenhouse-kit-main.jpg?v=1730391680",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8ks5dmd"],
      ["Premium", 4918, "fn8ks62wl"],
    ],
  },
  {
    i: "26",
    t: "Grandio Elite 8x20 Greenhouse",
    h: "grandio-elite-8x20-greenhouse",
    v: "Grandio",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x20-greehouse-kit.jpg?v=1730735624",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5299, "fn8l5c5kl"],
      ["Premium", 5898, "fn8l5cuut"],
    ],
  },
  {
    i: "27",
    t: "Grandio Elite 8x24 Greenhouse",
    h: "grandio-elite-8x24-greenhouse",
    v: "Grandio",
    p: 6199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x24-greenhouse-kit.jpg?v=1730836212",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6199, "fn8lktt11"],
      ["Premium", 6888, "fn8lkuib9"],
    ],
  },
  {
    i: "28",
    t: "Grandio Summit 12x8 Greenhouse",
    h: "grandio-summit-12x8-greenhouse",
    v: "Grandio",
    p: 3899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x8-greenhouse-kit.jpg?v=1732145356",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3899, "fn8m0zc51"],
      ["Premium", 4418, "fn8m101f9"],
    ],
  },
  {
    i: "29",
    t: "Grandio Summit 12x12 Greenhouse",
    h: "grandio-summit-12x12-greenhouse",
    v: "Grandio",
    p: 4899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-12x12-summit-greenhouse-kit-christmas.jpg?v=1732560926",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4899, "fn8mdz391"],
      ["Premium", 5588, "fn8mdzsj9"],
    ],
  },
  {
    i: "30",
    t: "Grandio Summit 12x16 Greenhouse",
    h: "grandio-summit-12x16-greenhouse",
    v: "Grandio",
    p: 5899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x16-greenhouse-kit.jpg?v=1731545194",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5899, "fn9ed1gs5"],
      ["Premium", 6818, "fn9ed262d"],
    ],
  },
  {
    i: "31",
    t: "Grandio Summit 12x20 Greenhouse",
    h: "grandio-summit-12x20-greenhouse",
    v: "Grandio",
    p: 6899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-summit-12x20-greenhouse-kit-main.jpg?v=1732644686",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6899, "fn9gk1ws5"],
      ["Premium", 7988, "fn9gk2m2d"],
    ],
  },
  {
    i: "32",
    t: "Grandio Summit 12x24 Greenhouse",
    h: "grandio-summit-12x24-greenhouse",
    v: "Grandio",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x24-greenhouse-kit.jpg?v=1731595437",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 7899, "fn9i4xws5"],
      ["Premium", 9158, "fn9i4ym2d"],
    ],
  },
  {
    i: "33",
    t: "Grandio Summit 12x28 Greenhouse",
    h: "grandio-summit-12x28-greenhouse-kit",
    v: "Grandio",
    p: 8899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/summit-12x28-greenhouse-kit-full-view.jpg?v=1732643940",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 8899, "fn9j6mtdh"],
      ["Premium", 10328, "fn9j6ninp"],
    ],
  },
  {
    i: "34",
    t: "Grandio Summit 12x32 Greenhouse",
    h: "grandio-summit-12x32-greenhouse",
    v: "Grandio",
    p: 9899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x32-greenhouse-kit.jpg?v=1731615382",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 9899, "fn9k9f1v9"],
      ["Premium", 11498, "fn9k9fr5h"],
    ],
  }
],
        S = [null, null],
        V = [0, 0],
        A = 0,
        R = document.getElementById("hs-greenhouse-compare"),
        E = document.getElementById("hsScOverlay"),
        L = document.getElementById("hsScList"),
        Q = document.getElementById("hsScSearch"),
        C = document.getElementById("hsScCompare"),
        X = document.getElementById("hsScClose"),
        B = [document.getElementById("hsScSlot1"), document.getElementById("hsScSlot2")];
      function e(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      function m(n) {
        if (n == null || n === "") return '<span class="hs-sc-na">Not listed</span>';
        var x = Number(n);
        if (!isFinite(x)) return e(n);
        return "$" + x.toLocaleString(undefined, { maximumFractionDigits: x % 1 ? 2 : 0 });
      }
      function qs(v) {
        return Array.isArray(v) ? v[0] : v.s;
      }
      function qp(v) {
        return Array.isArray(v) ? v[1] : v.p;
      }
      function qid(v) {
        var x = Array.isArray(v) ? v[2] : v.i;
        return x ? parseInt(x, 36) : "";
      }
      function pr(p, i) {
        var q = p.q || [];
        return q.length > 1 && q[i] ? qp(q[i]) : p.p;
      }
      function cp(p) {
        return p.c;
      }
      function ph(p, i) {
        var q = p.q || [],
          id = q.length > 1 && q[i] ? qid(q[i]) : "";
        return (
          "/products/" +
          encodeURIComponent(p.h) +
          (id ? "?variant=" + encodeURIComponent(String(id)) : "")
        );
      }
      function priceHtml(p, i) {
        var a = pr(p, i),
          b = cp(p),
          h = m(a);
        if (b && Number(b) > Number(a)) h += '<span class="hs-sc-compare-at">' + m(b) + "</span>";
        return h;
      }
      function minVi(p) {
        var q = p.q || [],
          mi = 0,
          mp = Infinity;
        if (q.length < 2) return 0;
        q.forEach(function (v, i) {
          var n = Number(qp(v));
          if (isFinite(n) && n < mp) {
            mp = n;
            mi = i;
          }
        });
        return mi;
      }
      function card(p, slot) {
        var q = p.q || [],
          vi = V[slot] || 0;
        if (q.length > 1 && !q[vi]) vi = V[slot] = minVi(p);
        var sel = "";
        if (q.length > 1)
          sel =
            '<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize' +
            slot +
            '">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize' +
            slot +
            '" class="hs-sc-size-select" data-slot="' +
            slot +
            '">' +
            q
              .map(function (v, i) {
                return (
                  '<option value="' +
                  i +
                  '"' +
                  (i === vi ? " selected" : "") +
                  ">" +
                  e(qs(v)) +
                  " - " +
                  e(m(qp(v)).replace(/<[^>]+>/g, "")) +
                  "</option>"
                );
              })
              .join("") +
            '</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';
        return (
          '<img class="hs-sc-fi" loading="lazy" src="' +
          e(p.g || "") +
          '" alt="' +
          e(p.t) +
          '"><div class="hs-sc-brand">' +
          e(p.v || "") +
          '</div><div class="hs-sc-title">' +
          e(p.t || "") +
          '</div><div class="hs-sc-price" data-price-slot="' +
          slot +
          '">' +
          priceHtml(p, vi) +
          '</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="' +
          slot +
          '" href="' +
          ph(p, vi) +
          '" target="_blank">View product</a>' +
          sel +
          '<button type="button" class="hs-sc-change" data-change="' +
          slot +
          '">Change greenhouse</button>'
        );
      }
      function empty(slot) {
        return (
          '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your ' +
          (slot ? "second" : "first") +
          " greenhouse</span>"
        );
      }
      function renderSlots() {
        for (var i = 0; i < 2; i++) {
          B[i].className = "hs-sc-slot" + (S[i] ? " hs-sc-filled" : "");
          B[i].innerHTML = S[i] ? card(S[i], i) : empty(i);
        }
        renderCompare();
      }
      function val(p, k) {
        return p && p.s && p.s[k] ? e(p.s[k]) : '<span class="hs-sc-na">Not listed</span>';
      }
      function roofv(p, slot) {
        var q = p && (p.q || []),
          vi = V[slot] || 0,
          l = q.length > 1 && q[vi] ? String(qs(q[vi])) : "";
        if (/OSB Roof/i.test(l)) return "OSB roof";
        if (/Metal Roof/i.test(l)) return "Metal roof";
        return val(p, "r");
      }
      function renderCompare() {
        if (!S[0] || !S[1]) {
          C.innerHTML = "";
          return;
        }
        var n0 = S[0] ? e(S[0].t) : "Select a greenhouse",
          n1 = S[1] ? e(S[1].t) : "Select a greenhouse";
        var rows = [
          ["Frame/Wall Material", val(S[0], "m"), val(S[1], "m")],
          ["Panels/Windows", val(S[0], "g"), val(S[1], "g")],
          ["Roof Style", val(S[0], "r"), val(S[1], "r")],
          ["Custom Door & Window Placement", val(S[0], "w"), val(S[1], "w")],
          ["Lead Time", val(S[0], "l"), val(S[1], "l")],
        ];
        C.innerHTML =
          '<div class="hs-sc-compare-table" role="table" aria-label="Selected greenhouse comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n0 +
          '</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n1 +
          "</div>" +
          rows
            .map(function (r) {
              return (
                '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">' +
                r[0] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[1] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[2] +
                "</div>"
              );
            })
            .join("") +
          "</div>";
      }
      function open(slot) {
        A = slot;
        E.classList.add("hs-sc-is-open");
        E.setAttribute("aria-hidden", "false");
        document.body.classList.add("hs-sc-lock");
        Q.value = "";
        list("");
        setTimeout(function () {
          Q.focus();
        }, 30);
      }
      function close() {
        E.classList.remove("hs-sc-is-open");
        E.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hs-sc-lock");
      }
      function list(term) {
        term = (term || "").toLowerCase();
        var items = P.filter(function (p) {
          return (
            !term ||
            (p.t || "").toLowerCase().indexOf(term) > -1 ||
            (p.v || "").toLowerCase().indexOf(term) > -1
          );
        });
        L.innerHTML =
          items
            .map(function (p) {
              return (
                '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="' +
                e(p.i) +
                '"><img loading="lazy" src="' +
                e(p.g || "") +
                '" alt="' +
                e(p.t) +
                '"><div class="hs-sc-pi-brand">' +
                e(p.v || "") +
                '</div><div class="hs-sc-pi-title">' +
                e(p.t || "") +
                '</div><div class="hs-sc-pi-price">From ' +
                m(p.p) +
                "</div></div>"
              );
            })
            .join("") || '<p class="hs-sc-na">No greenhouses found.</p>';
      }
      B.forEach(function (b, i) {
        b.addEventListener("click", function (ev) {
          if (ev.target.closest(".hs-sc-change")) {
            open(i);
            return;
          }
          if (!S[i]) open(i);
        });
      });
      R.addEventListener("change", function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains("hs-sc-size-select")) {
          var slot = Number(el.getAttribute("data-slot")),
            p = S[slot];
          V[slot] = Number(el.value) || 0;
          var price = R.querySelector('[data-price-slot="' + slot + '"]'),
            link = R.querySelector('[data-link-slot="' + slot + '"]');
          if (price && p) price.innerHTML = priceHtml(p, V[slot]);
          if (link && p) link.setAttribute("href", ph(p, V[slot]));
          renderCompare();
        }
      });
      L.addEventListener("click", function (ev) {
        var it = ev.target.closest(".hs-sc-picker-item");
        if (!it) return;
        var id = it.getAttribute("data-id"),
          p = P.find(function (x) {
            return String(x.i) === String(id);
          });
        if (p) {
          S[A] = p;
          V[A] = minVi(p);
          close();
          renderSlots();
        }
      });
      L.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          var it = ev.target.closest(".hs-sc-picker-item");
          if (it) {
            ev.preventDefault();
            it.click();
          }
        }
      });
      Q.addEventListener("input", function () {
        list(Q.value);
      });
      X.addEventListener("click", close);
      E.addEventListener("click", function (ev) {
        if (ev.target === E) close();
      });
      document.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape" && E.classList.contains("hs-sc-is-open")) close();
      });
      function curh() {
        var m = String(location.pathname || "").match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).replace(/\/$/, "") : "";
      }
      function initCurrent() {
        var h = curh(),
          p =
            h &&
            P.find(function (x) {
              return String(x.h) === h;
            });
        if (p) {
          S[0] = p;
          V[0] = minVi(p);
        }
      }
      initCurrent();
      renderSlots();

      // ===== Live price refresh (lazy fetch with optimistic render) =====
      var LIVE = {}; // handle -> { done: boolean, loading: boolean }

      function toBase36(n) {
        return Number(n).toString(36);
      }

      function centsToDollars(v) {
        var n = Number(v);
        return isFinite(n) ? n / 100 : null;
      }

      function variantId36(v) {
        return Array.isArray(v) ? v[2] : v && v.i;
      }

      function variantIdNum(v) {
        var x = variantId36(v);
        return x ? parseInt(x, 36) : null;
      }

      function findLiveVariant(data, oldVariant) {
        var oldTitle = qs(oldVariant);
        var oldIdNum = variantIdNum(oldVariant);

        return (
          data.variants.find(function (v) {
            return oldIdNum && String(v.id) === String(oldIdNum);
          }) ||
          data.variants.find(function (v) {
            return v.title === oldTitle || v.public_title === oldTitle || v.name === oldTitle;
          }) ||
          null
        );
      }

      function fetchLive(p, cb) {
        if (!p || !p.h) return;

        if (LIVE[p.h] && LIVE[p.h].done) {
          cb && cb();
          return;
        }

        if (LIVE[p.h] && LIVE[p.h].loading) {
          setTimeout(function () {
            fetchLive(p, cb);
          }, 80);
          return;
        }

        LIVE[p.h] = { loading: true, done: false };

        try {
          fetch('/products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data || !data.variants || !data.variants.length) {
                LIVE[p.h] = { loading: false, done: true };
                cb && cb();
                return;
              }

              var oldQ = p.q || [];
              var newQ = oldQ.map(function (oldVariant) {
                var match = findLiveVariant(data, oldVariant);
                if (!match) return oldVariant;

                var livePrice = centsToDollars(match.price);
                return [qs(oldVariant), livePrice != null ? livePrice : qp(oldVariant), toBase36(match.id)];
              });

              // If this product had no baked-in variant dropdown, use the storefront product-level price.
              if (!newQ.length && data.price != null) {
                var topPrice = centsToDollars(data.price);
                if (topPrice != null) p.p = topPrice;
              }

              // If variants are present, use the lowest live variant price as the product's displayed From price.
              if (newQ.length) {
                var minPrice = Infinity;
                newQ.forEach(function (v) {
                  var price = Number(qp(v));
                  if (isFinite(price) && price < minPrice) minPrice = price;
                });
                if (isFinite(minPrice)) p.p = minPrice;
                p.q = newQ;
              }

              // Update compare-at price too. Prefer product-level compare_at_price, then max variant compare_at_price.
              var liveCompareAt = centsToDollars(data.compare_at_price);
              if (liveCompareAt == null) {
                data.variants.forEach(function (v) {
                  var ca = centsToDollars(v.compare_at_price);
                  if (ca != null && (liveCompareAt == null || ca > liveCompareAt)) liveCompareAt = ca;
                });
              }
              if (liveCompareAt != null) p.c = liveCompareAt;

              LIVE[p.h] = { loading: false, done: true };
              cb && cb();
            })
            .catch(function () {
              LIVE[p.h] = { loading: false, done: false };
            });
        } catch (e) {
          LIVE[p.h] = { loading: false, done: false };
        }
      }

      function refreshSlot(slot, preferMinVariant) {
        var p = S[slot];
        if (!p) return;

        var beforeIndex = V[slot] || 0;
        var beforeVariant = p.q && p.q[beforeIndex] ? p.q[beforeIndex] : null;
        var beforeTitle = beforeVariant ? qs(beforeVariant) : null;
        var beforeId = beforeVariant ? variantId36(beforeVariant) : null;

        fetchLive(p, function () {
          if (preferMinVariant) {
            V[slot] = minVi(p);
          } else if (p.q && p.q.length && beforeVariant) {
            var matchedIndex = p.q.findIndex(function (v) {
              return (beforeId && variantId36(v) === beforeId) || (beforeTitle && qs(v) === beforeTitle);
            });
            V[slot] = matchedIndex > -1 ? matchedIndex : Math.min(beforeIndex, p.q.length - 1);
          }
          renderSlots();
        });
      }

      // Refresh slot 1, the auto-loaded current product, shortly after load.
      if (S[0]) {
        setTimeout(function () {
          refreshSlot(0, true);
        }, 50);
      }

      // Hook into the modal-pick handler. The original picker handler stays intact;
      // this runs one tick later, after S[A] has been updated.
      L.addEventListener('click', function (ev) {
        var it = ev.target.closest('.hs-sc-picker-item');
        if (!it) return;
        setTimeout(function () {
          refreshSlot(A, true);
        }, 0);
      });

      // Preserve a user's selected variant when they change the dropdown and live data is not fetched yet.
      R.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains('hs-sc-size-select')) {
          var slot = Number(el.getAttribute('data-slot'));
          setTimeout(function () {
            refreshSlot(slot, false);
          }, 0);
        }
      });

      // Background-prefetch picker product prices once the modal opens.
      var _origOpen = open;
      open = function (slot) {
        _origOpen(slot);
        var i = 0;
        function prefetchNext() {
          if (i >= P.length) return;
          var p = P[i++];
          if (p && p.h && !(LIVE[p.h] && LIVE[p.h].done)) {
            fetchLive(p, function () {
              if (E.classList.contains('hs-sc-is-open')) list(Q.value);
            });
          }
          setTimeout(prefetchNext, 60);
        }
        prefetchNext();
      };
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-greenhouse-comparison-tool-lcc-assets"] && !Shopify.designMode) return;
  try {
    (function () {
      var P = [
  {
    i: "1",
    t: "Cedarshed Sunhouse Western Red Cedar Greenhouse",
    h: "cedarshed-sunhouses-western-red-cedar-greenhouse-kit",
    v: "Cedarshed",
    p: 4599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-sunhouse-western-red-cedar-greenhouse.jpg?v=1713909199",
    s: {
      m: "Western Red Cedar",
      g: "Thermoclear polycarbonate roof panels",
      r: "Gable with lean-to extension",
      l: "~2 weeks production + ~1 week delivery",
      w: "No",
    },
    q: [
      ["Sunhouse 8x8 with Cedar Roof Shingles", 4599, "bf0xcsvud"],
      ["Sunhouse 8x12 with Cedar Roof Shingles", 5719, "bf0xctl4l"],
      ["Sunhouse 8x16 with Cedar Roof Shingles", 6839, "bf0xcuaet"],
      ["Sunhouse 12x12 with Cedar Roof Shingles", 8029, "bf0xcuzp1"],
      ["Sunhouse 8x8 with OSB Roof", 4059, "eic16ku9h"],
      ["Sunhouse 8x12 with OSB Roof", 4909, "eic16zl85"],
      ["Sunhouse 8x16 with OSB Roof", 5749, "eic17rol1"],
      ["Sunhouse 12x12 with OSB Roof", 6809, "eic18an91"],
    ],
  },
  {
    i: "2",
    t: "EZ-Fit Greenhouse Kit",
    h: "ez-fit-greenhouse",
    v: "EZ-Fit",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-kit-main.jpg?v=1739993920",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "8 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x8", 5299, "ek8tfiy45"],
      ["8x10", 5799, "ek8tfjned"],
      ["8x12", 6399, "ek8tfkcol"],
      ["10x12", 7299, "ek8tfl1yt"],
      ["10x14", 7899, "ek8tflr91"],
      ["10x16", 8699, "ek8tfmgj9"],
      ["12x16", 9299, "f7u9dvigl"],
      ["12x20", 10599, "f7u9dw7qt"],
      ["12x24", 11699, "f7u9dwx11"],
    ],
  },
  {
    i: "3",
    t: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP",
    h: "ez-fit-greenhouse-shed-kit-quick-ship",
    v: "EZ-Fit",
    p: 5799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-shed-kit-main.jpg?v=1740156032",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "3 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x10", 5799, "fpyozghmd"],
      ["8x12", 6399, "fpyozh6wl"],
      ["10x12", 7299, "fpyozhw6t"],
      ["12x20", 10599, "fpyozilh1"],
    ],
  },
  {
    i: "4",
    t: "Little Cottage Co. 12x12 Octagon Greenhouse",
    h: "little-cottage-company-12-x-12-octagon-garden-shed-greenhouse",
    v: "Little Cottage Co.",
    p: 14799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/12x12-garden-shed-greenhouse-view.jpg?v=1759764620",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 14799, "e0sfsakvp"],
    ],
  },
  {
    i: "5",
    t: "Little Cottage Co. 8x8 Octagon Greenhouse Kit",
    h: "little-cottage-company-8-x-8-octagon-greenhouse-shed",
    v: "Little Cottage Co.",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-octagon-greenhouse-kit-view.jpg?v=1759763977",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 7899, "e0sib2j3p"],
    ],
  },
  {
    i: "6",
    t: "Little Cottage Co. Colonial Gable Greenhouse",
    h: "little-cottage-company-colonial-gable-greenhouse-shed-kit",
    v: "Little Cottage Co.",
    p: 6499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/colonial-gable-greenhouse-8x12-panelized-409604.webp?v=1695738864",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Corrugated polycarbonate roof panels",
      r: "Gable",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["8ft x 8ft", 6499, "e0umlipth"],
      ["8ft x 12ft", 7699, "e0umlk4dx"],
      ["8ft x 16ft", 9499, "e0umlliyd"],
      ["10ft x 12ft", 8299, "e0umlmxit"],
      ["10ft x 14ft", 9499, "e0umlnmt1"],
      ["10ft x 16ft", 10399, "e0umloc39"],
    ],
  },
  {
    i: "7",
    t: "Little Cottage Co. Petite Greenhouse Kit",
    h: "little-cottage-company-petite-greenhouse",
    v: "Little Cottage Co.",
    p: 2399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-company-petite-greenhouse-front.jpg?v=1759767147",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Lean-to / single slope",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 2399, "e0uoehhdh"],
    ],
  },
  {
    i: "8",
    t: "Outdoor Living Today 8x8 Cedar Greenhouse",
    h: "outdoor-living-today-8x8-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 3999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x8-cedar-greenhouse.webp?v=1712353579",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 3999, "fb1pvtqut"],
    ],
  },
  {
    i: "9",
    t: "Outdoor Living Today 8x12 Cedar Greenhouse",
    h: "outdoor-living-today-8x12-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 4999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x12-cedar-greenhouse.jpg?v=1712334460",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 4999, "fb0xgj12t"],
    ],
  },
  {
    i: "10",
    t: "Riverstone MONT Greenhouse",
    h: "riverstone-industries-monticello-black-greenhouse",
    v: "Riverstone",
    p: 3149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x8-mont-greenhouse.jpg?v=1756399184",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 3149, "evunpyat1"],
      ["8x12'", 4149, "evunpz039"],
      ["8x16'", 5099, "evunpzpdh"],
      ["8x20'", 6149, "evunq0enp"],
      ["8x24'", 6999, "evunq13xx"],
    ],
  },
  {
    i: "11",
    t: "Riverstone MONT Greenhouse - Premium Package",
    h: "riverstone-industries-monticello-black-greenhouse-premium",
    v: "Riverstone",
    p: 4149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x12-mont-greenhouse-side.webp?v=1725474944",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 4149, "evvp9sab9"],
      ["8x12'", 4999, "evvp9szlh"],
      ["8x16'", 6099, "evvp9tovp"],
      ["8x20'", 7199, "evvp9ue5x"],
      ["8x24'", 7949, "evvp9v3g5"],
    ],
  },
  {
    i: "12",
    t: "Riverstone MONT Greenhouse - Mojave Package",
    h: "riverstone-industries-monticello-mojave-greenhouse",
    v: "Riverstone",
    p: 6799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x16-mojave-black-greenhouse-top-view.webp?v=1725909423",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 6799, "evwwff705"],
      ["8x16'", 7299, "evwwffwad"],
      ["8x20'", 7799, "evwwfglkl"],
      ["8x24'", 8699, "evwwfhaut"],
    ],
  },
  {
    i: "13",
    t: "Riverstone MONT Greenhouse - Moheat Package",
    h: "riverstone-industries-monticello-moheat-edition-black-finish-greenhouse-with-heater",
    v: "Riverstone",
    p: 7549,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-moheat-greenhouse-main.jpg?v=1726177659",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 7549, "ew0pryf5h"],
      ["8x16'", 8049, "ew0prz4fp"],
      ["8x20'", 8549, "ew0prztpx"],
      ["8x24'", 9349, "ew0ps0j05"],
    ],
  },
  {
    i: "14",
    t: "Riverstone MONT Greenhouse - Growers Package",
    h: "riverstone-industries-monticello-greenhouse-growers-edition",
    v: "Riverstone",
    p: 6399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-greenhouse-growers-edition.jpg?v=1726589737",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 6399, "ew1t134tx"],
      ["8x12'", 7099, "ew1t13u45"],
      ["8x16'", 8299, "ew1t14jed"],
      ["8x20'", 9099, "ew1t158ol"],
      ["8x24'", 9999, "ew1t15xyt"],
    ],
  },
  {
    i: "15",
    t: "Grandio Element 6x4 Greenhouse",
    h: "grandio-element-6x4-greenhouse",
    v: "Grandio",
    p: 1099,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-element-6x4-greenhouse-front-view.jpg?v=1729783640",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic Kit", 1099, "fn5jo4gfp"],
      ["Premium Kit", 1368, "fn5jo55px"],
    ],
  },
  {
    i: "16",
    t: "Grandio Element 6x8 Greenhouse",
    h: "grandio-element-6x8-greenhouse",
    v: "Grandio",
    p: 1699,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-6x8-element-greenhouse-kit-main.webp?v=1732143404",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1699, "fn5k7xbn9"],
      ["Premium", 2048, "fn5k7y0xh"],
    ],
  },
  {
    i: "17",
    t: "Grandio Element 6x12 Greenhouse",
    h: "grandio-element-6x12-greenhouse",
    v: "Grandio",
    p: 2299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-grandio-element-6x12-basic.jpg?v=1729724584",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2299, "fn81cuzp1"],
      ["Premium", 2728, "fn81cvoz9"],
    ],
  },
  {
    i: "18",
    t: "Grandio Ascent 8x8 Greenhouse",
    h: "grandio-ascent-8x8-greenhouse",
    v: "Grandio",
    p: 1999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x8-greenhouse-kit-main.jpg?v=1730932966",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1999, "fn8ducpx1"],
      ["Premium", 2348, "fn8dudf79"],
    ],
  },
  {
    i: "19",
    t: "Grandio Ascent 8x12 Greenhouse",
    h: "grandio-ascent-8x12-greenhouse",
    v: "Grandio",
    p: 2799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x12-greenhouse-kit.jpg?v=1731015892",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2799, "fn8grke9h"],
      ["Premium", 3228, "fn8grl3jp"],
    ],
  },
  {
    i: "20",
    t: "Grandio Ascent 8x16 Greenhouse",
    h: "grandio-ascent-8x16-greenhouse",
    v: "Grandio",
    p: 3599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x16-greenhouse-kit.jpg?v=1731097686",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3599, "fn8i0ecs5"],
      ["Premium", 4118, "fn8i0f22d"],
    ],
  },
  {
    i: "21",
    t: "Grandio Ascent 8x20 Greenhouse",
    h: "grandio-ascent-8x20-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x20-greenhouse-kit.jpg?v=1731441637",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8j3ebed"],
      ["Premium", 4998, "fn8j3f0ol"],
    ],
  },
  {
    i: "22",
    t: "Grandio Ascent 8x24 Greenhouse",
    h: "grandio-ascent-8x24-greenhouse",
    v: "Grandio",
    p: 5199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x24-greenhouse-kit-main.jpg?v=1732641939",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5199, "fn8jn4dh1"],
      ["Premium", 5888, "fn8jn52r9"],
    ],
  },
  {
    i: "23",
    t: "Grandio Elite 8x8 Greenhouse",
    h: "grandio-elite-8x8-greenhouse",
    v: "Grandio",
    p: 2599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x8-greenhouse-kit-main.jpg?v=1730142085",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2599, "fn8k35ovp"],
      ["Premium", 2948, "fn8k36e5x"],
    ],
  },
  {
    i: "24",
    t: "Grandio Elite 8x12 Greenhouse",
    h: "grandio-elite-8x12-greenhouse",
    v: "Grandio",
    p: 3499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x12-greenhouses-kit.jpg?v=1730236532",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3499, "fn8kc2nn9"],
      ["Premium", 3928, "fn8kc3cxh"],
    ],
  },
  {
    i: "25",
    t: "Grandio Elite 8x16 Greenhouse",
    h: "grandio-elite-8x16-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x16-greenhouse-kit-main.jpg?v=1730391680",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8ks5dmd"],
      ["Premium", 4918, "fn8ks62wl"],
    ],
  },
  {
    i: "26",
    t: "Grandio Elite 8x20 Greenhouse",
    h: "grandio-elite-8x20-greenhouse",
    v: "Grandio",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x20-greehouse-kit.jpg?v=1730735624",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5299, "fn8l5c5kl"],
      ["Premium", 5898, "fn8l5cuut"],
    ],
  },
  {
    i: "27",
    t: "Grandio Elite 8x24 Greenhouse",
    h: "grandio-elite-8x24-greenhouse",
    v: "Grandio",
    p: 6199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x24-greenhouse-kit.jpg?v=1730836212",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6199, "fn8lktt11"],
      ["Premium", 6888, "fn8lkuib9"],
    ],
  },
  {
    i: "28",
    t: "Grandio Summit 12x8 Greenhouse",
    h: "grandio-summit-12x8-greenhouse",
    v: "Grandio",
    p: 3899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x8-greenhouse-kit.jpg?v=1732145356",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3899, "fn8m0zc51"],
      ["Premium", 4418, "fn8m101f9"],
    ],
  },
  {
    i: "29",
    t: "Grandio Summit 12x12 Greenhouse",
    h: "grandio-summit-12x12-greenhouse",
    v: "Grandio",
    p: 4899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-12x12-summit-greenhouse-kit-christmas.jpg?v=1732560926",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4899, "fn8mdz391"],
      ["Premium", 5588, "fn8mdzsj9"],
    ],
  },
  {
    i: "30",
    t: "Grandio Summit 12x16 Greenhouse",
    h: "grandio-summit-12x16-greenhouse",
    v: "Grandio",
    p: 5899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x16-greenhouse-kit.jpg?v=1731545194",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5899, "fn9ed1gs5"],
      ["Premium", 6818, "fn9ed262d"],
    ],
  },
  {
    i: "31",
    t: "Grandio Summit 12x20 Greenhouse",
    h: "grandio-summit-12x20-greenhouse",
    v: "Grandio",
    p: 6899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-summit-12x20-greenhouse-kit-main.jpg?v=1732644686",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6899, "fn9gk1ws5"],
      ["Premium", 7988, "fn9gk2m2d"],
    ],
  },
  {
    i: "32",
    t: "Grandio Summit 12x24 Greenhouse",
    h: "grandio-summit-12x24-greenhouse",
    v: "Grandio",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x24-greenhouse-kit.jpg?v=1731595437",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 7899, "fn9i4xws5"],
      ["Premium", 9158, "fn9i4ym2d"],
    ],
  },
  {
    i: "33",
    t: "Grandio Summit 12x28 Greenhouse",
    h: "grandio-summit-12x28-greenhouse-kit",
    v: "Grandio",
    p: 8899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/summit-12x28-greenhouse-kit-full-view.jpg?v=1732643940",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 8899, "fn9j6mtdh"],
      ["Premium", 10328, "fn9j6ninp"],
    ],
  },
  {
    i: "34",
    t: "Grandio Summit 12x32 Greenhouse",
    h: "grandio-summit-12x32-greenhouse",
    v: "Grandio",
    p: 9899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x32-greenhouse-kit.jpg?v=1731615382",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 9899, "fn9k9f1v9"],
      ["Premium", 11498, "fn9k9fr5h"],
    ],
  }
],
        S = [null, null],
        V = [0, 0],
        A = 0,
        R = document.getElementById("hs-greenhouse-compare"),
        E = document.getElementById("hsScOverlay"),
        L = document.getElementById("hsScList"),
        Q = document.getElementById("hsScSearch"),
        C = document.getElementById("hsScCompare"),
        X = document.getElementById("hsScClose"),
        B = [document.getElementById("hsScSlot1"), document.getElementById("hsScSlot2")];
      function e(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      function m(n) {
        if (n == null || n === "") return '<span class="hs-sc-na">Not listed</span>';
        var x = Number(n);
        if (!isFinite(x)) return e(n);
        return "$" + x.toLocaleString(undefined, { maximumFractionDigits: x % 1 ? 2 : 0 });
      }
      function qs(v) {
        return Array.isArray(v) ? v[0] : v.s;
      }
      function qp(v) {
        return Array.isArray(v) ? v[1] : v.p;
      }
      function qid(v) {
        var x = Array.isArray(v) ? v[2] : v.i;
        return x ? parseInt(x, 36) : "";
      }
      function pr(p, i) {
        var q = p.q || [];
        return q.length > 1 && q[i] ? qp(q[i]) : p.p;
      }
      function cp(p) {
        return p.c;
      }
      function ph(p, i) {
        var q = p.q || [],
          id = q.length > 1 && q[i] ? qid(q[i]) : "";
        return (
          "/products/" +
          encodeURIComponent(p.h) +
          (id ? "?variant=" + encodeURIComponent(String(id)) : "")
        );
      }
      function priceHtml(p, i) {
        var a = pr(p, i),
          b = cp(p),
          h = m(a);
        if (b && Number(b) > Number(a)) h += '<span class="hs-sc-compare-at">' + m(b) + "</span>";
        return h;
      }
      function minVi(p) {
        var q = p.q || [],
          mi = 0,
          mp = Infinity;
        if (q.length < 2) return 0;
        q.forEach(function (v, i) {
          var n = Number(qp(v));
          if (isFinite(n) && n < mp) {
            mp = n;
            mi = i;
          }
        });
        return mi;
      }
      function card(p, slot) {
        var q = p.q || [],
          vi = V[slot] || 0;
        if (q.length > 1 && !q[vi]) vi = V[slot] = minVi(p);
        var sel = "";
        if (q.length > 1)
          sel =
            '<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize' +
            slot +
            '">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize' +
            slot +
            '" class="hs-sc-size-select" data-slot="' +
            slot +
            '">' +
            q
              .map(function (v, i) {
                return (
                  '<option value="' +
                  i +
                  '"' +
                  (i === vi ? " selected" : "") +
                  ">" +
                  e(qs(v)) +
                  " - " +
                  e(m(qp(v)).replace(/<[^>]+>/g, "")) +
                  "</option>"
                );
              })
              .join("") +
            '</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';
        return (
          '<img class="hs-sc-fi" loading="lazy" src="' +
          e(p.g || "") +
          '" alt="' +
          e(p.t) +
          '"><div class="hs-sc-brand">' +
          e(p.v || "") +
          '</div><div class="hs-sc-title">' +
          e(p.t || "") +
          '</div><div class="hs-sc-price" data-price-slot="' +
          slot +
          '">' +
          priceHtml(p, vi) +
          '</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="' +
          slot +
          '" href="' +
          ph(p, vi) +
          '" target="_blank">View product</a>' +
          sel +
          '<button type="button" class="hs-sc-change" data-change="' +
          slot +
          '">Change greenhouse</button>'
        );
      }
      function empty(slot) {
        return (
          '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your ' +
          (slot ? "second" : "first") +
          " greenhouse</span>"
        );
      }
      function renderSlots() {
        for (var i = 0; i < 2; i++) {
          B[i].className = "hs-sc-slot" + (S[i] ? " hs-sc-filled" : "");
          B[i].innerHTML = S[i] ? card(S[i], i) : empty(i);
        }
        renderCompare();
      }
      function val(p, k) {
        return p && p.s && p.s[k] ? e(p.s[k]) : '<span class="hs-sc-na">Not listed</span>';
      }
      function roofv(p, slot) {
        var q = p && (p.q || []),
          vi = V[slot] || 0,
          l = q.length > 1 && q[vi] ? String(qs(q[vi])) : "";
        if (/OSB Roof/i.test(l)) return "OSB roof";
        if (/Metal Roof/i.test(l)) return "Metal roof";
        return val(p, "r");
      }
      function renderCompare() {
        if (!S[0] || !S[1]) {
          C.innerHTML = "";
          return;
        }
        var n0 = S[0] ? e(S[0].t) : "Select a greenhouse",
          n1 = S[1] ? e(S[1].t) : "Select a greenhouse";
        var rows = [
          ["Frame/Wall Material", val(S[0], "m"), val(S[1], "m")],
          ["Panels/Windows", val(S[0], "g"), val(S[1], "g")],
          ["Roof Style", val(S[0], "r"), val(S[1], "r")],
          ["Custom Door & Window Placement", val(S[0], "w"), val(S[1], "w")],
          ["Lead Time", val(S[0], "l"), val(S[1], "l")],
        ];
        C.innerHTML =
          '<div class="hs-sc-compare-table" role="table" aria-label="Selected greenhouse comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n0 +
          '</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n1 +
          "</div>" +
          rows
            .map(function (r) {
              return (
                '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">' +
                r[0] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[1] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[2] +
                "</div>"
              );
            })
            .join("") +
          "</div>";
      }
      function open(slot) {
        A = slot;
        E.classList.add("hs-sc-is-open");
        E.setAttribute("aria-hidden", "false");
        document.body.classList.add("hs-sc-lock");
        Q.value = "";
        list("");
        setTimeout(function () {
          Q.focus();
        }, 30);
      }
      function close() {
        E.classList.remove("hs-sc-is-open");
        E.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hs-sc-lock");
      }
      function list(term) {
        term = (term || "").toLowerCase();
        var items = P.filter(function (p) {
          return (
            !term ||
            (p.t || "").toLowerCase().indexOf(term) > -1 ||
            (p.v || "").toLowerCase().indexOf(term) > -1
          );
        });
        L.innerHTML =
          items
            .map(function (p) {
              return (
                '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="' +
                e(p.i) +
                '"><img loading="lazy" src="' +
                e(p.g || "") +
                '" alt="' +
                e(p.t) +
                '"><div class="hs-sc-pi-brand">' +
                e(p.v || "") +
                '</div><div class="hs-sc-pi-title">' +
                e(p.t || "") +
                '</div><div class="hs-sc-pi-price">From ' +
                m(p.p) +
                "</div></div>"
              );
            })
            .join("") || '<p class="hs-sc-na">No greenhouses found.</p>';
      }
      B.forEach(function (b, i) {
        b.addEventListener("click", function (ev) {
          if (ev.target.closest(".hs-sc-change")) {
            open(i);
            return;
          }
          if (!S[i]) open(i);
        });
      });
      R.addEventListener("change", function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains("hs-sc-size-select")) {
          var slot = Number(el.getAttribute("data-slot")),
            p = S[slot];
          V[slot] = Number(el.value) || 0;
          var price = R.querySelector('[data-price-slot="' + slot + '"]'),
            link = R.querySelector('[data-link-slot="' + slot + '"]');
          if (price && p) price.innerHTML = priceHtml(p, V[slot]);
          if (link && p) link.setAttribute("href", ph(p, V[slot]));
          renderCompare();
        }
      });
      L.addEventListener("click", function (ev) {
        var it = ev.target.closest(".hs-sc-picker-item");
        if (!it) return;
        var id = it.getAttribute("data-id"),
          p = P.find(function (x) {
            return String(x.i) === String(id);
          });
        if (p) {
          S[A] = p;
          V[A] = minVi(p);
          close();
          renderSlots();
        }
      });
      L.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          var it = ev.target.closest(".hs-sc-picker-item");
          if (it) {
            ev.preventDefault();
            it.click();
          }
        }
      });
      Q.addEventListener("input", function () {
        list(Q.value);
      });
      X.addEventListener("click", close);
      E.addEventListener("click", function (ev) {
        if (ev.target === E) close();
      });
      document.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape" && E.classList.contains("hs-sc-is-open")) close();
      });
      function curh() {
        var m = String(location.pathname || "").match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).replace(/\/$/, "") : "";
      }
      function initCurrent() {
        var h = curh(),
          p =
            h &&
            P.find(function (x) {
              return String(x.h) === h;
            });
        if (p) {
          S[0] = p;
          V[0] = minVi(p);
        }
      }
      initCurrent();
      renderSlots();

      // ===== Live price refresh (lazy fetch with optimistic render) =====
      var LIVE = {}; // handle -> { done: boolean, loading: boolean }

      function toBase36(n) {
        return Number(n).toString(36);
      }

      function centsToDollars(v) {
        var n = Number(v);
        return isFinite(n) ? n / 100 : null;
      }

      function variantId36(v) {
        return Array.isArray(v) ? v[2] : v && v.i;
      }

      function variantIdNum(v) {
        var x = variantId36(v);
        return x ? parseInt(x, 36) : null;
      }

      function findLiveVariant(data, oldVariant) {
        var oldTitle = qs(oldVariant);
        var oldIdNum = variantIdNum(oldVariant);

        return (
          data.variants.find(function (v) {
            return oldIdNum && String(v.id) === String(oldIdNum);
          }) ||
          data.variants.find(function (v) {
            return v.title === oldTitle || v.public_title === oldTitle || v.name === oldTitle;
          }) ||
          null
        );
      }

      function fetchLive(p, cb) {
        if (!p || !p.h) return;

        if (LIVE[p.h] && LIVE[p.h].done) {
          cb && cb();
          return;
        }

        if (LIVE[p.h] && LIVE[p.h].loading) {
          setTimeout(function () {
            fetchLive(p, cb);
          }, 80);
          return;
        }

        LIVE[p.h] = { loading: true, done: false };

        try {
          fetch('/products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data || !data.variants || !data.variants.length) {
                LIVE[p.h] = { loading: false, done: true };
                cb && cb();
                return;
              }

              var oldQ = p.q || [];
              var newQ = oldQ.map(function (oldVariant) {
                var match = findLiveVariant(data, oldVariant);
                if (!match) return oldVariant;

                var livePrice = centsToDollars(match.price);
                return [qs(oldVariant), livePrice != null ? livePrice : qp(oldVariant), toBase36(match.id)];
              });

              // If this product had no baked-in variant dropdown, use the storefront product-level price.
              if (!newQ.length && data.price != null) {
                var topPrice = centsToDollars(data.price);
                if (topPrice != null) p.p = topPrice;
              }

              // If variants are present, use the lowest live variant price as the product's displayed From price.
              if (newQ.length) {
                var minPrice = Infinity;
                newQ.forEach(function (v) {
                  var price = Number(qp(v));
                  if (isFinite(price) && price < minPrice) minPrice = price;
                });
                if (isFinite(minPrice)) p.p = minPrice;
                p.q = newQ;
              }

              // Update compare-at price too. Prefer product-level compare_at_price, then max variant compare_at_price.
              var liveCompareAt = centsToDollars(data.compare_at_price);
              if (liveCompareAt == null) {
                data.variants.forEach(function (v) {
                  var ca = centsToDollars(v.compare_at_price);
                  if (ca != null && (liveCompareAt == null || ca > liveCompareAt)) liveCompareAt = ca;
                });
              }
              if (liveCompareAt != null) p.c = liveCompareAt;

              LIVE[p.h] = { loading: false, done: true };
              cb && cb();
            })
            .catch(function () {
              LIVE[p.h] = { loading: false, done: false };
            });
        } catch (e) {
          LIVE[p.h] = { loading: false, done: false };
        }
      }

      function refreshSlot(slot, preferMinVariant) {
        var p = S[slot];
        if (!p) return;

        var beforeIndex = V[slot] || 0;
        var beforeVariant = p.q && p.q[beforeIndex] ? p.q[beforeIndex] : null;
        var beforeTitle = beforeVariant ? qs(beforeVariant) : null;
        var beforeId = beforeVariant ? variantId36(beforeVariant) : null;

        fetchLive(p, function () {
          if (preferMinVariant) {
            V[slot] = minVi(p);
          } else if (p.q && p.q.length && beforeVariant) {
            var matchedIndex = p.q.findIndex(function (v) {
              return (beforeId && variantId36(v) === beforeId) || (beforeTitle && qs(v) === beforeTitle);
            });
            V[slot] = matchedIndex > -1 ? matchedIndex : Math.min(beforeIndex, p.q.length - 1);
          }
          renderSlots();
        });
      }

      // Refresh slot 1, the auto-loaded current product, shortly after load.
      if (S[0]) {
        setTimeout(function () {
          refreshSlot(0, true);
        }, 50);
      }

      // Hook into the modal-pick handler. The original picker handler stays intact;
      // this runs one tick later, after S[A] has been updated.
      L.addEventListener('click', function (ev) {
        var it = ev.target.closest('.hs-sc-picker-item');
        if (!it) return;
        setTimeout(function () {
          refreshSlot(A, true);
        }, 0);
      });

      // Preserve a user's selected variant when they change the dropdown and live data is not fetched yet.
      R.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains('hs-sc-size-select')) {
          var slot = Number(el.getAttribute('data-slot'));
          setTimeout(function () {
            refreshSlot(slot, false);
          }, 0);
        }
      });

      // Background-prefetch picker product prices once the modal opens.
      var _origOpen = open;
      open = function (slot) {
        _origOpen(slot);
        var i = 0;
        function prefetchNext() {
          if (i >= P.length) return;
          var p = P[i++];
          if (p && p.h && !(LIVE[p.h] && LIVE[p.h].done)) {
            fetchLive(p, function () {
              if (E.classList.contains('hs-sc-is-open')) list(Q.value);
            });
          }
          setTimeout(prefetchNext, 60);
        }
        prefetchNext();
      };
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-greenhouse-comparison-tool-petite-assets"] && !Shopify.designMode) return;
  try {
    (function () {
      var P = [
  {
    i: "1",
    t: "Cedarshed Sunhouse Western Red Cedar Greenhouse",
    h: "cedarshed-sunhouses-western-red-cedar-greenhouse-kit",
    v: "Cedarshed",
    p: 4599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-sunhouse-western-red-cedar-greenhouse.jpg?v=1713909199",
    s: {
      m: "Western Red Cedar",
      g: "Thermoclear polycarbonate roof panels",
      r: "Gable with lean-to extension",
      l: "~2 weeks production + ~1 week delivery",
      w: "No",
    },
    q: [
      ["Sunhouse 8x8 with Cedar Roof Shingles", 4599, "bf0xcsvud"],
      ["Sunhouse 8x12 with Cedar Roof Shingles", 5719, "bf0xctl4l"],
      ["Sunhouse 8x16 with Cedar Roof Shingles", 6839, "bf0xcuaet"],
      ["Sunhouse 12x12 with Cedar Roof Shingles", 8029, "bf0xcuzp1"],
      ["Sunhouse 8x8 with OSB Roof", 4059, "eic16ku9h"],
      ["Sunhouse 8x12 with OSB Roof", 4909, "eic16zl85"],
      ["Sunhouse 8x16 with OSB Roof", 5749, "eic17rol1"],
      ["Sunhouse 12x12 with OSB Roof", 6809, "eic18an91"],
    ],
  },
  {
    i: "2",
    t: "EZ-Fit Greenhouse Kit",
    h: "ez-fit-greenhouse",
    v: "EZ-Fit",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-kit-main.jpg?v=1739993920",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "8 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x8", 5299, "ek8tfiy45"],
      ["8x10", 5799, "ek8tfjned"],
      ["8x12", 6399, "ek8tfkcol"],
      ["10x12", 7299, "ek8tfl1yt"],
      ["10x14", 7899, "ek8tflr91"],
      ["10x16", 8699, "ek8tfmgj9"],
      ["12x16", 9299, "f7u9dvigl"],
      ["12x20", 10599, "f7u9dw7qt"],
      ["12x24", 11699, "f7u9dwx11"],
    ],
  },
  {
    i: "3",
    t: "EZ-Fit Greenhouse Shed Kit - QUICK-SHIP",
    h: "ez-fit-greenhouse-shed-kit-quick-ship",
    v: "EZ-Fit",
    p: 5799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-greenhouse-shed-kit-main.jpg?v=1740156032",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame, optional treated bottom plate",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Gable",
      l: "3 business days production + 2\u20139 business days shipping",
      w: "No",
    },
    q: [
      ["8x10", 5799, "fpyozghmd"],
      ["8x12", 6399, "fpyozh6wl"],
      ["10x12", 7299, "fpyozhw6t"],
      ["12x20", 10599, "fpyozilh1"],
    ],
  },
  {
    i: "4",
    t: "Little Cottage Co. 12x12 Octagon Greenhouse",
    h: "little-cottage-company-12-x-12-octagon-garden-shed-greenhouse",
    v: "Little Cottage Co.",
    p: 14799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/12x12-garden-shed-greenhouse-view.jpg?v=1759764620",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 14799, "e0sfsakvp"],
    ],
  },
  {
    i: "5",
    t: "Little Cottage Co. 8x8 Octagon Greenhouse Kit",
    h: "little-cottage-company-8-x-8-octagon-greenhouse-shed",
    v: "Little Cottage Co.",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-octagon-greenhouse-kit-view.jpg?v=1759763977",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Tempered glass windows, OSB roof sheathing",
      r: "Octagonal / pyramidal",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 7899, "e0sib2j3p"],
    ],
  },
  {
    i: "6",
    t: "Little Cottage Co. Colonial Gable Greenhouse",
    h: "little-cottage-company-colonial-gable-greenhouse-shed-kit",
    v: "Little Cottage Co.",
    p: 6499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/products/colonial-gable-greenhouse-8x12-panelized-409604.webp?v=1695738864",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Corrugated polycarbonate roof panels",
      r: "Gable",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["8ft x 8ft", 6499, "e0umlipth"],
      ["8ft x 12ft", 7699, "e0umlk4dx"],
      ["8ft x 16ft", 9499, "e0umlliyd"],
      ["10ft x 12ft", 8299, "e0umlmxit"],
      ["10ft x 14ft", 9499, "e0umlnmt1"],
      ["10ft x 16ft", 10399, "e0umloc39"],
    ],
  },
  {
    i: "7",
    t: "Little Cottage Co. Petite Greenhouse Kit",
    h: "little-cottage-company-petite-greenhouse",
    v: "Little Cottage Co.",
    p: 2399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-company-petite-greenhouse-front.jpg?v=1759767147",
    s: {
      m: "LP SmartSide engineered wood + 2x4 frame",
      g: "Sunsky corrugated polycarbonate (Soft White)",
      r: "Lean-to / single slope",
      l: "4\u20136 weeks production + 2\u20139 days shipping",
      w: "Yes",
    },
    q: [
      ["Default Title", 2399, "e0uoehhdh"],
    ],
  },
  {
    i: "8",
    t: "Outdoor Living Today 8x8 Cedar Greenhouse",
    h: "outdoor-living-today-8x8-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 3999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x8-cedar-greenhouse.webp?v=1712353579",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 3999, "fb1pvtqut"],
    ],
  },
  {
    i: "9",
    t: "Outdoor Living Today 8x12 Cedar Greenhouse",
    h: "outdoor-living-today-8x12-cedar-greenhouse",
    v: "Outdoor Living Today",
    p: 4999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-8x12-cedar-greenhouse.jpg?v=1712334460",
    s: {
      m: "Western Red Cedar",
      g: "6mm Polygal twin-wall polycarbonate",
      r: "Gable",
      l: "7 days production + 5\u20137 days (west) / 7\u201310 days (east)",
      w: "N/A",
    },
    q: [
      ["Default Title", 4999, "fb0xgj12t"],
    ],
  },
  {
    i: "10",
    t: "Riverstone MONT Greenhouse",
    h: "riverstone-industries-monticello-black-greenhouse",
    v: "Riverstone",
    p: 3149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x8-mont-greenhouse.jpg?v=1756399184",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 3149, "evunpyat1"],
      ["8x12'", 4149, "evunpz039"],
      ["8x16'", 5099, "evunpzpdh"],
      ["8x20'", 6149, "evunq0enp"],
      ["8x24'", 6999, "evunq13xx"],
    ],
  },
  {
    i: "11",
    t: "Riverstone MONT Greenhouse - Premium Package",
    h: "riverstone-industries-monticello-black-greenhouse-premium",
    v: "Riverstone",
    p: 4149,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-8x12-mont-greenhouse-side.webp?v=1725474944",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 4149, "evvp9sab9"],
      ["8x12'", 4999, "evvp9szlh"],
      ["8x16'", 6099, "evvp9tovp"],
      ["8x20'", 7199, "evvp9ue5x"],
      ["8x24'", 7949, "evvp9v3g5"],
    ],
  },
  {
    i: "12",
    t: "Riverstone MONT Greenhouse - Mojave Package",
    h: "riverstone-industries-monticello-mojave-greenhouse",
    v: "Riverstone",
    p: 6799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x16-mojave-black-greenhouse-top-view.webp?v=1725909423",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 6799, "evwwff705"],
      ["8x16'", 7299, "evwwffwad"],
      ["8x20'", 7799, "evwwfglkl"],
      ["8x24'", 8699, "evwwfhaut"],
    ],
  },
  {
    i: "13",
    t: "Riverstone MONT Greenhouse - Moheat Package",
    h: "riverstone-industries-monticello-moheat-edition-black-finish-greenhouse-with-heater",
    v: "Riverstone",
    p: 7549,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-moheat-greenhouse-main.jpg?v=1726177659",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x12'", 7549, "ew0pryf5h"],
      ["8x16'", 8049, "ew0prz4fp"],
      ["8x20'", 8549, "ew0prztpx"],
      ["8x24'", 9349, "ew0ps0j05"],
    ],
  },
  {
    i: "14",
    t: "Riverstone MONT Greenhouse - Growers Package",
    h: "riverstone-industries-monticello-greenhouse-growers-edition",
    v: "Riverstone",
    p: 6399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/riverstone-industries-mont-greenhouse-growers-edition.jpg?v=1726589737",
    s: {
      m: "Commercial-grade extruded aluminum (black powder-coated)",
      g: "8mm twin-wall polycarbonate",
      r: "Gable",
      l: "3\u20135 business days, ships FedEx Ground",
      w: "N/A",
    },
    q: [
      ["8x8'", 6399, "ew1t134tx"],
      ["8x12'", 7099, "ew1t13u45"],
      ["8x16'", 8299, "ew1t14jed"],
      ["8x20'", 9099, "ew1t158ol"],
      ["8x24'", 9999, "ew1t15xyt"],
    ],
  },
  {
    i: "15",
    t: "Grandio Element 6x4 Greenhouse",
    h: "grandio-element-6x4-greenhouse",
    v: "Grandio",
    p: 1099,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-element-6x4-greenhouse-front-view.jpg?v=1729783640",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic Kit", 1099, "fn5jo4gfp"],
      ["Premium Kit", 1368, "fn5jo55px"],
    ],
  },
  {
    i: "16",
    t: "Grandio Element 6x8 Greenhouse",
    h: "grandio-element-6x8-greenhouse",
    v: "Grandio",
    p: 1699,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-6x8-element-greenhouse-kit-main.webp?v=1732143404",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1699, "fn5k7xbn9"],
      ["Premium", 2048, "fn5k7y0xh"],
    ],
  },
  {
    i: "17",
    t: "Grandio Element 6x12 Greenhouse",
    h: "grandio-element-6x12-greenhouse",
    v: "Grandio",
    p: 2299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-grandio-element-6x12-basic.jpg?v=1729724584",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2299, "fn81cuzp1"],
      ["Premium", 2728, "fn81cvoz9"],
    ],
  },
  {
    i: "18",
    t: "Grandio Ascent 8x8 Greenhouse",
    h: "grandio-ascent-8x8-greenhouse",
    v: "Grandio",
    p: 1999,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x8-greenhouse-kit-main.jpg?v=1730932966",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 1999, "fn8ducpx1"],
      ["Premium", 2348, "fn8dudf79"],
    ],
  },
  {
    i: "19",
    t: "Grandio Ascent 8x12 Greenhouse",
    h: "grandio-ascent-8x12-greenhouse",
    v: "Grandio",
    p: 2799,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x12-greenhouse-kit.jpg?v=1731015892",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2799, "fn8grke9h"],
      ["Premium", 3228, "fn8grl3jp"],
    ],
  },
  {
    i: "20",
    t: "Grandio Ascent 8x16 Greenhouse",
    h: "grandio-ascent-8x16-greenhouse",
    v: "Grandio",
    p: 3599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x16-greenhouse-kit.jpg?v=1731097686",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3599, "fn8i0ecs5"],
      ["Premium", 4118, "fn8i0f22d"],
    ],
  },
  {
    i: "21",
    t: "Grandio Ascent 8x20 Greenhouse",
    h: "grandio-ascent-8x20-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-ascent-8x20-greenhouse-kit.jpg?v=1731441637",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8j3ebed"],
      ["Premium", 4998, "fn8j3f0ol"],
    ],
  },
  {
    i: "22",
    t: "Grandio Ascent 8x24 Greenhouse",
    h: "grandio-ascent-8x24-greenhouse",
    v: "Grandio",
    p: 5199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-ascent-8x24-greenhouse-kit-main.jpg?v=1732641939",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "6mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5199, "fn8jn4dh1"],
      ["Premium", 5888, "fn8jn52r9"],
    ],
  },
  {
    i: "23",
    t: "Grandio Elite 8x8 Greenhouse",
    h: "grandio-elite-8x8-greenhouse",
    v: "Grandio",
    p: 2599,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x8-greenhouse-kit-main.jpg?v=1730142085",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 2599, "fn8k35ovp"],
      ["Premium", 2948, "fn8k36e5x"],
    ],
  },
  {
    i: "24",
    t: "Grandio Elite 8x12 Greenhouse",
    h: "grandio-elite-8x12-greenhouse",
    v: "Grandio",
    p: 3499,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x12-greenhouses-kit.jpg?v=1730236532",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3499, "fn8kc2nn9"],
      ["Premium", 3928, "fn8kc3cxh"],
    ],
  },
  {
    i: "25",
    t: "Grandio Elite 8x16 Greenhouse",
    h: "grandio-elite-8x16-greenhouse",
    v: "Grandio",
    p: 4399,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-elite-8x16-greenhouse-kit-main.jpg?v=1730391680",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4399, "fn8ks5dmd"],
      ["Premium", 4918, "fn8ks62wl"],
    ],
  },
  {
    i: "26",
    t: "Grandio Elite 8x20 Greenhouse",
    h: "grandio-elite-8x20-greenhouse",
    v: "Grandio",
    p: 5299,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x20-greehouse-kit.jpg?v=1730735624",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5299, "fn8l5c5kl"],
      ["Premium", 5898, "fn8l5cuut"],
    ],
  },
  {
    i: "27",
    t: "Grandio Elite 8x24 Greenhouse",
    h: "grandio-elite-8x24-greenhouse",
    v: "Grandio",
    p: 6199,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-elite-8x24-greenhouse-kit.jpg?v=1730836212",
    s: {
      m: "Heavy-duty 1.6mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6199, "fn8lktt11"],
      ["Premium", 6888, "fn8lkuib9"],
    ],
  },
  {
    i: "28",
    t: "Grandio Summit 12x8 Greenhouse",
    h: "grandio-summit-12x8-greenhouse",
    v: "Grandio",
    p: 3899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x8-greenhouse-kit.jpg?v=1732145356",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 3899, "fn8m0zc51"],
      ["Premium", 4418, "fn8m101f9"],
    ],
  },
  {
    i: "29",
    t: "Grandio Summit 12x12 Greenhouse",
    h: "grandio-summit-12x12-greenhouse",
    v: "Grandio",
    p: 4899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-12x12-summit-greenhouse-kit-christmas.jpg?v=1732560926",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 4899, "fn8mdz391"],
      ["Premium", 5588, "fn8mdzsj9"],
    ],
  },
  {
    i: "30",
    t: "Grandio Summit 12x16 Greenhouse",
    h: "grandio-summit-12x16-greenhouse",
    v: "Grandio",
    p: 5899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x16-greenhouse-kit.jpg?v=1731545194",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 5899, "fn9ed1gs5"],
      ["Premium", 6818, "fn9ed262d"],
    ],
  },
  {
    i: "31",
    t: "Grandio Summit 12x20 Greenhouse",
    h: "grandio-summit-12x20-greenhouse",
    v: "Grandio",
    p: 6899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-summit-12x20-greenhouse-kit-main.jpg?v=1732644686",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 6899, "fn9gk1ws5"],
      ["Premium", 7988, "fn9gk2m2d"],
    ],
  },
  {
    i: "32",
    t: "Grandio Summit 12x24 Greenhouse",
    h: "grandio-summit-12x24-greenhouse",
    v: "Grandio",
    p: 7899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x24-greenhouse-kit.jpg?v=1731595437",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 7899, "fn9i4xws5"],
      ["Premium", 9158, "fn9i4ym2d"],
    ],
  },
  {
    i: "33",
    t: "Grandio Summit 12x28 Greenhouse",
    h: "grandio-summit-12x28-greenhouse-kit",
    v: "Grandio",
    p: 8899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/summit-12x28-greenhouse-kit-full-view.jpg?v=1732643940",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 8899, "fn9j6mtdh"],
      ["Premium", 10328, "fn9j6ninp"],
    ],
  },
  {
    i: "34",
    t: "Grandio Summit 12x32 Greenhouse",
    h: "grandio-summit-12x32-greenhouse",
    v: "Grandio",
    p: 9899,
    g: "https://cdn.shopify.com/s/files/1/1890/0221/files/grandio-greenhouses-summit-12x32-greenhouse-kit.jpg?v=1731615382",
    s: {
      m: "Heavy-duty 1.66mm powder-coated aluminum",
      g: "10mm twin-wall UV-protected polycarbonate",
      r: "Gable",
      l: "1\u20132 days + 1\u20137 business days shipping",
      w: "N/A",
    },
    q: [
      ["Basic", 9899, "fn9k9f1v9"],
      ["Premium", 11498, "fn9k9fr5h"],
    ],
  }
],
        S = [null, null],
        V = [0, 0],
        A = 0,
        R = document.getElementById("hs-greenhouse-compare"),
        E = document.getElementById("hsScOverlay"),
        L = document.getElementById("hsScList"),
        Q = document.getElementById("hsScSearch"),
        C = document.getElementById("hsScCompare"),
        X = document.getElementById("hsScClose"),
        B = [document.getElementById("hsScSlot1"), document.getElementById("hsScSlot2")];
      function e(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      function m(n) {
        if (n == null || n === "") return '<span class="hs-sc-na">Not listed</span>';
        var x = Number(n);
        if (!isFinite(x)) return e(n);
        return "$" + x.toLocaleString(undefined, { maximumFractionDigits: x % 1 ? 2 : 0 });
      }
      function qs(v) {
        return Array.isArray(v) ? v[0] : v.s;
      }
      function qp(v) {
        return Array.isArray(v) ? v[1] : v.p;
      }
      function qid(v) {
        var x = Array.isArray(v) ? v[2] : v.i;
        return x ? parseInt(x, 36) : "";
      }
      function pr(p, i) {
        var q = p.q || [];
        return q.length > 1 && q[i] ? qp(q[i]) : p.p;
      }
      function cp(p) {
        return p.c;
      }
      function ph(p, i) {
        var q = p.q || [],
          id = q.length > 1 && q[i] ? qid(q[i]) : "";
        return (
          "/products/" +
          encodeURIComponent(p.h) +
          (id ? "?variant=" + encodeURIComponent(String(id)) : "")
        );
      }
      function priceHtml(p, i) {
        var a = pr(p, i),
          b = cp(p),
          h = m(a);
        if (b && Number(b) > Number(a)) h += '<span class="hs-sc-compare-at">' + m(b) + "</span>";
        return h;
      }
      function minVi(p) {
        var q = p.q || [],
          mi = 0,
          mp = Infinity;
        if (q.length < 2) return 0;
        q.forEach(function (v, i) {
          var n = Number(qp(v));
          if (isFinite(n) && n < mp) {
            mp = n;
            mi = i;
          }
        });
        return mi;
      }
      function card(p, slot) {
        var q = p.q || [],
          vi = V[slot] || 0;
        if (q.length > 1 && !q[vi]) vi = V[slot] = minVi(p);
        var sel = "";
        if (q.length > 1)
          sel =
            '<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize' +
            slot +
            '">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize' +
            slot +
            '" class="hs-sc-size-select" data-slot="' +
            slot +
            '">' +
            q
              .map(function (v, i) {
                return (
                  '<option value="' +
                  i +
                  '"' +
                  (i === vi ? " selected" : "") +
                  ">" +
                  e(qs(v)) +
                  " - " +
                  e(m(qp(v)).replace(/<[^>]+>/g, "")) +
                  "</option>"
                );
              })
              .join("") +
            '</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';
        return (
          '<img class="hs-sc-fi" loading="lazy" src="' +
          e(p.g || "") +
          '" alt="' +
          e(p.t) +
          '"><div class="hs-sc-brand">' +
          e(p.v || "") +
          '</div><div class="hs-sc-title">' +
          e(p.t || "") +
          '</div><div class="hs-sc-price" data-price-slot="' +
          slot +
          '">' +
          priceHtml(p, vi) +
          '</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="' +
          slot +
          '" href="' +
          ph(p, vi) +
          '" target="_blank">View product</a>' +
          sel +
          '<button type="button" class="hs-sc-change" data-change="' +
          slot +
          '">Change greenhouse</button>'
        );
      }
      function empty(slot) {
        return (
          '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your ' +
          (slot ? "second" : "first") +
          " greenhouse</span>"
        );
      }
      function renderSlots() {
        for (var i = 0; i < 2; i++) {
          B[i].className = "hs-sc-slot" + (S[i] ? " hs-sc-filled" : "");
          B[i].innerHTML = S[i] ? card(S[i], i) : empty(i);
        }
        renderCompare();
      }
      function val(p, k) {
        return p && p.s && p.s[k] ? e(p.s[k]) : '<span class="hs-sc-na">Not listed</span>';
      }
      function roofv(p, slot) {
        var q = p && (p.q || []),
          vi = V[slot] || 0,
          l = q.length > 1 && q[vi] ? String(qs(q[vi])) : "";
        if (/OSB Roof/i.test(l)) return "OSB roof";
        if (/Metal Roof/i.test(l)) return "Metal roof";
        return val(p, "r");
      }
      function renderCompare() {
        if (!S[0] || !S[1]) {
          C.innerHTML = "";
          return;
        }
        var n0 = S[0] ? e(S[0].t) : "Select a greenhouse",
          n1 = S[1] ? e(S[1].t) : "Select a greenhouse";
        var rows = [
          ["Frame/Wall Material", val(S[0], "m"), val(S[1], "m")],
          ["Panels/Windows", val(S[0], "g"), val(S[1], "g")],
          ["Roof Style", val(S[0], "r"), val(S[1], "r")],
          ["Custom Door & Window Placement", val(S[0], "w"), val(S[1], "w")],
          ["Lead Time", val(S[0], "l"), val(S[1], "l")],
        ];
        C.innerHTML =
          '<div class="hs-sc-compare-table" role="table" aria-label="Selected greenhouse comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n0 +
          '</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n1 +
          "</div>" +
          rows
            .map(function (r) {
              return (
                '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">' +
                r[0] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[1] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[2] +
                "</div>"
              );
            })
            .join("") +
          "</div>";
      }
      function open(slot) {
        A = slot;
        E.classList.add("hs-sc-is-open");
        E.setAttribute("aria-hidden", "false");
        document.body.classList.add("hs-sc-lock");
        Q.value = "";
        list("");
        setTimeout(function () {
          Q.focus();
        }, 30);
      }
      function close() {
        E.classList.remove("hs-sc-is-open");
        E.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hs-sc-lock");
      }
      function list(term) {
        term = (term || "").toLowerCase();
        var items = P.filter(function (p) {
          return (
            !term ||
            (p.t || "").toLowerCase().indexOf(term) > -1 ||
            (p.v || "").toLowerCase().indexOf(term) > -1
          );
        });
        L.innerHTML =
          items
            .map(function (p) {
              return (
                '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="' +
                e(p.i) +
                '"><img loading="lazy" src="' +
                e(p.g || "") +
                '" alt="' +
                e(p.t) +
                '"><div class="hs-sc-pi-brand">' +
                e(p.v || "") +
                '</div><div class="hs-sc-pi-title">' +
                e(p.t || "") +
                '</div><div class="hs-sc-pi-price">From ' +
                m(p.p) +
                "</div></div>"
              );
            })
            .join("") || '<p class="hs-sc-na">No greenhouses found.</p>';
      }
      B.forEach(function (b, i) {
        b.addEventListener("click", function (ev) {
          if (ev.target.closest(".hs-sc-change")) {
            open(i);
            return;
          }
          if (!S[i]) open(i);
        });
      });
      R.addEventListener("change", function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains("hs-sc-size-select")) {
          var slot = Number(el.getAttribute("data-slot")),
            p = S[slot];
          V[slot] = Number(el.value) || 0;
          var price = R.querySelector('[data-price-slot="' + slot + '"]'),
            link = R.querySelector('[data-link-slot="' + slot + '"]');
          if (price && p) price.innerHTML = priceHtml(p, V[slot]);
          if (link && p) link.setAttribute("href", ph(p, V[slot]));
          renderCompare();
        }
      });
      L.addEventListener("click", function (ev) {
        var it = ev.target.closest(".hs-sc-picker-item");
        if (!it) return;
        var id = it.getAttribute("data-id"),
          p = P.find(function (x) {
            return String(x.i) === String(id);
          });
        if (p) {
          S[A] = p;
          V[A] = minVi(p);
          close();
          renderSlots();
        }
      });
      L.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          var it = ev.target.closest(".hs-sc-picker-item");
          if (it) {
            ev.preventDefault();
            it.click();
          }
        }
      });
      Q.addEventListener("input", function () {
        list(Q.value);
      });
      X.addEventListener("click", close);
      E.addEventListener("click", function (ev) {
        if (ev.target === E) close();
      });
      document.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape" && E.classList.contains("hs-sc-is-open")) close();
      });
      function curh() {
        var m = String(location.pathname || "").match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).replace(/\/$/, "") : "";
      }
      function initCurrent() {
        var h = curh(),
          p =
            h &&
            P.find(function (x) {
              return String(x.h) === h;
            });
        if (p) {
          S[0] = p;
          V[0] = minVi(p);
        }
      }
      initCurrent();
      renderSlots();

      // ===== Live price refresh (lazy fetch with optimistic render) =====
      var LIVE = {}; // handle -> { done: boolean, loading: boolean }

      function toBase36(n) {
        return Number(n).toString(36);
      }

      function centsToDollars(v) {
        var n = Number(v);
        return isFinite(n) ? n / 100 : null;
      }

      function variantId36(v) {
        return Array.isArray(v) ? v[2] : v && v.i;
      }

      function variantIdNum(v) {
        var x = variantId36(v);
        return x ? parseInt(x, 36) : null;
      }

      function findLiveVariant(data, oldVariant) {
        var oldTitle = qs(oldVariant);
        var oldIdNum = variantIdNum(oldVariant);

        return (
          data.variants.find(function (v) {
            return oldIdNum && String(v.id) === String(oldIdNum);
          }) ||
          data.variants.find(function (v) {
            return v.title === oldTitle || v.public_title === oldTitle || v.name === oldTitle;
          }) ||
          null
        );
      }

      function fetchLive(p, cb) {
        if (!p || !p.h) return;

        if (LIVE[p.h] && LIVE[p.h].done) {
          cb && cb();
          return;
        }

        if (LIVE[p.h] && LIVE[p.h].loading) {
          setTimeout(function () {
            fetchLive(p, cb);
          }, 80);
          return;
        }

        LIVE[p.h] = { loading: true, done: false };

        try {
          fetch('/products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data || !data.variants || !data.variants.length) {
                LIVE[p.h] = { loading: false, done: true };
                cb && cb();
                return;
              }

              var oldQ = p.q || [];
              var newQ = oldQ.map(function (oldVariant) {
                var match = findLiveVariant(data, oldVariant);
                if (!match) return oldVariant;

                var livePrice = centsToDollars(match.price);
                return [qs(oldVariant), livePrice != null ? livePrice : qp(oldVariant), toBase36(match.id)];
              });

              // If this product had no baked-in variant dropdown, use the storefront product-level price.
              if (!newQ.length && data.price != null) {
                var topPrice = centsToDollars(data.price);
                if (topPrice != null) p.p = topPrice;
              }

              // If variants are present, use the lowest live variant price as the product's displayed From price.
              if (newQ.length) {
                var minPrice = Infinity;
                newQ.forEach(function (v) {
                  var price = Number(qp(v));
                  if (isFinite(price) && price < minPrice) minPrice = price;
                });
                if (isFinite(minPrice)) p.p = minPrice;
                p.q = newQ;
              }

              // Update compare-at price too. Prefer product-level compare_at_price, then max variant compare_at_price.
              var liveCompareAt = centsToDollars(data.compare_at_price);
              if (liveCompareAt == null) {
                data.variants.forEach(function (v) {
                  var ca = centsToDollars(v.compare_at_price);
                  if (ca != null && (liveCompareAt == null || ca > liveCompareAt)) liveCompareAt = ca;
                });
              }
              if (liveCompareAt != null) p.c = liveCompareAt;

              LIVE[p.h] = { loading: false, done: true };
              cb && cb();
            })
            .catch(function () {
              LIVE[p.h] = { loading: false, done: false };
            });
        } catch (e) {
          LIVE[p.h] = { loading: false, done: false };
        }
      }

      function refreshSlot(slot, preferMinVariant) {
        var p = S[slot];
        if (!p) return;

        var beforeIndex = V[slot] || 0;
        var beforeVariant = p.q && p.q[beforeIndex] ? p.q[beforeIndex] : null;
        var beforeTitle = beforeVariant ? qs(beforeVariant) : null;
        var beforeId = beforeVariant ? variantId36(beforeVariant) : null;

        fetchLive(p, function () {
          if (preferMinVariant) {
            V[slot] = minVi(p);
          } else if (p.q && p.q.length && beforeVariant) {
            var matchedIndex = p.q.findIndex(function (v) {
              return (beforeId && variantId36(v) === beforeId) || (beforeTitle && qs(v) === beforeTitle);
            });
            V[slot] = matchedIndex > -1 ? matchedIndex : Math.min(beforeIndex, p.q.length - 1);
          }
          renderSlots();
        });
      }

      // Refresh slot 1, the auto-loaded current product, shortly after load.
      if (S[0]) {
        setTimeout(function () {
          refreshSlot(0, true);
        }, 50);
      }

      // Hook into the modal-pick handler. The original picker handler stays intact;
      // this runs one tick later, after S[A] has been updated.
      L.addEventListener('click', function (ev) {
        var it = ev.target.closest('.hs-sc-picker-item');
        if (!it) return;
        setTimeout(function () {
          refreshSlot(A, true);
        }, 0);
      });

      // Preserve a user's selected variant when they change the dropdown and live data is not fetched yet.
      R.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains('hs-sc-size-select')) {
          var slot = Number(el.getAttribute('data-slot'));
          setTimeout(function () {
            refreshSlot(slot, false);
          }, 0);
        }
      });

      // Background-prefetch picker product prices once the modal opens.
      var _origOpen = open;
      open = function (slot) {
        _origOpen(slot);
        var i = 0;
        function prefetchNext() {
          if (i >= P.length) return;
          var p = P[i++];
          if (p && p.h && !(LIVE[p.h] && LIVE[p.h].done)) {
            fetchLive(p, function () {
              if (E.classList.contains('hs-sc-is-open')) list(Q.value);
            });
          }
          setTimeout(prefetchNext, 60);
        }
        prefetchNext();
      };
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-lcc-colonial-five-corner-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-lcc");
    if (!root) return;

    const zipEl = document.getElementById("hsrZipLcc");
    const productEl = document.getElementById("hsrProductLcc");
    const btn = document.getElementById("hsrGoLcc");
    const clr = document.getElementById("hsrClearLcc");
    const err = document.getElementById("hsrErrLcc");
    const out = document.getElementById("hsrOutLcc");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_lcc_production_live_v2_20260314";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    const PRODUCT_MAP = {
      value_gable: {
        label: "Little Cottage Co. Value Gable Shed",
        bucket: "value"
      },
      value_workshop: {
        label: "Little Cottage Co. Value Workshop Shed",
        bucket: "value"
      },
      value_gambrel_4: {
        label: "Little Cottage Co. Value Gambrel Barn 4' Sidewalls",
        bucket: "value"
      },
      value_gambrel_6: {
        label: "Little Cottage Co. Value Gambrel Barn 6' Sidewalls",
        bucket: "value"
      },

      classic_gable: {
        label: "Little Cottage Co. Classic Gable Shed",
        bucket: "classic_precut"
      },
      classic_workshop: {
        label: "Little Cottage Co. Classic Workshop Shed",
        bucket: "classic_precut"
      },
      classic_gambrel_4: {
        label: "Little Cottage Co. Classic Gambrel Barn 4' Sidewalls",
        bucket: "classic_precut"
      },
      classic_gambrel_6: {
        label: "Little Cottage Co. Classic Gambrel Barn 6' Sidewalls",
        bucket: "classic_precut"
      },
      classic_gambrel_large: {
        label: "Little Cottage Co. Classic Gambrel Large Barn",
        bucket: "classic_precut"
      },
      classic_five_corner: {
        label: "Little Cottage Co. Classic Five Corner Shed",
        bucket: "classic_five_corner"
      },

      colonial_williamsburg: {
        label: "Little Cottage Co. Colonial Williamsburg Shed",
        bucket: "colonial_precut"
      },
      colonial_pinehurst: {
        label: "Little Cottage Co. Colonial Pinehurst Shed",
        bucket: "colonial_precut"
      },
      colonial_five_corner: {
        label: "Little Cottage Co. Colonial Five Corner Shed",
        bucket: "colonial_five_corner"
      },

      star_barn: {
        label: "Little Cottage Co. Star Barn",
        bucket: "specialty_barn"
      },

      cape_cod_playhouse: {
        label: "Little Cottage Co. Cape Cod Playhouse",
        bucket: "playhouse"
      },
      victorian_playhouse: {
        label: "Little Cottage Co. Victorian Playhouse",
        bucket: "playhouse"
      },
      gingerbread_cottage_playhouse: {
        label: "Little Cottage Co. Gingerbread Cottage Playhouse",
        bucket: "playhouse"
      },
      pennfield_cottage_playhouse: {
        label: "Little Cottage Co. Pennfield Cottage Playhouse",
        bucket: "playhouse"
      },
      craftsman_playhouse: {
        label: "Little Cottage Co. Craftsman Playhouse",
        bucket: "playhouse"
      },
      little_cottage_chapel: {
        label: "Little Cottage Co. Little Cottage Chapel",
        bucket: "playhouse"
      },
      firehouse_playhouse: {
        label: "Little Cottage Co. Firehouse Playhouse",
        bucket: "playhouse"
      },
      stratford_schoolhouse: {
        label: "Little Cottage Co. Stratford Schoolhouse",
        bucket: "playhouse"
      },
      saras_victorian_mansion: {
        label: "Little Cottage Co. Sara's Victorian Mansion",
        bucket: "playhouse"
      },
      grand_portico_mansion: {
        label: "Little Cottage Co. Grand Portico Mansion",
        bucket: "grand_portico"
      },

      colonial_gable_greenhouse: {
        label: "Little Cottage Co. Colonial Gable Greenhouse",
        bucket: "greenhouse"
      },
      octagon_greenhouse: {
        label: "Little Cottage Co. Octagon Greenhouse",
        bucket: "greenhouse"
      },
      garden_shed_greenhouse: {
        label: "Little Cottage Co. Garden Shed Greenhouse",
        bucket: "greenhouse"
      },
      petite_greenhouse: {
        label: "Little Cottage Co. Petite Greenhouse",
        bucket: "greenhouse"
      },

      value_a_frame_coop: {
        label: "Little Cottage Co. Value A-Frame Coop",
        bucket: "value_a_frame_coop"
      },
      gambrel_barn_coop: {
        label: "Little Cottage Co. Gambrel Barn Coop",
        bucket: "coop_panelized"
      },
      colonial_gable_coop: {
        label: "Little Cottage Co. Colonial Gable Coop",
        bucket: "coop_panelized"
      },
      round_roof_coop: {
        label: "Little Cottage Co. Round Roof Coop",
        bucket: "coop_panelized"
      },

      cape_cod_cozy_kennel: {
        label: "Little Cottage Co. Cape Cod Cozy Kennel",
        bucket: "dog_kennel"
      },
      victorian_cozy_kennel: {
        label: "Little Cottage Co. Victorian Cozy Kennel",
        bucket: "dog_kennel"
      }
    };

    const FALLBACK_PRODUCTION = {
      greenhouse: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      value: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      classic_precut: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      classic_five_corner: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      colonial_precut: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      colonial_five_corner: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      specialty_barn: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      playhouse: {
        minBd: 5,
        maxBd: 10,
        display: "1 to 2 weeks"
      },
      grand_portico: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      value_a_frame_coop: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      coop_panelized: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      dog_kennel: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      }
    };

    const STATE_TRANSIT = {
      OH: { min: 1, max: 2 },

      IN: { min: 2, max: 3 },
      MI: { min: 2, max: 3 },
      PA: { min: 2, max: 3 },
      WV: { min: 2, max: 3 },
      KY: { min: 2, max: 3 },

      IL: { min: 3, max: 4 },
      WI: { min: 3, max: 4 },
      NY: { min: 3, max: 4 },
      VA: { min: 3, max: 4 },
      MD: { min: 3, max: 4 },
      DE: { min: 3, max: 4 },
      NJ: { min: 3, max: 4 },
      TN: { min: 3, max: 4 },
      NC: { min: 3, max: 4 },
      DC: { min: 3, max: 4 },

      AL: { min: 4, max: 5 },
      AR: { min: 4, max: 5 },
      CT: { min: 4, max: 5 },
      GA: { min: 4, max: 5 },
      IA: { min: 4, max: 5 },
      LA: { min: 4, max: 5 },
      MA: { min: 4, max: 5 },
      MS: { min: 4, max: 5 },
      MO: { min: 4, max: 5 },
      NH: { min: 4, max: 5 },
      RI: { min: 4, max: 5 },
      SC: { min: 4, max: 5 },
      VT: { min: 4, max: 5 },

      FL: { min: 5, max: 6 },
      KS: { min: 5, max: 6 },
      ME: { min: 5, max: 6 },
      MN: { min: 5, max: 6 },
      NE: { min: 5, max: 6 },
      OK: { min: 5, max: 6 },
      SD: { min: 5, max: 6 },

      CO: { min: 6, max: 7 },
      ND: { min: 6, max: 7 },
      NM: { min: 6, max: 7 },
      TX: { min: 6, max: 7 },
      WY: { min: 6, max: 7 },

      AZ: { min: 7, max: 8 },
      ID: { min: 7, max: 8 },
      MT: { min: 7, max: 8 },
      NV: { min: 7, max: 8 },
      UT: { min: 7, max: 8 },

      CA: { min: 9, max: 9 },
      OR: { min: 9, max: 9 },
      WA: { min: 9, max: 9 },

      AK: { min: null, max: null, blocked: true },
      HI: { min: null, max: null, blocked: true }
    };

    const STATE_NAMES = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "Washington DC",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming"
    };

    const ZIP_STATE_RANGES = [
      ["AK", 995, 999],
      ["AL", 350, 369],
      ["AR", 716, 729],
      ["AZ", 850, 865],
      ["CA", 900, 961],
      ["CO", 800, 816],
      ["CT", 60, 69],
      ["DC", 200, 205],
      ["DE", 197, 199],
      ["FL", 320, 349],
      ["GA", 300, 319],
      ["HI", 967, 968],
      ["IA", 500, 528],
      ["ID", 832, 838],
      ["IL", 600, 629],
      ["IN", 460, 479],
      ["KS", 660, 679],
      ["KY", 400, 427],
      ["LA", 700, 714],
      ["MA", 10, 27],
      ["MD", 206, 219],
      ["ME", 39, 49],
      ["MI", 480, 499],
      ["MN", 550, 567],
      ["MO", 630, 658],
      ["MS", 386, 397],
      ["MT", 590, 599],
      ["NC", 270, 289],
      ["ND", 580, 588],
      ["NE", 680, 693],
      ["NH", 30, 38],
      ["NJ", 70, 89],
      ["NM", 870, 884],
      ["NV", 889, 898],
      ["NY", 100, 149],
      ["OH", 430, 459],
      ["OK", 730, 749],
      ["OR", 970, 979],
      ["PA", 150, 196],
      ["RI", 28, 29],
      ["SC", 290, 299],
      ["SD", 570, 577],
      ["TN", 370, 385],
      ["TX", 750, 799],
      ["TX", 885, 885],
      ["UT", 840, 847],
      ["VA", 201, 246],
      ["VT", 50, 59],
      ["WA", 980, 994],
      ["WI", 530, 549],
      ["WV", 247, 268],
      ["WY", 820, 831]
    ];

    const cleanZip = (value) => String(value || "").replace(/\D/g, "").slice(0, 5);
    const isValidZip = (value) => /^\d{5}$/.test(value);

    const showErr = (on, msg) => {
      err.textContent = msg || "Enter a valid 5-digit ZIP.";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();

        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    function getStateFromZip(zip) {
      const prefix = Number(zip.slice(0, 3));

      for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
        const [state, min, max] = ZIP_STATE_RANGES[i];

        if (prefix >= min && prefix <= max) {
          return state;
        }
      }

      return "";
    }

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");

        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;

        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    function toBusinessDayRange(min, max, unit) {
      if (unit === "weeks") {
        return {
          minBd: Number(min) * 5,
          maxBd: Number(max) * 5,
          display: `${min} to ${max} weeks`
        };
      }

      return {
        minBd: Number(min),
        maxBd: Number(max),
        display: `${min} to ${max} business days`
      };
    }

    function normalizeLeadPageText(text) {
      return String(text || "")
        .replace(/\u00a0/g, " ")
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
    }

    function parseRange(text, regex, unit) {
      const match = text.match(regex);
      if (!match) return null;

      return toBusinessDayRange(match[1], match[2], unit);
    }

    async function fetchFreshProductionData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const rawText = doc.body ? doc.body.innerText || doc.body.textContent || html : html;
      const text = normalizeLeadPageText(rawText);

      const parsed = {
        ...FALLBACK_PRODUCTION
      };

      const greenhouse = parseRange(
        text,
        /greenhouses\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const value = parseRange(
        text,
        /value\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days/i,
        "business_days"
      );

      const classicPrecut = parseRange(
        text,
        /classic\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+precut\s+kits/i,
        "business_days"
      );

      const classicFiveCorner = parseRange(
        text,
        /classic\s+five[\s-]*corner\s+shed\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const colonialPrecut = parseRange(
        text,
        /colonial\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+precut\s+kits/i,
        "business_days"
      );

      const colonialFiveCorner = parseRange(
        text,
        /colonial\s+five[\s-]*corner\s+shed\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const specialtyBarn = parseRange(
        text,
        /specialty\s+barns.*?(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const playhouse = parseRange(
        text,
        /playhouses\s+(?:are|is)\s+generally\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const grandPortico = parseRange(
        text,
        /grand\s+portico\s+mansion\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const valueAFrameCoop = parseRange(
        text,
        /chicken\s+coops\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+the\s+value\s+a[\s-]*frame\s+coop/i,
        "business_days"
      );

      const coopPanelized = parseRange(
        text,
        /chicken\s+coops.*?and\s+(\d+)\s+to\s+(\d+)\s+weeks\s+for\s+the\s+gambrel\s+barn\s+coop,\s+colonial\s+gable\s+coop,\s+and\s+round\s+roof\s+coop/i,
        "weeks"
      );

      const dogKennel = parseRange(
        text,
        /dog\s+kennels\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      if (greenhouse) parsed.greenhouse = greenhouse;
      if (value) parsed.value = value;
      if (classicPrecut) parsed.classic_precut = classicPrecut;
      if (classicFiveCorner) parsed.classic_five_corner = classicFiveCorner;
      if (colonialPrecut) parsed.colonial_precut = colonialPrecut;
      if (colonialFiveCorner) parsed.colonial_five_corner = colonialFiveCorner;
      if (specialtyBarn) parsed.specialty_barn = specialtyBarn;
      if (playhouse) parsed.playhouse = playhouse;
      if (grandPortico) parsed.grand_portico = grandPortico;
      if (valueAFrameCoop) parsed.value_a_frame_coop = valueAFrameCoop;
      if (coopPanelized) parsed.coop_panelized = coopPanelized;
      if (dogKennel) parsed.dog_kennel = dogKennel;

      writeCache(parsed);
      return parsed;
    }

    async function getProductionData() {
      const cached = readCache();
      if (cached) return cached;

      return fetchFreshProductionData();
    }

    function renderTable(
      productTitle,
      productionDisplay,
      destinationStateName,
      prodMinBd,
      prodMaxBd,
      transitMin,
      transitMax
    ) {
      const today = new Date();
      const earliestBD = prodMinBd + transitMin;
      const latestBD = prodMaxBd + transitMax;
      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const transitText =
        transitMin === transitMax
          ? `${transitMin} business days`
          : `${transitMin} to ${transitMax} business days`;

      const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      out.innerHTML = `
        <table aria-label="Delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
            <tr><th>Production lead time</th><td>${productionDisplay}</td></tr>
            <tr><th>Transit time</th><td>${transitText}</td></tr>
            <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Holidays and carrier delays can shift delivery.
        </p>
      `;
    }

    btn.addEventListener("click", async () => {
      const zip = cleanZip(zipEl.value);
      const selectedKey = productEl.value;

      zipEl.value = zip;

      if (!isValidZip(zip)) {
        out.innerHTML = "";
        showErr(true, "Enter a valid 5-digit ZIP.");
        return;
      }

      if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
        out.innerHTML = "";
        showErr(true, "Please choose the exact Little Cottage Co. product.");
        return;
      }

      const destinationState = getStateFromZip(zip);

      if (!destinationState) {
        out.innerHTML = "";
        showErr(true, "Could not match that ZIP code to a supported U.S. state.");
        return;
      }

      const transit = STATE_TRANSIT[destinationState];

      if (!transit || transit.blocked) {
        out.innerHTML = "";
        showErr(true, "We do not currently ship Little Cottage Co. products to Alaska or Hawaii.");
        return;
      }

      showErr(false);

      try {
        const production = await getProductionData();
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod =
          production[selectedProduct.bucket] || FALLBACK_PRODUCTION[selectedProduct.bucket];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load Little Cottage Co. lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          prod.display,
          STATE_NAMES[destinationState] || destinationState,
          prod.minBd,
          prod.maxBd,
          transit.min,
          transit.max
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "hsr_delivery_estimate_lcc_state_transit",
          zip,
          destination_state: destinationState,
          selected_product_key: selectedKey,
          selected_product_label: selectedProduct.label,
          lcc_bucket: selectedProduct.bucket
        });
      } catch (e) {
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod = FALLBACK_PRODUCTION[selectedProduct.bucket];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load Little Cottage Co. lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          prod.display,
          STATE_NAMES[destinationState] || destinationState,
          prod.minBd,
          prod.maxBd,
          transit.min,
          transit.max
        );

        showErr(false);
      }
    });

    clr.addEventListener("click", () => {
      zipEl.value = "";
      productEl.value = "";
      out.innerHTML = "";
      showErr(false);
    });

    window.hsrLccClearProductionCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
      } catch (e) {}
    };

    window.hsrLccReadProductionCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-lcc-delivery-tool-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById("hsr-delivery-lcc");
    if (!root) return;

    const zipEl = document.getElementById("hsrZipLcc");
    const productEl = document.getElementById("hsrProductLcc");
    const btn = document.getElementById("hsrGoLcc");
    const clr = document.getElementById("hsrClearLcc");
    const err = document.getElementById("hsrErrLcc");
    const out = document.getElementById("hsrOutLcc");

    const LEAD_PAGE = "/pages/lead-time-and-estimated-delivery-dates";
    const CACHE_KEY = "hsr_lcc_production_live_v2_20260314";
    const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    const PRODUCT_MAP = {
      value_gable: {
        label: "Little Cottage Co. Value Gable Shed",
        bucket: "value"
      },
      value_workshop: {
        label: "Little Cottage Co. Value Workshop Shed",
        bucket: "value"
      },
      value_gambrel_4: {
        label: "Little Cottage Co. Value Gambrel Barn 4' Sidewalls",
        bucket: "value"
      },
      value_gambrel_6: {
        label: "Little Cottage Co. Value Gambrel Barn 6' Sidewalls",
        bucket: "value"
      },

      classic_gable: {
        label: "Little Cottage Co. Classic Gable Shed",
        bucket: "classic_precut"
      },
      classic_workshop: {
        label: "Little Cottage Co. Classic Workshop Shed",
        bucket: "classic_precut"
      },
      classic_gambrel_4: {
        label: "Little Cottage Co. Classic Gambrel Barn 4' Sidewalls",
        bucket: "classic_precut"
      },
      classic_gambrel_6: {
        label: "Little Cottage Co. Classic Gambrel Barn 6' Sidewalls",
        bucket: "classic_precut"
      },
      classic_gambrel_large: {
        label: "Little Cottage Co. Classic Gambrel Large Barn",
        bucket: "classic_precut"
      },
      classic_five_corner: {
        label: "Little Cottage Co. Classic Five Corner Shed",
        bucket: "classic_five_corner"
      },

      colonial_williamsburg: {
        label: "Little Cottage Co. Colonial Williamsburg Shed",
        bucket: "colonial_precut"
      },
      colonial_pinehurst: {
        label: "Little Cottage Co. Colonial Pinehurst Shed",
        bucket: "colonial_precut"
      },
      colonial_five_corner: {
        label: "Little Cottage Co. Colonial Five Corner Shed",
        bucket: "colonial_five_corner"
      },

      star_barn: {
        label: "Little Cottage Co. Star Barn",
        bucket: "specialty_barn"
      },

      cape_cod_playhouse: {
        label: "Little Cottage Co. Cape Cod Playhouse",
        bucket: "playhouse"
      },
      victorian_playhouse: {
        label: "Little Cottage Co. Victorian Playhouse",
        bucket: "playhouse"
      },
      gingerbread_cottage_playhouse: {
        label: "Little Cottage Co. Gingerbread Cottage Playhouse",
        bucket: "playhouse"
      },
      pennfield_cottage_playhouse: {
        label: "Little Cottage Co. Pennfield Cottage Playhouse",
        bucket: "playhouse"
      },
      craftsman_playhouse: {
        label: "Little Cottage Co. Craftsman Playhouse",
        bucket: "playhouse"
      },
      little_cottage_chapel: {
        label: "Little Cottage Co. Little Cottage Chapel",
        bucket: "playhouse"
      },
      firehouse_playhouse: {
        label: "Little Cottage Co. Firehouse Playhouse",
        bucket: "playhouse"
      },
      stratford_schoolhouse: {
        label: "Little Cottage Co. Stratford Schoolhouse",
        bucket: "playhouse"
      },
      saras_victorian_mansion: {
        label: "Little Cottage Co. Sara's Victorian Mansion",
        bucket: "playhouse"
      },
      grand_portico_mansion: {
        label: "Little Cottage Co. Grand Portico Mansion",
        bucket: "grand_portico"
      },

      colonial_gable_greenhouse: {
        label: "Little Cottage Co. Colonial Gable Greenhouse",
        bucket: "greenhouse"
      },
      octagon_greenhouse: {
        label: "Little Cottage Co. Octagon Greenhouse",
        bucket: "greenhouse"
      },
      garden_shed_greenhouse: {
        label: "Little Cottage Co. Garden Shed Greenhouse",
        bucket: "greenhouse"
      },
      petite_greenhouse: {
        label: "Little Cottage Co. Petite Greenhouse",
        bucket: "greenhouse"
      },

      value_a_frame_coop: {
        label: "Little Cottage Co. Value A-Frame Coop",
        bucket: "value_a_frame_coop"
      },
      gambrel_barn_coop: {
        label: "Little Cottage Co. Gambrel Barn Coop",
        bucket: "coop_panelized"
      },
      colonial_gable_coop: {
        label: "Little Cottage Co. Colonial Gable Coop",
        bucket: "coop_panelized"
      },
      round_roof_coop: {
        label: "Little Cottage Co. Round Roof Coop",
        bucket: "coop_panelized"
      },

      cape_cod_cozy_kennel: {
        label: "Little Cottage Co. Cape Cod Cozy Kennel",
        bucket: "dog_kennel"
      },
      victorian_cozy_kennel: {
        label: "Little Cottage Co. Victorian Cozy Kennel",
        bucket: "dog_kennel"
      }
    };

    const FALLBACK_PRODUCTION = {
      greenhouse: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      value: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      classic_precut: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      classic_five_corner: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      colonial_precut: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      colonial_five_corner: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      specialty_barn: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      playhouse: {
        minBd: 5,
        maxBd: 10,
        display: "1 to 2 weeks"
      },
      grand_portico: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      value_a_frame_coop: {
        minBd: 5,
        maxBd: 10,
        display: "5 to 10 business days"
      },
      coop_panelized: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      },
      dog_kennel: {
        minBd: 10,
        maxBd: 20,
        display: "2 to 4 weeks"
      }
    };

    const STATE_TRANSIT = {
      OH: { min: 1, max: 2 },

      IN: { min: 2, max: 3 },
      MI: { min: 2, max: 3 },
      PA: { min: 2, max: 3 },
      WV: { min: 2, max: 3 },
      KY: { min: 2, max: 3 },

      IL: { min: 3, max: 4 },
      WI: { min: 3, max: 4 },
      NY: { min: 3, max: 4 },
      VA: { min: 3, max: 4 },
      MD: { min: 3, max: 4 },
      DE: { min: 3, max: 4 },
      NJ: { min: 3, max: 4 },
      TN: { min: 3, max: 4 },
      NC: { min: 3, max: 4 },
      DC: { min: 3, max: 4 },

      AL: { min: 4, max: 5 },
      AR: { min: 4, max: 5 },
      CT: { min: 4, max: 5 },
      GA: { min: 4, max: 5 },
      IA: { min: 4, max: 5 },
      LA: { min: 4, max: 5 },
      MA: { min: 4, max: 5 },
      MS: { min: 4, max: 5 },
      MO: { min: 4, max: 5 },
      NH: { min: 4, max: 5 },
      RI: { min: 4, max: 5 },
      SC: { min: 4, max: 5 },
      VT: { min: 4, max: 5 },

      FL: { min: 5, max: 6 },
      KS: { min: 5, max: 6 },
      ME: { min: 5, max: 6 },
      MN: { min: 5, max: 6 },
      NE: { min: 5, max: 6 },
      OK: { min: 5, max: 6 },
      SD: { min: 5, max: 6 },

      CO: { min: 6, max: 7 },
      ND: { min: 6, max: 7 },
      NM: { min: 6, max: 7 },
      TX: { min: 6, max: 7 },
      WY: { min: 6, max: 7 },

      AZ: { min: 7, max: 8 },
      ID: { min: 7, max: 8 },
      MT: { min: 7, max: 8 },
      NV: { min: 7, max: 8 },
      UT: { min: 7, max: 8 },

      CA: { min: 9, max: 9 },
      OR: { min: 9, max: 9 },
      WA: { min: 9, max: 9 },

      AK: { min: null, max: null, blocked: true },
      HI: { min: null, max: null, blocked: true }
    };

    const STATE_NAMES = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "Washington DC",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming"
    };

    const ZIP_STATE_RANGES = [
      ["AK", 995, 999],
      ["AL", 350, 369],
      ["AR", 716, 729],
      ["AZ", 850, 865],
      ["CA", 900, 961],
      ["CO", 800, 816],
      ["CT", 60, 69],
      ["DC", 200, 205],
      ["DE", 197, 199],
      ["FL", 320, 349],
      ["GA", 300, 319],
      ["HI", 967, 968],
      ["IA", 500, 528],
      ["ID", 832, 838],
      ["IL", 600, 629],
      ["IN", 460, 479],
      ["KS", 660, 679],
      ["KY", 400, 427],
      ["LA", 700, 714],
      ["MA", 10, 27],
      ["MD", 206, 219],
      ["ME", 39, 49],
      ["MI", 480, 499],
      ["MN", 550, 567],
      ["MO", 630, 658],
      ["MS", 386, 397],
      ["MT", 590, 599],
      ["NC", 270, 289],
      ["ND", 580, 588],
      ["NE", 680, 693],
      ["NH", 30, 38],
      ["NJ", 70, 89],
      ["NM", 870, 884],
      ["NV", 889, 898],
      ["NY", 100, 149],
      ["OH", 430, 459],
      ["OK", 730, 749],
      ["OR", 970, 979],
      ["PA", 150, 196],
      ["RI", 28, 29],
      ["SC", 290, 299],
      ["SD", 570, 577],
      ["TN", 370, 385],
      ["TX", 750, 799],
      ["TX", 885, 885],
      ["UT", 840, 847],
      ["VA", 201, 246],
      ["VT", 50, 59],
      ["WA", 980, 994],
      ["WI", 530, 549],
      ["WV", 247, 268],
      ["WY", 820, 831]
    ];

    const normalize = (value) =>
      String(value || "")
        .toLowerCase()
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\u00a0/g, " ")
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanZip = (value) => String(value || "").replace(/\D/g, "").slice(0, 5);
    const isValidZip = (value) => /^\d{5}$/.test(value);

    const showErr = (on, msg) => {
      err.textContent = msg || "Enter a valid 5-digit ZIP.";
      err.classList.toggle("is-active", !!on);
    };

    const addBusinessDays = (startDate, businessDays) => {
      const d = new Date(startDate.getTime());
      let added = 0;

      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();

        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }

      return d;
    };

    const fmtDate = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });

    function getStateFromZip(zip) {
      const prefix = Number(zip.slice(0, 3));

      for (let i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
        const [state, min, max] = ZIP_STATE_RANGES[i];

        if (prefix >= min && prefix <= max) {
          return state;
        }
      }

      return "";
    }

    function readCache() {
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");

        if (!cached || !cached.ts || !cached.data) return null;
        if (Date.now() - cached.ts >= CACHE_TTL_MS) return null;

        return cached.data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            ts: Date.now(),
            data
          })
        );
      } catch (e) {}
    }

    function toBusinessDayRange(min, max, unit) {
      if (unit === "weeks") {
        return {
          minBd: Number(min) * 5,
          maxBd: Number(max) * 5,
          display: `${min} to ${max} weeks`
        };
      }

      return {
        minBd: Number(min),
        maxBd: Number(max),
        display: `${min} to ${max} business days`
      };
    }

    function normalizeLeadPageText(text) {
      return String(text || "")
        .replace(/\u00a0/g, " ")
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
    }

    function parseRange(text, regex, unit) {
      const match = text.match(regex);
      if (!match) return null;

      return toBusinessDayRange(match[1], match[2], unit);
    }

    async function fetchFreshProductionData() {
      const refreshUrl =
        LEAD_PAGE +
        (LEAD_PAGE.includes("?") ? "&" : "?") +
        "hsr_refresh=" +
        encodeURIComponent(Date.now());

      const res = await fetch(refreshUrl, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) {
        throw new Error("Lead time page fetch failed");
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const rawText = doc.body ? doc.body.innerText || doc.body.textContent || html : html;
      const text = normalizeLeadPageText(rawText);

      const parsed = {
        ...FALLBACK_PRODUCTION
      };

      const greenhouse = parseRange(
        text,
        /greenhouses\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const value = parseRange(
        text,
        /value\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days/i,
        "business_days"
      );

      const classicPrecut = parseRange(
        text,
        /classic\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+precut\s+kits/i,
        "business_days"
      );

      const classicFiveCorner = parseRange(
        text,
        /classic\s+five[\s-]*corner\s+shed\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const colonialPrecut = parseRange(
        text,
        /colonial\s+series\s+sheds\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+precut\s+kits/i,
        "business_days"
      );

      const colonialFiveCorner = parseRange(
        text,
        /colonial\s+five[\s-]*corner\s+shed\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const specialtyBarn = parseRange(
        text,
        /specialty\s+barns.*?(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const playhouse = parseRange(
        text,
        /playhouses\s+(?:are|is)\s+generally\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const grandPortico = parseRange(
        text,
        /grand\s+portico\s+mansion\s+(?:is|are)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      const valueAFrameCoop = parseRange(
        text,
        /chicken\s+coops\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+business\s+days\s+for\s+the\s+value\s+a[\s-]*frame\s+coop/i,
        "business_days"
      );

      const coopPanelized = parseRange(
        text,
        /chicken\s+coops.*?and\s+(\d+)\s+to\s+(\d+)\s+weeks\s+for\s+the\s+gambrel\s+barn\s+coop,\s+colonial\s+gable\s+coop,\s+and\s+round\s+roof\s+coop/i,
        "weeks"
      );

      const dogKennel = parseRange(
        text,
        /dog\s+kennels\s+(?:are|is)\s+(\d+)\s+to\s+(\d+)\s+weeks/i,
        "weeks"
      );

      if (greenhouse) parsed.greenhouse = greenhouse;
      if (value) parsed.value = value;
      if (classicPrecut) parsed.classic_precut = classicPrecut;
      if (classicFiveCorner) parsed.classic_five_corner = classicFiveCorner;
      if (colonialPrecut) parsed.colonial_precut = colonialPrecut;
      if (colonialFiveCorner) parsed.colonial_five_corner = colonialFiveCorner;
      if (specialtyBarn) parsed.specialty_barn = specialtyBarn;
      if (playhouse) parsed.playhouse = playhouse;
      if (grandPortico) parsed.grand_portico = grandPortico;
      if (valueAFrameCoop) parsed.value_a_frame_coop = valueAFrameCoop;
      if (coopPanelized) parsed.coop_panelized = coopPanelized;
      if (dogKennel) parsed.dog_kennel = dogKennel;

      writeCache(parsed);
      return parsed;
    }

    async function getProductionData() {
      const cached = readCache();
      if (cached) return cached;

      return fetchFreshProductionData();
    }

    function getCurrentProductHandleFromUrl() {
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).trim() : "";
    }

    function getCurrentProductTitleFromPage() {
      const selectors = [
        "h1.productView-title",
        ".productView-title",
        "h1.product-single__title",
        ".product-single__title",
        "main h1",
        "h1"
      ];

      for (let i = 0; i < selectors.length; i += 1) {
        const el = document.querySelector(selectors[i]);
        if (el && el.textContent && el.textContent.trim()) {
          return el.textContent.trim();
        }
      }

      return document.title || "";
    }

    function detectDefaultProductKey() {
      const currentHandle = getCurrentProductHandleFromUrl();
      const currentTitle = getCurrentProductTitleFromPage();

      if (!currentHandle && !currentTitle) {
        return "";
      }

      const handleNorm = normalize(currentHandle);
      const titleNorm = normalize(currentTitle);
      const combined = `${handleNorm} ${titleNorm}`;

      const hasAll = (...terms) => terms.every((term) => combined.includes(term));
      const hasAny = (...terms) => terms.some((term) => combined.includes(term));

      const exactHandleMap = {
        "little cottage co value gable shed": "value_gable",
        "little cottage co value workshop shed": "value_workshop",
        "little cottage co value gambrel barn 4 sidewalls": "value_gambrel_4",
        "little cottage co value gambrel barn 6 sidewalls": "value_gambrel_6",

        "little cottage co classic gable shed": "classic_gable",
        "little cottage co classic workshop shed": "classic_workshop",
        "little cottage co classic gambrel barn 4 sidewalls": "classic_gambrel_4",
        "little cottage co classic gambrel barn 6 sidewalls": "classic_gambrel_6",
        "little cottage co classic gambrel large barn": "classic_gambrel_large",
        "little cottage co classic five corner shed": "classic_five_corner",

        "little cottage co colonial williamsburg shed": "colonial_williamsburg",
        "little cottage co colonial pinehurst shed": "colonial_pinehurst",
        "little cottage co colonial five corner shed": "colonial_five_corner",

        "little cottage co star barn": "star_barn",

        "little cottage co cape cod playhouse": "cape_cod_playhouse",
        "little cottage co victorian playhouse": "victorian_playhouse",
        "little cottage co gingerbread cottage playhouse": "gingerbread_cottage_playhouse",
        "little cottage co pennfield cottage playhouse": "pennfield_cottage_playhouse",
        "little cottage co craftsman playhouse": "craftsman_playhouse",
        "little cottage co little cottage chapel": "little_cottage_chapel",
        "little cottage co firehouse playhouse": "firehouse_playhouse",
        "little cottage co stratford schoolhouse": "stratford_schoolhouse",
        "little cottage co sara s victorian mansion": "saras_victorian_mansion",
        "little cottage co grand portico mansion": "grand_portico_mansion",

        "little cottage co colonial gable greenhouse": "colonial_gable_greenhouse",
        "little cottage co octagon greenhouse": "octagon_greenhouse",
        "little cottage co garden shed greenhouse": "garden_shed_greenhouse",
        "little cottage co petite greenhouse": "petite_greenhouse",

        "little cottage co value a frame coop": "value_a_frame_coop",
        "little cottage co gambrel barn coop": "gambrel_barn_coop",
        "little cottage co colonial gable coop": "colonial_gable_coop",
        "little cottage co round roof coop": "round_roof_coop",

        "little cottage co cape cod cozy kennel": "cape_cod_cozy_kennel",
        "little cottage co victorian cozy kennel": "victorian_cozy_kennel"
      };

      if (exactHandleMap[handleNorm]) {
        return exactHandleMap[handleNorm];
      }

      if (hasAll("grand", "portico", "mansion")) return "grand_portico_mansion";
      if (hasAll("sara", "victorian", "mansion") || hasAll("saras", "victorian", "mansion")) return "saras_victorian_mansion";
      if (hasAll("stratford", "schoolhouse")) return "stratford_schoolhouse";
      if (hasAll("firehouse", "playhouse")) return "firehouse_playhouse";
      if (hasAll("little", "cottage", "chapel")) return "little_cottage_chapel";
      if (hasAll("gingerbread", "cottage", "playhouse")) return "gingerbread_cottage_playhouse";
      if (hasAll("pennfield", "cottage", "playhouse")) return "pennfield_cottage_playhouse";
      if (hasAll("craftsman", "playhouse")) return "craftsman_playhouse";

      if (hasAll("cape", "cod", "kennel") || hasAll("cape", "cod", "cozy", "kennel")) return "cape_cod_cozy_kennel";
      if (hasAll("victorian", "kennel") || hasAll("victorian", "cozy", "kennel")) return "victorian_cozy_kennel";

      if (hasAll("cape", "cod", "playhouse")) return "cape_cod_playhouse";
      if (hasAll("victorian", "playhouse")) return "victorian_playhouse";

      if (hasAll("colonial", "gable", "greenhouse")) return "colonial_gable_greenhouse";
      if (hasAll("garden", "shed", "greenhouse")) return "garden_shed_greenhouse";
      if (hasAll("octagon", "greenhouse")) return "octagon_greenhouse";
      if (hasAll("petite", "greenhouse")) return "petite_greenhouse";

      if (hasAll("value", "a", "frame", "coop") || hasAll("value", "a-frame", "coop")) return "value_a_frame_coop";
      if (hasAll("gambrel", "barn", "coop")) return "gambrel_barn_coop";
      if (hasAll("colonial", "gable", "coop")) return "colonial_gable_coop";
      if (hasAll("round", "roof", "coop")) return "round_roof_coop";

      if (hasAll("star", "barn")) return "star_barn";

      if (hasAll("colonial", "five", "corner")) return "colonial_five_corner";
      if (hasAll("colonial", "williamsburg")) return "colonial_williamsburg";
      if (hasAll("colonial", "pinehurst")) return "colonial_pinehurst";

      if (hasAll("classic", "five", "corner")) return "classic_five_corner";
      if (hasAll("classic", "gambrel", "large")) return "classic_gambrel_large";
      if (hasAll("classic", "gambrel", "6")) return "classic_gambrel_6";
      if (hasAll("classic", "gambrel", "4")) return "classic_gambrel_4";
      if (hasAll("classic", "workshop")) return "classic_workshop";
      if (hasAll("classic", "gable")) return "classic_gable";

      if (hasAll("value", "gambrel", "6")) return "value_gambrel_6";
      if (hasAll("value", "gambrel", "4")) return "value_gambrel_4";
      if (hasAll("value", "workshop")) return "value_workshop";
      if (hasAll("value", "gable")) return "value_gable";

      if (hasAny("greenhouse") && hasAny("colonial gable greenhouse")) return "colonial_gable_greenhouse";
      if (hasAny("octagon greenhouse")) return "octagon_greenhouse";
      if (hasAny("garden shed greenhouse")) return "garden_shed_greenhouse";
      if (hasAny("petite greenhouse")) return "petite_greenhouse";

      return "";
    }

    function renderTable(
      productTitle,
      productionDisplay,
      destinationStateName,
      prodMinBd,
      prodMaxBd,
      transitMin,
      transitMax
    ) {
      const today = new Date();
      const earliestBD = prodMinBd + transitMin;
      const latestBD = prodMaxBd + transitMax;
      const earliest = addBusinessDays(today, earliestBD);
      const latest = addBusinessDays(today, latestBD);

      const transitText =
        transitMin === transitMax
          ? `${transitMin} business days`
          : `${transitMin} to ${transitMax} business days`;

      const windowText = `${fmtDate(earliest)} to ${fmtDate(latest)}`;

      out.innerHTML = `
        <table aria-label="Delivery estimate">
          <tbody>
            <tr><th>Product</th><td>${productTitle}</td></tr>
            <tr><th>Destination state</th><td>${destinationStateName}</td></tr>
            <tr><th>Production lead time</th><td>${productionDisplay}</td></tr>
            <tr><th>Transit time</th><td>${transitText}</td></tr>
            <tr><th>Estimated delivery window</th><td><strong>${windowText}</strong></td></tr>
          </tbody>
        </table>
        <p class="hsr-note" style="margin-top:10px;">
          Estimate only. Holidays and carrier delays can shift delivery.
        </p>
      `;
    }

    const detectedDefaultProduct = detectDefaultProductKey();

    if (detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]) {
      productEl.value = detectedDefaultProduct;
    }

    btn.addEventListener("click", async () => {
      const zip = cleanZip(zipEl.value);
      const selectedKey = productEl.value;

      zipEl.value = zip;

      if (!isValidZip(zip)) {
        out.innerHTML = "";
        showErr(true, "Enter a valid 5-digit ZIP.");
        return;
      }

      if (!selectedKey || !PRODUCT_MAP[selectedKey]) {
        out.innerHTML = "";
        showErr(true, "Please choose the exact Little Cottage Co. product.");
        return;
      }

      const destinationState = getStateFromZip(zip);

      if (!destinationState) {
        out.innerHTML = "";
        showErr(true, "Could not match that ZIP code to a supported U.S. state.");
        return;
      }

      const transit = STATE_TRANSIT[destinationState];

      if (!transit || transit.blocked) {
        out.innerHTML = "";
        showErr(true, "We do not currently ship Little Cottage Co. products to Alaska or Hawaii.");
        return;
      }

      showErr(false);

      try {
        const production = await getProductionData();
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod =
          production[selectedProduct.bucket] || FALLBACK_PRODUCTION[selectedProduct.bucket];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load Little Cottage Co. lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          prod.display,
          STATE_NAMES[destinationState] || destinationState,
          prod.minBd,
          prod.maxBd,
          transit.min,
          transit.max
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "hsr_delivery_estimate_lcc_state_transit",
          zip,
          destination_state: destinationState,
          selected_product_key: selectedKey,
          selected_product_label: selectedProduct.label,
          lcc_bucket: selectedProduct.bucket
        });
      } catch (e) {
        const selectedProduct = PRODUCT_MAP[selectedKey];
        const prod = FALLBACK_PRODUCTION[selectedProduct.bucket];

        if (!prod) {
          out.innerHTML = "";
          showErr(true, "Could not load Little Cottage Co. lead time data. Try again.");
          return;
        }

        renderTable(
          selectedProduct.label,
          prod.display,
          STATE_NAMES[destinationState] || destinationState,
          prod.minBd,
          prod.maxBd,
          transit.min,
          transit.max
        );

        showErr(false);
      }
    });

    clr.addEventListener("click", () => {
      zipEl.value = "";
      productEl.value =
        detectedDefaultProduct && PRODUCT_MAP[detectedDefaultProduct]
          ? detectedDefaultProduct
          : "";
      out.innerHTML = "";
      showErr(false);
    });

    window.hsrLccClearProductionCache = function () {
      try {
        localStorage.removeItem(CACHE_KEY);
      } catch (e) {}
    };

    window.hsrLccReadProductionCache = function () {
      try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      } catch (e) {
        return null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-shed-comparison-tool-assets"] && !Shopify.designMode) return;
  try {
    (function () {
      var P = [
          {
            i: "1",
            t: "Cedarshed Boathouse Canoe & Kayak Storage Shed Kit",
            h: "cedarshed-boathouse-canoe-kayak-storage-shed",
            v: "Cedarshed",
            p: 4209,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-canoe-and-kayak-storage-shed.jpg?v=1714160020",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4909.99,
            q: [
              ["Boathouse 12x6 with Cedar Roof Shingles", 4479, "2mcfpi59x"],
              ["Boathouse 12x8 with Cedar Roof Shingles", 5099, "2mcfpiuk5"],
              ["Boathouse 16x8 with Cedar Roof Shingles", 6279, "2mcfpjjud"],
              ["Boathouse 12x10 with Cedar Roof Shingles", 5379, "2mcfpk94l"],
              ["Boathouse 16x10 with Cedar Roof Shingles", 6279, "2mcfpkyet"],
              ["Boathouse 12x6 with Metal Roof", 4479, "fs71ao2et"],
              ["Boathouse 12x8 with Metal Roof", 5099, "fs71aorp1"],
              ["Boathouse 16x8 with Metal Roof", 6039, "fs71apgz9"],
              ["Boathouse 12x10 with Metal Roof", 5299, "fs71aq69h"],
              ["Boathouse 16x10 with Metal Roof", 6149, "fs71aqvjp"],
              ["Boathouse 12x6 with OSB Roof", 4209, "eibyq5645"],
              ["Boathouse 12x8 with OSB Roof", 4559, "eibyqx9h1"],
              ["Boathouse 16x8 with OSB Roof", 4999, "eibyr4ab9"],
              ["Boathouse 12x10 with OSB Roof", 4649, "eibyr8i0l"],
              ["Boathouse 16x10 with OSB Roof", 5379, "eibyrdf05"],
            ],
          },
          {
            i: "2",
            t: "Cedarshed Cabana Backyard & Pool Shed",
            h: "cedarshed-cabana-backyard-shed",
            v: "Cedarshed",
            p: 3459,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cabana-backyard-pool-shed-main.jpg?v=1713808378",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3799.99,
            q: [
              ["Cabana 9x6 with Cedar Roof Shingles", 4119, "2lp23erzp"],
              ["Cabana 10x8 with Cedar Roof Shingles", 4939, "2lp23fh9x"],
              ["Cabana 12x8 with Cedar Roof Shingles", 5239, "2lp23g6k5"],
              ["Cabana 12x10 with Cedar Roof Shingles", 5549, "2lp23gvud"],
              ["Cabana 9x6 with Metal Roof", 3949, "fs71k1vzp"],
              ["Cabana 10x8 with Metal Roof", 4729, "fs71k2l9x"],
              ["Cabana 12x8 with Metal Roof", 5119, "fs71k3ak5"],
              ["Cabana 12x10 with Metal Roof", 5509, "fs71k3zud"],
              ["Cabana 9x6 with OSB Roof", 3459, "eibx4gdh1"],
              ["Cabana 10x8 with OSB Roof", 4159, "eibx4mp11"],
              ["Cabana 12x8 with OSB Roof", 4459, "eibx4q7g5"],
              ["Cabana 12x10 with OSB Roof", 4749, "eibx4uf5h"],
            ],
          },
          {
            i: "3",
            t: "Cedarshed Cedar House Storage Shed",
            h: "cedarshed-cedarhouse-storage-shed",
            v: "Cedarshed",
            p: 4029,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cedar-house-storage-shed-main.webp?v=1714519762",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4849,
            q: [
              ["CEDARHOUSE 10x8 with Cedar Roof Shingles", 4649, "2loo3nv3p"],
              ["CEDARHOUSE 10x10 with Cedar Roof Shingles", 4929, "2loo3p9o5"],
              ["CEDARHOUSE 10x12 with Cedar Roof Shingles", 5549, "2loo3qo8l"],
              ["CEDARHOUSE 10x16 with Cedar Roof Shingles", 6449, "2loo3s2t1"],
              ["CEDARHOUSE 10x20 with Cedar Roof Shingles", 7629, "2loo3ss39"],
              ["CEDARHOUSE 10x8 with Metal Roof", 4539, "fs7wllkj9"],
              ["CEDARHOUSE 10x10 with Metal Roof", 4779, "fs7wlm9th"],
              ["CEDARHOUSE 10x12 with Metal Roof", 5499, "fs7wlmz3p"],
              ["CEDARHOUSE 10x16 with Metal Roof", 6079, "fs7wlnodx"],
              ["CEDARHOUSE 10x20 with Metal Roof", 7349, "fs7wlodo5"],
              ["CEDARHOUSE 10x8 with OSB Roof", 4029, "eibxumwj9"],
              ["CEDARHOUSE 10x10 with OSB Roof", 4199, "eibxv2cs5"],
              ["CEDARHOUSE 10x12 with OSB Roof", 4839, "eibxv5v79"],
              ["CEDARHOUSE 10x16 with OSB Roof", 5299, "eibxvbhh1"],
              ["CEDARHOUSE 10x20 with OSB Roof", 6279, "eibxvdlbp"],
            ],
          },
          {
            i: "4",
            t: "Cedarshed Cookhouse BBQ Shed",
            h: "cedarshed-cookhouse-cooking-bbq-sheds",
            v: "Cedarshed",
            p: 6819,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cookhouse-bbq-shed-main.webp?v=1714587118",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 8099,
            q: [
              ["Cookhouse 12x10 with Cedar Roof Shingles", 7449, "benb0nwhh"],
              ["Cookhouse 16x12 with Cedar Roof Shingles", 8799, "benb0olrp"],
              ["Cookhouse 16x14 with Cedar Roof Shingles", 8979, "benb0pb1x"],
              ["Cookhouse 12x10 with OSB Roof", 6819, "eic096g51"],
              ["Cookhouse 16x12 with OSB Roof", 7539, "eic09jsj9"],
              ["Cookhouse 16x14 with OSB Roof", 7629, "eic0baat1"],
            ],
          },
          {
            i: "5",
            t: "Cedarshed DIY 4x4 Green Pod Wooden Garbage Can & Recycling Bin Shed Kits",
            h: "cedarshed-green-pod-garbage-recycling-shed",
            v: "Cedarshed",
            p: 2279.99,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-wooden-garbage-can-shed-kit.webp?v=1714414026",
            s: {
              m: "100% Western Red Cedar",
              r: "Tongue-and-groove roof panels; OSB version available",
              f: "Not listed",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 2899.99,
          },
          {
            i: "6",
            t: "Cedarshed Farmhouse Shed Kit",
            h: "cedarshed-farmhouse-shed-kits",
            v: "Cedarshed",
            p: 7499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-farmhouse-shed-kit-main.webp?v=1714409778",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 8749,
            q: [
              ["Farmhouse 16x12 with Cedar Roof Shingles", 8979, "beoltxfzp"],
              ["Farmhouse 16x14 with Cedar Roof Shingles", 9879, "beolty59x"],
              ["Farmhouse 20x12 with Cedar Roof Shingles", 10699, "beoltyuk5"],
              ["Farmhouse 20x14 with Cedar Roof Shingles", 11599, "beoltzjud"],
              ["Farmhouse 16x12 with Metal Roof", 8979, "fwsubo1f9"],
              ["Farmhouse 16x14 with Metal Roof", 9879, "fwsuboqph"],
              ["Farmhouse 20x12 with Metal Roof", 10699, "fwsubpfzp"],
              ["Farmhouse 20x14 with Metal Roof", 11599, "fwsubq59x"],
              ["Farmhouse 16x12 with OSB Roof", 7499, "eic0t3j1x"],
              ["Farmhouse 16x14 with OSB Roof", 7719, "eic0tkdv9"],
              ["Farmhouse 20x12 with OSB Roof", 8979, "eic0ttik5"],
              ["Farmhouse 20x14 with OSB Roof", 9419, "eic0u5gdx"],
            ],
          },
          {
            i: "7",
            t: "Cedarshed Gable Style Beach House Shed",
            h: "cedarshed-gable-style-beach-house-shed-kit",
            v: "Cedarshed",
            p: 4079,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gable-style-beach-house-shed.webp?v=1714495934",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4889.99,
            q: [
              ["Beachhouse 9x6 with Cedar Roof Shingles", 4799, "bf0wwsz05"],
              ["Beachhouse 10x8 with Cedar Roof Shingles", 5549, "bf0wwtoad"],
              ["Beachhouse 12x8 with Cedar Roof Shingles", 6199, "bf0wwudkl"],
              ["Beachhouse 9x6 with Metal Roof", 4649, "fs70t3yut"],
              ["Beachhouse 10x8 with Metal Roof", 5379, "fs70t4o51"],
              ["Beachhouse 12x8 with Metal Roof", 5979, "fs70t5df9"],
              ["Beachhouse 9x6 with OSB Roof", 4079, "eibzeopbp"],
              ["Beachhouse 10x8 with OSB Roof", 4979, "eibzfpxdh"],
              ["Beachhouse 12x8 with OSB Roof", 5379, "eibzgr5f9"],
            ],
          },
          {
            i: "8",
            t: "Cedarshed Garden Hutch",
            h: "cedarshed-garden-hutch",
            v: "Cedarshed",
            p: 1779,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardeners-hutch-storage-shed-main.webp?v=1714512776",
            s: {
              m: "100% Western Red Cedar",
              r: "Not listed",
              f: "Not listed",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 1959,
          },
          {
            i: "9",
            t: "Cedarshed Gardener Small Gable Shed Kit",
            h: "cedarshed-gardener-small-gable-shed-kit",
            v: "Cedarshed",
            p: 3029,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardener-small-gable-shed-kit.webp?v=1714149172",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3299.99,
            q: [
              ["Gardener 6x6 with Cedar Roof Shingles", 3229, "2lolr396d"],
              ["Gardener 6x9 with Cedar Roof Shingles", 3739, "eibxitzqt"],
              ["Gardener 6x12 with Cedar Roof Shingles", 4549, "2lolr4nqt"],
              ["Gardener 8x10 with Cedar Roof Shingles", 4549, "2lolr5d11"],
              ["Gardener 8x12 with Cedar Roof Shingles", 4949, "2lolr62b9"],
              ["Gardener 8x16 with Cedar Roof Shingles", 5929, "2lolr6rlh"],
              ["Gardener 6x6 with Metal Roof", 3279, "fs721wit1"],
              ["Gardener 6x9 with Metal Roof", 3769, "fs721xxdh"],
              ["Gardener 6x12 with Metal Roof", 4319, "fs721x839"],
              ["Gardener 8x10 with Metal Roof", 4569, "fs721ymnp"],
              ["Gardener 8x12 with Metal Roof", 4969, "fs721zbxx"],
              ["Gardener 8x16 with Metal Roof", 5849, "fs7220185"],
              ["Gardener 6x6 with OSB Roof", 3029, "eibxgsy7p"],
              ["Gardener 6x9 with OSB Roof", 3459, "2lolr3ygl"],
              ["Gardener 6x12 with OSB Roof", 3779, "eibxjqat1"],
              ["Gardener 8x10 with OSB Roof", 4169, "eibxjvx2t"],
              ["Gardener 8x12 with OSB Roof", 4319, "eibxkj3g5"],
              ["Gardener 8x16 with OSB Roof", 5129, "eibxkvqk5"],
            ],
          },
          {
            i: "10",
            t: "Cedarshed Haida Cabin & Storage Shed",
            h: "cedarshed-haida-cabin-storage-shed",
            v: "Cedarshed",
            p: 3939.99,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-haida-storage-shed-fully-assembled.webp?v=1714406713",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′",
              w: "Yes",
            },
            c: 4639.99,
            q: [
              ["Haida 9x6 with Cedar Roof Shingles", 4559.99, "2mcrgr8l1"],
              ["Haida 12x8 with Cedar Roof Shingles", 5549.99, "2mcrgrxv9"],
              ["Haida 12x10 with Cedar Roof Shingles", 5919.99, "2mcrgsn5h"],
              ["Haida 9x6 with Metal Roof", 4399.99, "fs726hkj9"],
              ["Haida 12x8 with Metal Roof", 5379.99, "fs726i9th"],
              ["Haida 12x10 with Metal Roof", 5549.99, "fs726iz3p"],
              ["Haida 9x6 with OSB Roof", 3939.99, "eibzpbh2t"],
              ["Haida 12x8 with OSB Roof", 4799.99, "eibzpsbw5"],
              ["Haida 12x10 with OSB Roof", 4899.99, "eibzql4j9"],
            ],
          },
          {
            i: "11",
            t: "Cedarshed Hobbyhouse Prefab Shed Kits",
            h: "cedarshed-hobbyhouse-prefab-shed-kits",
            v: "Cedarshed",
            p: 3669,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-hobbyhouse-she-shed-kit-main.webp?v=1714589468",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB; skylight roof variants shown",
              f: "5/8″ plywood over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′",
              w: "Yes",
            },
            c: 4489,
            q: [
              ["Hobbyhouse 9' x 6' with Cedar & Skylight Roof", 4079, "bembid06t"],
              ["Hobbyhouse 10' x 8' with Cedar & Skylight Roof", 4769, "bembidph1"],
              ["Hobbyhouse 12' x 8' with Cedar & Skylight Roof", 5179, "bembieer9"],
              ["Hobbyhouse 12' x 10' with Cedar & Skylight Roof", 5529, "bembif41h"],
              ["Hobbyhouse 9' x 6' with OSB & Skylight Roof", 3669, "eic109zjp"],
              ["Hobbyhouse 10' x 8' with OSB & Skylight Roof", 4159, "eic10q52t"],
              ["Hobbyhouse 12' x 8' with OSB & Skylight Roof", 5349, "eic11b7lh"],
              ["Hobbyhouse 12' x 10' with OSB & Skylight Roof", 4619, "eic11wzed"],
            ],
          },
          {
            i: "12",
            t: "Cedarshed Lean To Storage Bayside Shed",
            h: "cedarshed-lean-to-storage-shed",
            v: "Cedarshed",
            p: 2059,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-lean-to-shingles-roof.png?v=1713987560",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 2374,
            q: [
              ["Bayside 6x3 with Cedar Roof Shingles / Double Doors", 2339, "dyf9r1ulx"],
              ["Bayside 6x3 with Cedar Roof Shingles / Dutch Door with Window", 2189, "dzqsa6vqt"],
              [
                "Bayside 6x3 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2488,
                "dzqsv1oad",
              ],
              [
                "Bayside 6x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2498,
                "feinsygj9",
              ],
              ["Bayside 6x4 with Cedar Roof Shingles / Double Doors", 2709, "fv4w66n1x"],
              ["Bayside 6x4 with Cedar Roof Shingles / Dutch Door with Window", 2709, "fv4w67cc5"],
              [
                "Bayside 6x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2858,
                "fv4w681md",
              ],
              [
                "Bayside 6x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2868,
                "fv4w68qwl",
              ],
              ["Bayside 8x3 with Cedar Roof Shingles / Double Doors", 2709, "dyf9rd35h"],
              ["Bayside 8x3 with Cedar Roof Shingles / Dutch Door with Window", 2709, "dzqsb3w39"],
              [
                "Bayside 8x3 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2858,
                "dzqsvxzcl",
              ],
              [
                "Bayside 8x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2868,
                "feinsz5th",
              ],
              ["Bayside 8x4 with Cedar Roof Shingles / Double Doors", 2879, "dzqsevfw5"],
              ["Bayside 8x4 with Cedar Roof Shingles / Dutch Door with Window", 2879, "dyf9rkt9x"],
              [
                "Bayside 8x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                3028,
                "dzqswx3jp",
              ],
              [
                "Bayside 8x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                3038,
                "feinszv3p",
              ],
              ["Bayside 12x4 with Cedar Roof Shingles / Double Doors", 3739, "e043fnqd1"],
              ["Bayside 12x4 with Cedar Roof Shingles / Dutch Door with Window", 3739, "dyf9rmx4l"],
              [
                "Bayside 12x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                3888,
                "dzqsx9qnp",
              ],
              [
                "Bayside 12x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                3898,
                "feint0kdx",
              ],
              ["Bayside 6x3 with Metal Roof / Double Doors", 2299, "fs7uyz29h"],
              ["Bayside 6x3 with Metal Roof / Dutch Door with Window", 2299, "fs7uyzrjp"],
              ["Bayside 6x3 with Metal Roof / Sliding Door (no window) $149", 2448, "fs7uz0gtx"],
              [
                "Bayside 6x3 with Metal Roof / Double Doors with One Fixed Window $159",
                2458,
                "fs7uz1645",
              ],
              ["Bayside 6x4 with Metal Roof / Double Doors", 2539, "fv4w69g6t"],
              ["Bayside 6x4 with Metal Roof / Dutch Door with Window", 2539, "fv4w6a5h1"],
              ["Bayside 6x4 with Metal Roof / Sliding Door (no window) $149", 2688, "fv4w6aur9"],
              [
                "Bayside 6x4 with Metal Roof / Double Doors with One Fixed Window $159",
                2698,
                "fv4w6bk1h",
              ],
              ["Bayside 8x3 with Metal Roof / Double Doors", 2539, "fs7uz1ved"],
              ["Bayside 8x3 with Metal Roof / Dutch Door with Window", 2539, "fs7uz2kol"],
              ["Bayside 8x3 with Metal Roof / Sliding Door (no window) $149", 2688, "fs7uz39yt"],
              [
                "Bayside 8x3 with Metal Roof / Double Doors with One Fixed Window $159",
                2698,
                "fs7uz3z91",
              ],
              ["Bayside 8x4 with Metal Roof / Double Doors", 2749.99, "fs7uz4oj9"],
              ["Bayside 8x4 with Metal Roof / Dutch Door with Window", 2749.99, "fs7uz5dth"],
              ["Bayside 8x4 with Metal Roof / Sliding Door (no window) $149", 2899, "fs7uz633p"],
              [
                "Bayside 8x4 with Metal Roof / Double Doors with One Fixed Window $159",
                2909,
                "fs7uz6sdx",
              ],
              ["Bayside 12x4 with Metal Roof / Double Doors", 3419, "fs7uz7ho5"],
              ["Bayside 12x4 with Metal Roof / Dutch Door with Window", 3419, "fs7uz86yd"],
              ["Bayside 12x4 with Metal Roof / Sliding Door (no window) $149", 3569, "fs7uz8w8l"],
              [
                "Bayside 12x4 with Metal Roof / Double Doors with One Fixed Window $159",
                3579,
                "fs7uz9lit",
              ],
              ["Bayside 6x3 with OSB Roof / Double Doors", 2059, "eic4p2245"],
              ["Bayside 6x3 with OSB Roof / Dutch Door with Window", 2059, "eic4pl0s5"],
              ["Bayside 6x3 with OSB Roof / Sliding Door (no window) $149", 2209, "eic4q1vlh"],
              [
                "Bayside 6x3 with OSB Roof / Double Doors with One Fixed Window $159",
                2219,
                "feint19o5",
              ],
              ["Bayside 6x4 with OSB Roof / Double Doors", 2429, "fv4w6c9bp"],
              ["Bayside 6x4 with OSB Roof / Dutch Door with Window", 2429, "fv4w6cylx"],
              ["Bayside 6x4 with OSB Roof / Sliding Door (no window) $149", 2579, "fv4w6dnw5"],
              [
                "Bayside 6x4 with OSB Roof / Double Doors with One Fixed Window $159",
                2589,
                "fv4w6ed6d",
              ],
              ["Bayside 8x3 with OSB Roof / Double Doors", 2429, "eic4s8jed"],
              ["Bayside 8x3 with OSB Roof / Dutch Door with Window", 2429, "eic4sv0hh"],
              ["Bayside 8x3 with OSB Roof / Sliding Door (no window) $149", 2579, "eic4t5jqt"],
              [
                "Bayside 8x3 with OSB Roof / Double Doors with One Fixed Window $159",
                2589,
                "feint1yyd",
              ],
              ["Bayside 8x4 with OSB Roof / Double Doors", 2489, "eic4u2k39"],
              ["Bayside 8x4 with OSB Roof / Dutch Door with Window", 2489, "eic4um81h"],
              ["Bayside 8x4 with OSB Roof / Sliding Door (no window) $149", 2639, "eic4v3s51"],
              [
                "Bayside 8x4 with OSB Roof / Double Doors with One Fixed Window $159",
                2649,
                "feint2o8l",
              ],
              ["Bayside 12x4 with OSB Roof / Double Doors", 3279, "eic4vq985"],
              ["Bayside 12x4 with OSB Roof / Dutch Door with Window", 3279, "eic4wjr5h"],
              ["Bayside 12x4 with OSB Roof / Sliding Door (no window) $149", 3428, "eic4x688l"],
              [
                "Bayside 12x4 with OSB Roof / Double Doors with One Fixed Window $159",
                3438,
                "feint3dit",
              ],
            ],
          },
          {
            i: "13",
            t: "Cedarshed Longhouse Gable Style Double Door Shed Kit",
            h: "cedarshed-longhouse-double-door-shed",
            v: "Cedarshed",
            p: 4309,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-longhouse-double-door-shed-kit.webp?v=1714066930",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4719.99,
            q: [
              ["Longhouse 12x6 with Cedar Roof Shingles", 4899, "2mc6cqhpx"],
              ["Longhouse 12x8 with Cedar Roof Shingles", 5299, "2mc6cr705"],
              ["Longhouse 16x8 with Cedar Roof Shingles", 6199, "2mc6crwad"],
              ["Longhouse 12x10 with Cedar Roof Shingles", 6099, "2mc6cslkl"],
              ["Longhouse 16x10 with Cedar Roof Shingles", 6899, "2mc6ctaut"],
              ["Longhouse 12x6 with Metal Roof", 4399, "fs72awaph"],
              ["Longhouse 12x8 with Metal Roof", 5199, "fs72awzzp"],
              ["Longhouse 16x8 with Metal Roof", 6099, "fs72axp9x"],
              ["Longhouse 12x10 with Metal Roof", 5899, "fs72az3ud"],
              ["Longhouse 16x10 with Metal Roof", 6599, "fs72ayek5"],
              ["Longhouse 12x6 with OSB Roof", 4309, "eibynz7lh"],
              ["Longhouse 12x8 with OSB Roof", 4599, "eibyo20qd"],
              ["Longhouse 16x8 with OSB Roof", 5399, "eibyoohth"],
              ["Longhouse 12x10 with OSB Roof", 5199, "eibyop73p"],
              ["Longhouse 16x10 with OSB Roof", 5699, "eibyp14xh"],
            ],
          },
          {
            i: "14",
            t: "Cedarshed Rancher Large Shed Kit and Storage Solution",
            h: "cedarshed-large-rancher-shed-kit-storage-solution",
            v: "Cedarshed",
            p: 2989,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-rancher-shed-kit-and-storage-solution.webp?v=1713988928",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3259.99,
            q: [
              ["RANCHER 6x6 with Cedar Roof Shingles", 3469, "2louk0myd"],
              ["RANCHER 6x9 with Cedar Roof Shingles", 3979, "2louk1c8l"],
              ["RANCHER 6x12 with Cedar Roof Shingles", 4759, "2louk21it"],
              ["RANCHER 8x8 with Cedar Roof Shingles", 4319, "en18u7ar9"],
              ["RANCHER 8x10 with Cedar Roof Shingles", 4979, "2louk2qt1"],
              ["RANCHER 8x12 with Cedar Roof Shingles", 5179, "2louk3g39"],
              ["RANCHER 8x16 with Cedar Roof Shingles", 6479, "2louk45dh"],
              ["RANCHER 10x10 with Cedar Roof Shingles", 5279, "2louk4unp"],
              ["RANCHER 10x12 with Cedar Roof Shingles", 5679, "2louk5jxx"],
              ["RANCHER 10x16 with Cedar Roof Shingles", 6579, "2louk6985"],
              ["RANCHER 10x20 with Cedar Roof Shingles", 7879, "2louk6yid"],
              ["RANCHER 6x6 with Metal Roof", 3329, "fs7vugmk5"],
              ["RANCHER 6x9 with Metal Roof", 3859, "fs7vuhbud"],
              ["RANCHER 6x12 with Metal Roof", 4679, "fs7vui14l"],
              ["RANCHER 8x8 with Metal Roof", 4239, "fs7vuiqet"],
              ["RANCHER 8x10 with Metal Roof", 4699, "fs7vujfp1"],
              ["RANCHER 8x12 with Metal Roof", 4899, "fs7vuk4z9"],
              ["RANCHER 8x16 with Metal Roof", 6019, "fs7vuku9h"],
              ["RANCHER 10x10 with Metal Roof", 4899, "fs7vuljjp"],
              ["RANCHER 10x12 with Metal Roof", 5299, "fs7vum8tx"],
              ["RANCHER 10x16 with Metal Roof", 6319, "fs7vumy45"],
              ["RANCHER 10x20 with Metal Roof", 7519, "fs7vunned"],
              ["RANCHER 6x6 with OSB Roof", 2989, "eiby3rlf9"],
              ["RANCHER 6x9 with OSB Roof", 3379, "eiby48g8l"],
              ["RANCHER 6x12 with OSB Roof", 4139, "eiby4zub9"],
              ["RANCHER 8x8 with OSB Roof", 3739, "en18v6eyd"],
              ["RANCHER 8x10 with OSB Roof", 4139, "eiby5i3p1"],
              ["RANCHER 8x12 with OSB Roof", 4269, "eiby5yyid"],
              ["RANCHER 8x16 with OSB Roof", 5309, "euwz88hth"],
              ["RANCHER 10x10 with OSB Roof", 4269, "eiby6a71x"],
              ["RANCHER 10x12 with OSB Roof", 4559, "eiby6r1v9"],
              ["RANCHER 10x16 with OSB Roof", 5469, "eibya0cad"],
              ["RANCHER 10x20 with OSB Roof", 6349, "eibyb5s1h"],
            ],
          },
          {
            i: "15",
            t: "Cedarshed Ranchhouse Prefab Cottage Kit",
            h: "cedarshed-ranchhouses-prefab-cottage-kits",
            v: "Cedarshed",
            p: 6899,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-ranchhouse-prefab-cottage-kit-main.webp?v=1714156975",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 7399,
            q: [
              ["Ranchhouse 12x12 with Cedar Roof Shingles", 7899, "beokkv22d"],
              ["Ranchhouse 16x12 with Cedar Roof Shingles", 10299, "beokkvrcl"],
              ["Ranchhouse 12x14 with Cedar Roof Shingles", 7999, "beokkwgmt"],
              ["Ranchhouse 16x14 with Cedar Roof Shingles", 10499, "beokkx5x1"],
              ["Ranchhouse 12x12 with Metal Roof", 7899, "fws1glu7p"],
              ["Ranchhouse 16x12 with Metal Roof", 10399, "fws1gmjhx"],
              ["Ranchhouse 12x14 with Metal Roof", 7999, "fws1gn8s5"],
              ["Ranchhouse 16x14 with Metal Roof", 10499, "fws1gny2d"],
              ["Ranchhouse 12x12 with OSB Roof", 6999, "eic0j85dh"],
              ["Ranchhouse 16x12 with OSB Roof", 8899, "eic0k3r5h"],
              ["Ranchhouse 12x14 with OSB Roof", 6899, "eic0ktqnp"],
              ["Ranchhouse 16x14 with OSB Roof", 8999, "eic0l8hmd"],
            ],
          },
          {
            i: "16",
            t: "EZ-Fit Craftsman Storage Shed Kit",
            h: "ez-fit-craftsman-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2399,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-craftsman-shed-kit-main.jpg?v=1740682952",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "Not listed; sidewall height extension available",
              w: "Yes",
            },
            c: 2699,
            q: [
              ["8x8", 2399, "dyzebcjed"],
              ["8x10", 2599, "dyzebd8ol"],
              ["8x12", 2949, "dyzebfcj9"],
              ["10x10", 2949, "dyzebgr3p"],
              ["10x12", 3299, "dyzebi5o5"],
              ["10x14", 3599, "dyzebjk8l"],
              ["10x16", 3799, "dyzeblo39"],
              ["10x20", 4399, "dyzebn2np"],
              ["12x16", 4549, "dyzebpvsl"],
              ["12x20", 5099, "dyzebrad1"],
              ["12x24", 5549, "dyzebte7p"],
            ],
          },
          {
            i: "17",
            t: "EZ-Fit Heritage Shed Kit",
            h: "ez-fit-heritage-outdoor-garden-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2699,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/Heritageedited_1000x1000_60818b49-2519-4b67-a58a-e05892b7e1e5.jpg?v=1660745179",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 2999,
            q: [
              ["8x8'", 2699, "fq5f9btpx"],
              ["8x10'", 2899, "fq5f9cj05"],
              ["8x12'", 3299, "i5n4219"],
              ["10x10'", 3299, "fq5f9d8ad"],
              ["10x12'", 3699, "i5n4231"],
              ["10x14", 3999, "i5n424t"],
              ["10x16'", 4299, "i5n426l"],
              ["10x20'", 4899, "i5n428d"],
              ["12x16'", 5099, "i5n42a5"],
              ["12x20'", 5699, "i5n42bx"],
              ["12x24'", 6199, "i5n42dp"],
            ],
          },
          {
            i: "18",
            t: "EZ-Fit Heritage Shed Kit - QUICK-SHIP",
            h: "ez-fit-heritage-shed-kit-quick-ship",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-heritage-shed-double-doors.webp?v=1740001927",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpwanxjjp"],
              ["10x12", 3699, "fpwany8tx"],
            ],
          },
          {
            i: "19",
            t: "EZ-Fit Homestead Shed Kit",
            h: "ez-fit-homestead-garden-tool-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2699,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/HomesteadEZfit-937503.jpg?v=1695738402",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 2999,
            q: [
              ["8x8", 2699, "i5nhowd"],
              ["8x10'", 2899, "i5ni00d"],
              ["8x12'", 3299, "i5ng7nx"],
              ["10x10'", 3299, "i5ni8wd"],
              ["10x12'", 3699, "i5ng7pp"],
              ["10x14'", 3999, "i5ng7rh"],
              ["10x16'", 4299, "i5ng7t9"],
              ["10x20'", 4899, "i5ng7v1"],
              ["12x16'", 5099, "i5ng7wt"],
              ["12x20'", 5699, "i5ng7yl"],
              ["12x24'", 6199, "i5ng80d"],
            ],
          },
          {
            i: "20",
            t: "EZ-Fit Homestead Shed Kit - QUICK-SHIP",
            h: "ez-fit-homestead-shed-kit-quick-ship",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-homestead-shed-kit-red.jpg?v=1740001269",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpv59456d"],
              ["10x12", 3699, "fpv594ugl"],
            ],
          },
          {
            i: "21",
            t: "EZ-Fit Riverside Shed Kit",
            h: "ez-fit-riverside-shed-kit",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-riverside-shed-kit-main.jpg?v=1732738736",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12'", 3299, "i4ch4p9"],
              ["10x12'", 3699, "i55brpp"],
              ["10x14'", 3999, "i55brt9"],
              ["10x16'", 4299, "i55brwt"],
              ["10x20'", 4899, "i55bs0d"],
              ["12x16'", 5099, "i55bs3x"],
              ["12x20'", 5699, "i55bs5p"],
              ["12x24'", 6199, "i55bs99"],
            ],
          },
          {
            i: "22",
            t: "EZ-Fit Riverside Shed Kit - QUICK-SHIP",
            h: "ez-fit-10x14-riverside-shed-kit",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-quickship-riverside-storage-shed.jpg?v=1756400548",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpsnwh1yt"],
              ["10x12", 3699, "fpsnwhr91"],
              ["10x14", 3999, "fpsnwigj9"],
              ["10x16", 4299, "fpsnwj5th"],
              ["10x20", 4899, "fpsnwjv3p"],
              ["12x24", 6199, "fpsnwkkdx"],
            ],
          },
          {
            i: "23",
            t: "EZ-Fit Skyview Shed Kit",
            h: "ez-fit-skyview-shed-kit",
            v: "EZ-Fit Sheds",
            p: 4399,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-skyview-shed-kit-main.jpg?v=1743006556",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "6′6″ sidewalls; no sidewall height upgrade",
              w: "Yes",
            },
            c: 4699,
            q: [
              ["8x12'", 4399, "fqnlcoo51"],
              ["10x12'", 4699, "fqnlcpdf9"],
              ["10x16'", 5399, "fqnlcq2ph"],
              ["10x20'", 5999, "fqnlcqrzp"],
            ],
          },
          {
            i: "24",
            t: "EZ-Fit Woodsman Shed Kit",
            h: "ez-fit-woodsman-shed-kit",
            v: "EZ-Fit Sheds",
            p: 4199,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-woodsman-shed-kit-main.jpg?v=1740410859",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "8 business days production + 2–9 business days shipping",
              h: "7′ sidewalls; sidewall height extension available",
              w: "Yes",
            },
            c: 4499,
            q: [
              ["8x8", 4199, "fq0gjy4vp"],
              ["8x12", 4699, "fq0gjyu5x"],
              ["10x10", 4799, "fq0gjzjg5"],
              ["10x12", 5199, "fq0gk08qd"],
              ["10x14", 5599, "fq0gk0y0l"],
              ["10x16", 5899, "fq0gk1nat"],
            ],
          },
          {
            i: "25",
            t: "Little Cottage Co. Classic 4' Gambrel Barn Shed Kit",
            h: "little-cottage-company-classic-gambrel-barn-4-sidewall-shed",
            v: "Little Cottage Co.",
            p: 2229,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-kit-sidewall-main.jpg?v=1759413523",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "4′ sidewalls",
              w: "No",
            },
            c: 2349,
            q: [
              ["8ft x 8ft", 2229, "e0ua6fdit"],
              ["8ft x 10ft", 2349, "e0ua6g2t1"],
              ["8ft x 12ft", 2419, "e0ua6gs39"],
              ["8ft x 14ft", 2539, "e0ua6hhdh"],
              ["8ft x 16ft", 2979, "e0ua6i6np"],
              ["10ft x 10ft", 2479, "e0ua6ivxx"],
              ["10ft x 12ft", 2929, "e0ua6jl85"],
              ["10ft x 14ft", 3049, "e0ua6kaid"],
              ["10ft x 16ft", 3169, "e0ua6kzsl"],
              ["10ft x 18ft", 3439, "e0ua6lp2t"],
              ["10ft x 20ft", 3699, "e0ua6med1"],
              ["12ft x 12ft", 3229, "e0ua6n3n9"],
              ["12ft x 14ft", 3379, "e0ua6nsxh"],
              ["12ft x 16ft", 3509, "e0ua6oi7p"],
              ["12ft x 18ft", 3959, "e0ua6p7hx"],
              ["12ft x 20ft", 4079, "e0ua6pws5"],
              ["12ft x 24ft", 4639, "e0ua6qm2d"],
            ],
          },
          {
            i: "26",
            t: "Little Cottage Co. Classic Five-Corner 10x10 Shed Kit",
            h: "little-cottage-company-classic-five-corner-10x10-shed",
            v: "Little Cottage Co.",
            p: 3339,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x10-classic-five-corner-shed-main.jpg?v=1759425555",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "6–8 weeks production + 2–9 days shipping",
              h: "72″ sidewalls",
              w: "No",
            },
            c: 3519,
            q: [
              ["Without Floor Kit", 3339, "e08lrj22d"],
              ["With Floor Kit", 4249, "e08lrjrcl"],
            ],
          },
          {
            i: "27",
            t: "Little Cottage Co. Classic Gable Shed Kit",
            h: "little-cottage-company-classic-gable-shed",
            v: "Little Cottage Co.",
            p: 2359,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-classic-gable-storage-shed-isolated.jpg?v=1759252363",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2489,
            q: [
              ["8ft x 8ft", 2359, "e0ubook6t"],
              ["8ft x 10ft", 2549, "e0ubop9h1"],
              ["8ft x 12ft", 2679, "e0ubopyr9"],
              ["8ft x 14ft", 3159, "e0uboqo1h"],
              ["8ft x 16ft", 3289, "e0ubordbp"],
              ["10ft x 10ft", 2719, "e0ubos2lx"],
              ["10ft x 12ft", 3199, "e0ubosrw5"],
              ["10ft x 14ft", 3359, "e0uboth6d"],
              ["10ft x 16ft", 3499, "e0ubou6gl"],
              ["10ft x 18ft", 3829, "e0ubouvqt"],
              ["10ft x 20ft", 4129, "e0ubovl11"],
              ["12ft x 12ft", 3379, "e0ubowab9"],
              ["12ft x 14ft", 3549, "e0ubowzlh"],
              ["12ft x 16ft", 4029, "e0uboxovp"],
              ["12ft x 18ft", 4209, "e0uboye5x"],
              ["12ft x 20ft", 4339, "e0uboz3g5"],
              ["12ft x 24ft", 4789, "e0ubozsqd"],
            ],
          },
          {
            i: "28",
            t: "Little Cottage Co. Classic Gambrel Barn 6' Sidewall Kit",
            h: "little-cottage-company-classic-gambrel-barn-6-sidewall-shed",
            v: "Little Cottage Co.",
            p: 2509,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-6-sidewall-main.jpg?v=1759345324",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′ sidewalls",
              w: "No",
            },
            c: 2649,
            q: [
              ["8ft x 8ft", 2509, "e0uavjz91"],
              ["8ft x 10ft", 2679, "e0uavkoj9"],
              ["8ft x 12ft", 2829, "e0uavldth"],
              ["8ft x 14ft", 3329, "e0uavm33p"],
              ["8ft x 16ft", 3479, "e0uavmsdx"],
              ["10ft x 10ft", 2979, "e0uavnho5"],
              ["10ft x 12ft", 3489, "e0uavo6yd"],
              ["10ft x 14ft", 3629, "e0uavow8l"],
              ["10ft x 16ft", 3709, "e0uavplit"],
              ["10ft x 18ft", 4099, "e0uavqat1"],
              ["10ft x 20ft", 4409, "e0uavr039"],
              ["12ft x 12ft", 3749, "e0uavrpdh"],
              ["12ft x 14ft", 3879, "e0uavsenp"],
              ["12ft x 16ft", 4399, "e0uavt3xx"],
              ["12ft x 18ft", 4559, "e0uavtt85"],
              ["12ft x 20ft", 4729, "e0uavuiid"],
              ["12ft x 24ft", 5349, "e0uavv7sl"],
            ],
          },
          {
            i: "29",
            t: "Little Cottage Co. Classic Gambrel Large Barn",
            h: "little-cottage-co-classic-gambrel-large-barn",
            v: "Little Cottage Co.",
            p: 4559,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-co-classic-gambrel-barn.jpg?v=1759352547",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Floor not included; optional kit available",
              l: "Not listed",
              h: "76″ sidewalls",
              w: "No",
            },
            c: 4819,
            q: [
              ["14ft x 18ft", 4559, "fum704eut"],
              ["14ft x 20ft", 4749, "fum705451"],
              ["14ft x 22ft", 4999, "fum705tf9"],
              ["14ft x 24ft", 5239, "fum706iph"],
              ["14ft x 26ft", 5459, "fum7077zp"],
              ["14ft x 28ft", 6089, "fum707x9x"],
              ["14ft x 30ft", 6199, "fum708mk5"],
              ["14ft x 32ft", 6409, "fum709bud"],
              ["16ft x 18ft", 5139, "fum70a14l"],
              ["16ft x 20ft", 5459, "fum70aqet"],
              ["16ft x 22ft", 5789, "fum70bfp1"],
              ["16ft x 24ft", 6009, "fum70c4z9"],
              ["16ft x 26ft", 6249, "fum70cu9h"],
              ["16ft x 28ft", 6569, "fum70djjp"],
              ["16ft x 30ft", 6799, "fum70e8tx"],
              ["16ft x 32ft", 7039, "fum70ey45"],
              ["16ft x 34ft", 7569, "fum70fned"],
            ],
          },
          {
            i: "30",
            t: "Little Cottage Co. Classic Workshop & Garden Shed",
            h: "little-cottage-company-classic-workshop-shed",
            v: "Little Cottage Co.",
            p: 2469,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-workshop-storage-shed-kit-front.jpg?v=1759256527",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2599,
            q: [
              ["8ft x 8ft", 2469, "e0ub6r48l"],
              ["8ft x 10ft", 2659, "e0ub6rtit"],
              ["8ft x 12ft", 2899, "e0ub6sit1"],
              ["8ft x 14ft", 3379, "e0ub6t839"],
              ["8ft x 16ft", 3519, "e0ub6txdh"],
              ["10ft x 10ft", 2819, "e0ub6umnp"],
              ["10ft x 12ft", 3419, "e0ub6vbxx"],
              ["10ft x 14ft", 3559, "e0ub6w185"],
              ["10ft x 16ft", 3719, "e0ub6wqid"],
              ["10ft x 18ft", 4039, "e0ub6xfsl"],
              ["10ft x 20ft", 4339, "e0ub6y52t"],
              ["12ft x 12ft", 3609, "e0ub6yud1"],
              ["12ft x 14ft", 3779, "e0ub6zjn9"],
              ["12ft x 16ft", 4249, "e0ub708xh"],
              ["12ft x 18ft", 4429, "e0ub70y7p"],
              ["12ft x 20ft", 4569, "e0ub71nhx"],
              ["12ft x 24ft", 5169, "e0ub72cs5"],
            ],
          },
          {
            i: "31",
            t: "Little Cottage Co. Colonial Five-Corner 10x10 Shed Kit",
            h: "little-cottage-company-colonial-five-corner-10x10-shed",
            v: "Little Cottage Co.",
            p: 4419,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/colonial-five-corner-storage-shed-main.jpg?v=1759425560",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "2–4 weeks production + 2–9 days shipping",
              h: "72″ sidewalls",
              w: "No",
            },
            c: 4659,
            q: [
              ["Without Floor Kit", 4419, "e0605wzed"],
              ["With Floor Kit", 5369, "e0605xool"],
            ],
          },
          {
            i: "32",
            t: "Little Cottage Co. Colonial Pinehurst Storage Shed Kit",
            h: "little-cottage-company-colonial-pinehurst-shed-kit",
            v: "Little Cottage Co.",
            p: 2499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x12-colonial-pinehurst-main_9c9bdbdf-1916-43a7-989a-039f99fa1095.jpg?v=1759419491",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2639,
            q: [
              ["8ft x 8ft", 2499, "e0uh7tyr9"],
              ["8ft x 10ft", 2979, "e0uh7uo1h"],
              ["8ft x 12ft", 3109, "e0uh7vdbp"],
              ["8ft x 14ft", 3569, "e0uh7w2lx"],
              ["8ft x 16ft", 3709, "e0uh7wrw5"],
              ["10ft x 10ft", 3349, "e0uh7xh6d"],
              ["10ft x 12ft", 3839, "e0uh7y6gl"],
              ["10ft x 14ft", 4249, "e0uh7yvqt"],
              ["10ft x 16ft", 4379, "e0uh7zl11"],
              ["10ft x 18ft", 4849, "e0uh80ab9"],
              ["10ft x 20ft", 4979, "e0uh80zlh"],
              ["12ft x 12ft", 4099, "e0uh81ovp"],
              ["12ft x 14ft", 4569, "e0uh82e5x"],
              ["12ft x 16ft", 5009, "e0uh833g5"],
              ["12ft x 18ft", 5169, "e0uh83sqd"],
              ["12ft x 20ft", 5329, "e0uh84i0l"],
              ["12ft x 24ft", 5859, "e0uh857at"],
            ],
          },
          {
            i: "33",
            t: "Little Cottage Co. Colonial Williamsburg Shed Kit",
            h: "little-cottage-company-colonial-williamsburg-storage-shed-kit",
            v: "Little Cottage Co.",
            p: 2649,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-colonial-williamsburg-main.jpg?v=1759419524",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2789,
            q: [
              ["8ft x 8ft", 2649, "e0ug111rp"],
              ["8ft x 10ft", 3149, "e0ug11r1x"],
              ["8ft x 12ft", 3329, "e0ug12gc5"],
              ["8ft x 14ft", 3799, "e0ug135md"],
              ["8ft x 16ft", 3949, "e0ug13uwl"],
              ["10ft x 10ft", 3479, "e0ug14k6t"],
              ["10ft x 12ft", 4009, "e0ug159h1"],
              ["10ft x 14ft", 4439, "e0ug15yr9"],
              ["10ft x 16ft", 4609, "e0ug16o1h"],
              ["10ft x 18ft", 5079, "e0ug17dbp"],
              ["10ft x 20ft", 5249, "e0ug182lx"],
              ["12ft x 12ft", 4189, "e0ug18rw5"],
              ["12ft x 14ft", 4649, "e0ug19h6d"],
              ["12ft x 16ft", 5119, "e0ug1a6gl"],
              ["12ft x 18ft", 5219, "e0ug1avqt"],
              ["12ft x 20ft", 5389, "e0ug1bl11"],
              ["12ft x 24ft", 6079, "e0ug1cab9"],
            ],
          },
          {
            i: "34",
            t: "Little Cottage Co. Star Barn Kit",
            h: "little-cottage-company-star-barn",
            v: "Little Cottage Co.",
            p: 9189,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-star-barn-storage-shed-kit.jpg?v=1718301285",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "6–8 weeks production + 2–9 days shipping",
              h: "76″ sidewalls",
              w: "No",
            },
            c: 9669,
            q: [
              ["10ft x 14ft", 9189, "e0uq6pk51"],
              ["10ft x 16ft", 10349, "e0uq6q9f9"],
              ["10ft x 18ft", 11639, "e0uq6qyph"],
              ["10ft x 20ft", 12919, "eywq204dx"],
            ],
          },
          {
            i: "35",
            t: "Little Cottage Co. Value Gable Shed",
            h: "little-cottage-company-value-gable-shed-kit",
            v: "Little Cottage Co.",
            p: 1569,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-value-gable-shed-kit-front.jpg?v=1759245611",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′3″ sidewalls",
              w: "No",
            },
            c: 1649,
            q: [
              ["8ft x 8ft", 1569, "e0uc725o5"],
              ["8ft x 10ft", 1729, "e0uc72uyd"],
              ["8ft x 12ft", 1889, "e0uc73k8l"],
              ["8ft x 14ft", 2059, "e0uc749it"],
              ["8ft x 16ft", 2219, "e0uc74yt1"],
              ["10ft x 10ft", 1949, "e0uc75o39"],
              ["10ft x 12ft", 2109, "e0uc76ddh"],
              ["10ft x 14ft", 2299, "e0uc772np"],
              ["10ft x 16ft", 2459, "e0uc77rxx"],
              ["10ft x 18ft", 2659, "e0uc78h85"],
              ["10ft x 20ft", 2839, "e0uc796id"],
              ["12ft x 12ft", 2309, "e0uc79vsl"],
              ["12ft x 14ft", 2499, "e0uc7al2t"],
              ["12ft x 16ft", 2709, "e0uc7bad1"],
              ["12ft x 18ft", 2879, "e0uc7bzn9"],
              ["12ft x 20ft", 3089, "e0uc7coxh"],
              ["12ft x 24ft", 3489, "e0uc7de7p"],
            ],
          },
          {
            i: "36",
            t: "Little Cottage Co. Value Gambrel Barn 4' Sidewalls",
            h: "little-cottage-company-value-gambrel-barn-4-sidewall-kit",
            v: "Little Cottage Co.",
            p: 1479,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-main.jpg?v=1759508554",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Floor not included; optional kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "3′9.5″ sidewalls",
              w: "No",
            },
            c: 1569,
            q: [
              ["8ft x 8ft", 1479, "e0ucrkb3p"],
              ["8ft x 10ft", 1599, "e0ucrl0dx"],
              ["8ft x 12ft", 1739, "e0ucrlpo5"],
              ["8ft x 14ft", 1889, "e0ucrmeyd"],
              ["8ft x 16ft", 2079, "e0ucrn48l"],
              ["10ft x 10ft", 1799, "e0ucrntit"],
              ["10ft x 12ft", 1989, "e0ucroit1"],
              ["10ft x 14ft", 2109, "e0ucrp839"],
              ["10ft x 16ft", 2259, "e0ucrpxdh"],
              ["10ft x 18ft", 2409, "e0ucrqmnp"],
              ["10ft x 20ft", 2559, "e0ucrrbxx"],
              ["12ft x 12ft", 2229, "e0ucrs185"],
              ["12ft x 14ft", 2409, "e0ucrsqid"],
              ["12ft x 16ft", 2569, "e0ucrtfsl"],
              ["12ft x 18ft", 2739, "e0ucru52t"],
              ["12ft x 20ft", 2909, "e0ucruud1"],
              ["12ft x 24ft", 3259, "e0ucrvjn9"],
            ],
          },
          {
            i: "37",
            t: "Little Cottage Co. Value Gambrel Barn 6' Sidewalls",
            h: "little-cottage-company-value-gambrel-barn-6-sidewall-kit",
            v: "Little Cottage Co.",
            p: 1679,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-6-sidewalls.jpg?v=1759324155",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′ sidewalls",
              w: "No",
            },
            c: 1769,
            q: [
              ["8ft x 8ft", 1679, "e0ucis9bp"],
              ["8ft x 10ft", 1869, "e0ucisylx"],
              ["8ft x 12ft", 2029, "e0ucitnw5"],
              ["8ft x 14ft", 2219, "e0uciud6d"],
              ["8ft x 16ft", 2469, "e0uciv2gl"],
              ["10ft x 10ft", 2069, "e0ucivrqt"],
              ["10ft x 12ft", 2259, "e0uciwh11"],
              ["10ft x 14ft", 2439, "e0ucix6b9"],
              ["10ft x 16ft", 2619, "e0ucixvlh"],
              ["10ft x 18ft", 2869, "e0uciykvp"],
              ["10ft x 20ft", 3059, "e0uciza5x"],
              ["12ft x 12ft", 2579, "e0ucizzg5"],
              ["12ft x 14ft", 2799, "e0ucj0oqd"],
              ["12ft x 16ft", 2999, "e0ucj1e0l"],
              ["12ft x 18ft", 3199, "e0ucj23at"],
              ["12ft x 20ft", 3419, "e0ucj2sl1"],
              ["12ft x 24ft", 3809, "e0ucj3hv9"],
            ],
          },
          {
            i: "38",
            t: "Little Cottage Co. Value Workshop Shed",
            h: "little-cottage-company-value-workshop-shed-kit",
            v: "Little Cottage Co.",
            p: 1749,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/value-workshop-8x10-front.jpg?v=1759247323",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′3″ sidewalls",
              w: "No",
            },
            c: 1839,
            q: [
              ["8ft x 8ft", 1749, "e0uem39dh"],
              ["8ft x 10ft", 1919, "e0uem3ynp"],
              ["8ft x 12ft", 2209, "e0uem4nxx"],
              ["8ft x 14ft", 2389, "e0uem5d85"],
              ["8ft x 16ft", 2559, "e0uem62id"],
              ["10ft x 10ft", 2139, "e0uem6rsl"],
              ["10ft x 12ft", 2439, "e0uem7h2t"],
              ["10ft x 14ft", 2629, "e0uem86d1"],
              ["10ft x 16ft", 2759, "e0uem8vn9"],
              ["10ft x 18ft", 2999, "e0uem9kxh"],
              ["10ft x 20ft", 3169, "e0uemaa7p"],
              ["12ft x 12ft", 2649, "e0uemazhx"],
              ["12ft x 14ft", 2829, "e0uemce2d"],
              ["12ft x 16ft", 3029, "e0uemd3cl"],
              ["12ft x 18ft", 3209, "e0uemdsmt"],
              ["12ft x 20ft", 3409, "e0uemehx1"],
              ["12ft x 24ft", 3809, "e0uemf779"],
            ],
          },
          {
            i: "39",
            t: "Outdoor Living Today 12x8 Saltbox Studio",
            h: "outdoor-living-today-12x8-saltbox-studio",
            v: "Outdoor Living Today",
            p: 13499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-12x8-saltbox-studio.webp?v=1769027284",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar roof system",
              f: "Wood floor/base components listed",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "Not listed",
              w: "No",
            },
            c: 15499,
          },
          {
            i: "40",
            t: "Outdoor Living Today 6x3 Oscar Waste Management Shed",
            h: "outdoor-living-today-6x3-oscar-waste-management-shed",
            v: "Outdoor Living Today",
            p: 1599,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/6x3-oscar-waste-management-shed-main.jpg?v=1711556132",
            s: {
              m: "Western Red Cedar wood",
              f: "Wood floor/base components listed",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              r: "Cedar roof system",
              h: "Not listed",
              w: "No",
            },
            c: 2289,
          },
          {
            i: "41",
            t: "Outdoor Living Today 6x4 SpaceMaster Wood Storage Shed with Double Doors",
            h: "outdoor-living-today-6x4-spacemaster-wood-storage-shed-with-double-doors",
            v: "Outdoor Living Today",
            p: 2199,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/olt-spacemaster-6x4-storage-garden-shed.jpg?v=1710522333",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar shingles or Galvalume metal, varies by variant",
              f: "Pre-assembled Western Red Cedar floor included",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "64″ min / 77.75″ max interior height",
              w: "No",
            },
            c: 2799,
            q: [
              ["Metal", 2199, "f9eqdon5h"],
              ["Cedar", 2199, "f9eqdpcfp"],
            ],
          },
          {
            i: "42",
            t: "Outdoor Living Today 9x9 Penthouse Cedar Garden Shed",
            h: "outdoor-living-today-9x9-penthouse-cedar-garden-shed",
            v: "Outdoor Living Today",
            p: 7499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/9x9-penthouse-cedar-garden-shed-main.webp?v=1710799316",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar shingles included",
              f: "5/8″ plywood floor over 2×4 cedar joists",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "Not listed",
              w: "No",
            },
            c: 9299,
          },
        ],
        S = [null, null],
        V = [0, 0],
        A = 0,
        R = document.getElementById("hs-shed-compare"),
        E = document.getElementById("hsScOverlay"),
        L = document.getElementById("hsScList"),
        Q = document.getElementById("hsScSearch"),
        C = document.getElementById("hsScCompare"),
        X = document.getElementById("hsScClose"),
        B = [document.getElementById("hsScSlot1"), document.getElementById("hsScSlot2")];
      function e(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      function m(n) {
        if (n == null || n === "") return '<span class="hs-sc-na">Not listed</span>';
        var x = Number(n);
        if (!isFinite(x)) return e(n);
        return "$" + x.toLocaleString(undefined, { maximumFractionDigits: x % 1 ? 2 : 0 });
      }
      function qs(v) {
        return Array.isArray(v) ? v[0] : v.s;
      }
      function qp(v) {
        return Array.isArray(v) ? v[1] : v.p;
      }
      function qid(v) {
        var x = Array.isArray(v) ? v[2] : v.i;
        return x ? parseInt(x, 36) : "";
      }
      function pr(p, i) {
        var q = p.q || [];
        return q.length > 1 && q[i] ? qp(q[i]) : p.p;
      }
      function cp(p) {
        return p.c;
      }
      function ph(p, i) {
        var q = p.q || [],
          id = q.length > 1 && q[i] ? qid(q[i]) : "";
        return (
          "/products/" +
          encodeURIComponent(p.h) +
          (id ? "?variant=" + encodeURIComponent(String(id)) : "")
        );
      }
      function priceHtml(p, i) {
        var a = pr(p, i),
          b = cp(p),
          h = m(a);
        if (b && Number(b) > Number(a)) h += '<span class="hs-sc-compare-at">' + m(b) + "</span>";
        return h;
      }
      function minVi(p) {
        var q = p.q || [],
          mi = 0,
          mp = Infinity;
        if (q.length < 2) return 0;
        q.forEach(function (v, i) {
          var n = Number(qp(v));
          if (isFinite(n) && n < mp) {
            mp = n;
            mi = i;
          }
        });
        return mi;
      }
      function card(p, slot) {
        var q = p.q || [],
          vi = V[slot] || 0;
        if (q.length > 1 && !q[vi]) vi = V[slot] = minVi(p);
        var sel = "";
        if (q.length > 1)
          sel =
            '<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize' +
            slot +
            '">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize' +
            slot +
            '" class="hs-sc-size-select" data-slot="' +
            slot +
            '">' +
            q
              .map(function (v, i) {
                return (
                  '<option value="' +
                  i +
                  '"' +
                  (i === vi ? " selected" : "") +
                  ">" +
                  e(qs(v)) +
                  " - " +
                  e(m(qp(v)).replace(/<[^>]+>/g, "")) +
                  "</option>"
                );
              })
              .join("") +
            '</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';
        return (
          '<img class="hs-sc-fi" loading="lazy" src="' +
          e(p.g || "") +
          '" alt="' +
          e(p.t) +
          '"><div class="hs-sc-brand">' +
          e(p.v || "") +
          '</div><div class="hs-sc-title">' +
          e(p.t || "") +
          '</div><div class="hs-sc-price" data-price-slot="' +
          slot +
          '">' +
          priceHtml(p, vi) +
          '</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="' +
          slot +
          '" href="' +
          ph(p, vi) +
          '" target="_blank">View product</a>' +
          sel +
          '<button type="button" class="hs-sc-change" data-change="' +
          slot +
          '">Change shed</button>'
        );
      }
      function empty(slot) {
        return (
          '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your ' +
          (slot ? "second" : "first") +
          " shed</span>"
        );
      }
      function renderSlots() {
        for (var i = 0; i < 2; i++) {
          B[i].className = "hs-sc-slot" + (S[i] ? " hs-sc-filled" : "");
          B[i].innerHTML = S[i] ? card(S[i], i) : empty(i);
        }
        renderCompare();
      }
      function val(p, k) {
        return p && p.s && p.s[k] ? e(p.s[k]) : '<span class="hs-sc-na">Not listed</span>';
      }
      function roofv(p, slot) {
        var q = p && (p.q || []),
          vi = V[slot] || 0,
          l = q.length > 1 && q[vi] ? String(qs(q[vi])) : "";
        if (/OSB Roof/i.test(l)) return "OSB roof";
        if (/Metal Roof/i.test(l)) return "Metal roof";
        return val(p, "r");
      }
      function renderCompare() {
        if (!S[0] && !S[1]) {
          C.innerHTML = "";
          return;
        }
        var n0 = S[0] ? e(S[0].t) : "Select a shed",
          n1 = S[1] ? e(S[1].t) : "Select a shed";
        var rows = [
          ["Material", val(S[0], "m"), val(S[1], "m")],
          ["Roof type", roofv(S[0], 0), roofv(S[1], 1)],
          ["Floor kit", val(S[0], "f"), val(S[1], "f")],
          ["Wall height", val(S[0], "h"), val(S[1], "h")],
          ["Custom door and window placement", val(S[0], "w"), val(S[1], "w")],
          ["Lead time", val(S[0], "l"), val(S[1], "l")],
        ];
        C.innerHTML =
          '<div class="hs-sc-compare-table" role="table" aria-label="Selected shed comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n0 +
          '</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n1 +
          "</div>" +
          rows
            .map(function (r) {
              return (
                '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">' +
                r[0] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[1] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[2] +
                "</div>"
              );
            })
            .join("") +
          "</div>";
      }
      function open(slot) {
        A = slot;
        E.classList.add("hs-sc-is-open");
        E.setAttribute("aria-hidden", "false");
        document.body.classList.add("hs-sc-lock");
        Q.value = "";
        list("");
        setTimeout(function () {
          Q.focus();
        }, 30);
      }
      function close() {
        E.classList.remove("hs-sc-is-open");
        E.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hs-sc-lock");
      }
      function list(term) {
        term = (term || "").toLowerCase();
        var items = P.filter(function (p) {
          return (
            !term ||
            (p.t || "").toLowerCase().indexOf(term) > -1 ||
            (p.v || "").toLowerCase().indexOf(term) > -1
          );
        });
        L.innerHTML =
          items
            .map(function (p) {
              return (
                '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="' +
                e(p.i) +
                '"><img loading="lazy" src="' +
                e(p.g || "") +
                '" alt="' +
                e(p.t) +
                '"><div class="hs-sc-pi-brand">' +
                e(p.v || "") +
                '</div><div class="hs-sc-pi-title">' +
                e(p.t || "") +
                '</div><div class="hs-sc-pi-price">From ' +
                m(p.p) +
                "</div></div>"
              );
            })
            .join("") || '<p class="hs-sc-na">No sheds found.</p>';
      }
      B.forEach(function (b, i) {
        b.addEventListener("click", function (ev) {
          if (ev.target.closest(".hs-sc-change")) {
            open(i);
            return;
          }
          if (!S[i]) open(i);
        });
      });
      R.addEventListener("change", function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains("hs-sc-size-select")) {
          var slot = Number(el.getAttribute("data-slot")),
            p = S[slot];
          V[slot] = Number(el.value) || 0;
          var price = R.querySelector('[data-price-slot="' + slot + '"]'),
            link = R.querySelector('[data-link-slot="' + slot + '"]');
          if (price && p) price.innerHTML = priceHtml(p, V[slot]);
          if (link && p) link.setAttribute("href", ph(p, V[slot]));
          renderCompare();
        }
      });
      L.addEventListener("click", function (ev) {
        var it = ev.target.closest(".hs-sc-picker-item");
        if (!it) return;
        var id = it.getAttribute("data-id"),
          p = P.find(function (x) {
            return String(x.i) === String(id);
          });
        if (p) {
          S[A] = p;
          V[A] = minVi(p);
          close();
          renderSlots();
        }
      });
      L.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          var it = ev.target.closest(".hs-sc-picker-item");
          if (it) {
            ev.preventDefault();
            it.click();
          }
        }
      });
      Q.addEventListener("input", function () {
        list(Q.value);
      });
      X.addEventListener("click", close);
      E.addEventListener("click", function (ev) {
        if (ev.target === E) close();
      });
      document.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape" && E.classList.contains("hs-sc-is-open")) close();
      });
      function curh() {
        var m = String(location.pathname || "").match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).replace(/\/$/, "") : "";
      }
      function initCurrent() {
        var h = curh(),
          p =
            h &&
            P.find(function (x) {
              return String(x.h) === h;
            });
        if (p) {
          S[0] = p;
          V[0] = minVi(p);
        }
      }
      initCurrent();
      renderSlots();

      // ===== Live price refresh (lazy fetch with optimistic render) =====
      // Paste this inside the main comparison-tool IIFE, replacing the original final:
      // initCurrent();
      // renderSlots();
      // })();
      //
      // This refreshes live Shopify storefront pricing from /products/{handle}.js.
      // It updates product price, compare-at price, variant prices, and variant IDs.
      // It does not add brand-new products or brand-new variants to the baked-in catalog.

      var LIVE = {}; // handle -> { done: true, loading: false }

      function toBase36(n) {
        return Number(n).toString(36);
      }

      function centsToDollars(v) {
        var n = Number(v);
        return isFinite(n) ? n / 100 : null;
      }

      function variantId36(v) {
        return Array.isArray(v) ? v[2] : v && v.i;
      }

      function variantIdNum(v) {
        var x = variantId36(v);
        return x ? parseInt(x, 36) : null;
      }

      function findLiveVariant(data, oldVariant) {
        var oldTitle = qs(oldVariant);
        var oldIdNum = variantIdNum(oldVariant);

        return (
          data.variants.find(function (v) {
            return oldIdNum && String(v.id) === String(oldIdNum);
          }) ||
          data.variants.find(function (v) {
            return v.title === oldTitle || v.public_title === oldTitle || v.name === oldTitle;
          }) ||
          null
        );
      }

      function fetchLive(p, cb) {
        if (!p || !p.h) return;

        if (LIVE[p.h] && LIVE[p.h].done) {
          cb && cb();
          return;
        }

        if (LIVE[p.h] && LIVE[p.h].loading) {
          setTimeout(function () {
            fetchLive(p, cb);
          }, 80);
          return;
        }

        LIVE[p.h] = { loading: true, done: false };

        try {
          fetch('/products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data || !data.variants || !data.variants.length) {
                LIVE[p.h] = { loading: false, done: true };
                cb && cb();
                return;
              }

              var oldQ = p.q || [];
              var newQ = oldQ.map(function (oldVariant) {
                var match = findLiveVariant(data, oldVariant);
                if (!match) return oldVariant;

                var livePrice = centsToDollars(match.price);
                return [qs(oldVariant), livePrice != null ? livePrice : qp(oldVariant), toBase36(match.id)];
              });

              // If this product had no baked-in variant dropdown, use the storefront product-level price.
              if (!newQ.length && data.price != null) {
                var topPrice = centsToDollars(data.price);
                if (topPrice != null) p.p = topPrice;
              }

              // If variants are present, use the lowest live variant price as the product's displayed From price.
              if (newQ.length) {
                var minPrice = Infinity;
                newQ.forEach(function (v) {
                  var price = Number(qp(v));
                  if (isFinite(price) && price < minPrice) minPrice = price;
                });
                if (isFinite(minPrice)) p.p = minPrice;
                p.q = newQ;
              }

              // Update compare-at price too. Prefer product-level compare_at_price, then max variant compare_at_price.
              var liveCompareAt = centsToDollars(data.compare_at_price);
              if (liveCompareAt == null) {
                data.variants.forEach(function (v) {
                  var ca = centsToDollars(v.compare_at_price);
                  if (ca != null && (liveCompareAt == null || ca > liveCompareAt)) liveCompareAt = ca;
                });
              }
              if (liveCompareAt != null) p.c = liveCompareAt;

              LIVE[p.h] = { loading: false, done: true };
              cb && cb();
            })
            .catch(function () {
              LIVE[p.h] = { loading: false, done: false };
            });
        } catch (e) {
          LIVE[p.h] = { loading: false, done: false };
        }
      }

      function refreshSlot(slot, preferMinVariant) {
        var p = S[slot];
        if (!p) return;

        var beforeIndex = V[slot] || 0;
        var beforeVariant = p.q && p.q[beforeIndex] ? p.q[beforeIndex] : null;
        var beforeTitle = beforeVariant ? qs(beforeVariant) : null;
        var beforeId = beforeVariant ? variantId36(beforeVariant) : null;

        fetchLive(p, function () {
          if (preferMinVariant) {
            V[slot] = minVi(p);
          } else if (p.q && p.q.length && beforeVariant) {
            var matchedIndex = p.q.findIndex(function (v) {
              return (beforeId && variantId36(v) === beforeId) || (beforeTitle && qs(v) === beforeTitle);
            });
            V[slot] = matchedIndex > -1 ? matchedIndex : Math.min(beforeIndex, p.q.length - 1);
          }
          renderSlots();
        });
      }

      // Refresh slot 1, the auto-loaded current product, shortly after load.
      if (S[0]) {
        setTimeout(function () {
          refreshSlot(0, true);
        }, 50);
      }

      // Hook into the modal-pick handler. The original picker handler stays intact;
      // this runs one tick later, after S[A] has been updated.
      L.addEventListener('click', function (ev) {
        var it = ev.target.closest('.hs-sc-picker-item');
        if (!it) return;
        setTimeout(function () {
          refreshSlot(A, true);
        }, 0);
      });

      // Preserve a user's selected variant when they change the dropdown and live data is not fetched yet.
      R.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains('hs-sc-size-select')) {
          var slot = Number(el.getAttribute('data-slot'));
          setTimeout(function () {
            refreshSlot(slot, false);
          }, 0);
        }
      });

      // Background-prefetch picker product prices once the modal opens.
      var _origOpen = open;
      open = function (slot) {
        _origOpen(slot);
        var i = 0;
        function prefetchNext() {
          if (i >= P.length) return;
          var p = P[i++];
          if (p && p.h && !(LIVE[p.h] && LIVE[p.h].done)) {
            fetchLive(p, function () {
              if (E.classList.contains('hs-sc-is-open')) list(Q.value);
            });
          }
          setTimeout(prefetchNext, 60);
        }
        prefetchNext();
      };
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-shed-comparison-tool-ezfit-assets"] && !Shopify.designMode) return;
  try {
    (function () {
      var P = [
          {
            i: "1",
            t: "Cedarshed Boathouse Canoe & Kayak Storage Shed Kit",
            h: "cedarshed-boathouse-canoe-kayak-storage-shed",
            v: "Cedarshed",
            p: 4209,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-canoe-and-kayak-storage-shed.jpg?v=1714160020",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4909.99,
            q: [
              ["Boathouse 12x6 with Cedar Roof Shingles", 4479, "2mcfpi59x"],
              ["Boathouse 12x8 with Cedar Roof Shingles", 5099, "2mcfpiuk5"],
              ["Boathouse 16x8 with Cedar Roof Shingles", 6279, "2mcfpjjud"],
              ["Boathouse 12x10 with Cedar Roof Shingles", 5379, "2mcfpk94l"],
              ["Boathouse 16x10 with Cedar Roof Shingles", 6279, "2mcfpkyet"],
              ["Boathouse 12x6 with Metal Roof", 4479, "fs71ao2et"],
              ["Boathouse 12x8 with Metal Roof", 5099, "fs71aorp1"],
              ["Boathouse 16x8 with Metal Roof", 6039, "fs71apgz9"],
              ["Boathouse 12x10 with Metal Roof", 5299, "fs71aq69h"],
              ["Boathouse 16x10 with Metal Roof", 6149, "fs71aqvjp"],
              ["Boathouse 12x6 with OSB Roof", 4209, "eibyq5645"],
              ["Boathouse 12x8 with OSB Roof", 4559, "eibyqx9h1"],
              ["Boathouse 16x8 with OSB Roof", 4999, "eibyr4ab9"],
              ["Boathouse 12x10 with OSB Roof", 4649, "eibyr8i0l"],
              ["Boathouse 16x10 with OSB Roof", 5379, "eibyrdf05"],
            ],
          },
          {
            i: "2",
            t: "Cedarshed Cabana Backyard & Pool Shed",
            h: "cedarshed-cabana-backyard-shed",
            v: "Cedarshed",
            p: 3459,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cabana-backyard-pool-shed-main.jpg?v=1713808378",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3799.99,
            q: [
              ["Cabana 9x6 with Cedar Roof Shingles", 4119, "2lp23erzp"],
              ["Cabana 10x8 with Cedar Roof Shingles", 4939, "2lp23fh9x"],
              ["Cabana 12x8 with Cedar Roof Shingles", 5239, "2lp23g6k5"],
              ["Cabana 12x10 with Cedar Roof Shingles", 5549, "2lp23gvud"],
              ["Cabana 9x6 with Metal Roof", 3949, "fs71k1vzp"],
              ["Cabana 10x8 with Metal Roof", 4729, "fs71k2l9x"],
              ["Cabana 12x8 with Metal Roof", 5119, "fs71k3ak5"],
              ["Cabana 12x10 with Metal Roof", 5509, "fs71k3zud"],
              ["Cabana 9x6 with OSB Roof", 3459, "eibx4gdh1"],
              ["Cabana 10x8 with OSB Roof", 4159, "eibx4mp11"],
              ["Cabana 12x8 with OSB Roof", 4459, "eibx4q7g5"],
              ["Cabana 12x10 with OSB Roof", 4749, "eibx4uf5h"],
            ],
          },
          {
            i: "3",
            t: "Cedarshed Cedar House Storage Shed",
            h: "cedarshed-cedarhouse-storage-shed",
            v: "Cedarshed",
            p: 4029,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cedar-house-storage-shed-main.webp?v=1714519762",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4849,
            q: [
              ["CEDARHOUSE 10x8 with Cedar Roof Shingles", 4649, "2loo3nv3p"],
              ["CEDARHOUSE 10x10 with Cedar Roof Shingles", 4929, "2loo3p9o5"],
              ["CEDARHOUSE 10x12 with Cedar Roof Shingles", 5549, "2loo3qo8l"],
              ["CEDARHOUSE 10x16 with Cedar Roof Shingles", 6449, "2loo3s2t1"],
              ["CEDARHOUSE 10x20 with Cedar Roof Shingles", 7629, "2loo3ss39"],
              ["CEDARHOUSE 10x8 with Metal Roof", 4539, "fs7wllkj9"],
              ["CEDARHOUSE 10x10 with Metal Roof", 4779, "fs7wlm9th"],
              ["CEDARHOUSE 10x12 with Metal Roof", 5499, "fs7wlmz3p"],
              ["CEDARHOUSE 10x16 with Metal Roof", 6079, "fs7wlnodx"],
              ["CEDARHOUSE 10x20 with Metal Roof", 7349, "fs7wlodo5"],
              ["CEDARHOUSE 10x8 with OSB Roof", 4029, "eibxumwj9"],
              ["CEDARHOUSE 10x10 with OSB Roof", 4199, "eibxv2cs5"],
              ["CEDARHOUSE 10x12 with OSB Roof", 4839, "eibxv5v79"],
              ["CEDARHOUSE 10x16 with OSB Roof", 5299, "eibxvbhh1"],
              ["CEDARHOUSE 10x20 with OSB Roof", 6279, "eibxvdlbp"],
            ],
          },
          {
            i: "4",
            t: "Cedarshed Cookhouse BBQ Shed",
            h: "cedarshed-cookhouse-cooking-bbq-sheds",
            v: "Cedarshed",
            p: 6819,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cookhouse-bbq-shed-main.webp?v=1714587118",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 8099,
            q: [
              ["Cookhouse 12x10 with Cedar Roof Shingles", 7449, "benb0nwhh"],
              ["Cookhouse 16x12 with Cedar Roof Shingles", 8799, "benb0olrp"],
              ["Cookhouse 16x14 with Cedar Roof Shingles", 8979, "benb0pb1x"],
              ["Cookhouse 12x10 with OSB Roof", 6819, "eic096g51"],
              ["Cookhouse 16x12 with OSB Roof", 7539, "eic09jsj9"],
              ["Cookhouse 16x14 with OSB Roof", 7629, "eic0baat1"],
            ],
          },
          {
            i: "5",
            t: "Cedarshed DIY 4x4 Green Pod Wooden Garbage Can & Recycling Bin Shed Kits",
            h: "cedarshed-green-pod-garbage-recycling-shed",
            v: "Cedarshed",
            p: 2279.99,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-wooden-garbage-can-shed-kit.webp?v=1714414026",
            s: {
              m: "100% Western Red Cedar",
              r: "Tongue-and-groove roof panels; OSB version available",
              f: "Not listed",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 2899.99,
          },
          {
            i: "6",
            t: "Cedarshed Farmhouse Shed Kit",
            h: "cedarshed-farmhouse-shed-kits",
            v: "Cedarshed",
            p: 7499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-farmhouse-shed-kit-main.webp?v=1714409778",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 8749,
            q: [
              ["Farmhouse 16x12 with Cedar Roof Shingles", 8979, "beoltxfzp"],
              ["Farmhouse 16x14 with Cedar Roof Shingles", 9879, "beolty59x"],
              ["Farmhouse 20x12 with Cedar Roof Shingles", 10699, "beoltyuk5"],
              ["Farmhouse 20x14 with Cedar Roof Shingles", 11599, "beoltzjud"],
              ["Farmhouse 16x12 with Metal Roof", 8979, "fwsubo1f9"],
              ["Farmhouse 16x14 with Metal Roof", 9879, "fwsuboqph"],
              ["Farmhouse 20x12 with Metal Roof", 10699, "fwsubpfzp"],
              ["Farmhouse 20x14 with Metal Roof", 11599, "fwsubq59x"],
              ["Farmhouse 16x12 with OSB Roof", 7499, "eic0t3j1x"],
              ["Farmhouse 16x14 with OSB Roof", 7719, "eic0tkdv9"],
              ["Farmhouse 20x12 with OSB Roof", 8979, "eic0ttik5"],
              ["Farmhouse 20x14 with OSB Roof", 9419, "eic0u5gdx"],
            ],
          },
          {
            i: "7",
            t: "Cedarshed Gable Style Beach House Shed",
            h: "cedarshed-gable-style-beach-house-shed-kit",
            v: "Cedarshed",
            p: 4079,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gable-style-beach-house-shed.webp?v=1714495934",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4889.99,
            q: [
              ["Beachhouse 9x6 with Cedar Roof Shingles", 4799, "bf0wwsz05"],
              ["Beachhouse 10x8 with Cedar Roof Shingles", 5549, "bf0wwtoad"],
              ["Beachhouse 12x8 with Cedar Roof Shingles", 6199, "bf0wwudkl"],
              ["Beachhouse 9x6 with Metal Roof", 4649, "fs70t3yut"],
              ["Beachhouse 10x8 with Metal Roof", 5379, "fs70t4o51"],
              ["Beachhouse 12x8 with Metal Roof", 5979, "fs70t5df9"],
              ["Beachhouse 9x6 with OSB Roof", 4079, "eibzeopbp"],
              ["Beachhouse 10x8 with OSB Roof", 4979, "eibzfpxdh"],
              ["Beachhouse 12x8 with OSB Roof", 5379, "eibzgr5f9"],
            ],
          },
          {
            i: "8",
            t: "Cedarshed Garden Hutch",
            h: "cedarshed-garden-hutch",
            v: "Cedarshed",
            p: 1779,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardeners-hutch-storage-shed-main.webp?v=1714512776",
            s: {
              m: "100% Western Red Cedar",
              r: "Not listed",
              f: "Not listed",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 1959,
          },
          {
            i: "9",
            t: "Cedarshed Gardener Small Gable Shed Kit",
            h: "cedarshed-gardener-small-gable-shed-kit",
            v: "Cedarshed",
            p: 3029,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardener-small-gable-shed-kit.webp?v=1714149172",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3299.99,
            q: [
              ["Gardener 6x6 with Cedar Roof Shingles", 3229, "2lolr396d"],
              ["Gardener 6x9 with Cedar Roof Shingles", 3739, "eibxitzqt"],
              ["Gardener 6x12 with Cedar Roof Shingles", 4549, "2lolr4nqt"],
              ["Gardener 8x10 with Cedar Roof Shingles", 4549, "2lolr5d11"],
              ["Gardener 8x12 with Cedar Roof Shingles", 4949, "2lolr62b9"],
              ["Gardener 8x16 with Cedar Roof Shingles", 5929, "2lolr6rlh"],
              ["Gardener 6x6 with Metal Roof", 3279, "fs721wit1"],
              ["Gardener 6x9 with Metal Roof", 3769, "fs721xxdh"],
              ["Gardener 6x12 with Metal Roof", 4319, "fs721x839"],
              ["Gardener 8x10 with Metal Roof", 4569, "fs721ymnp"],
              ["Gardener 8x12 with Metal Roof", 4969, "fs721zbxx"],
              ["Gardener 8x16 with Metal Roof", 5849, "fs7220185"],
              ["Gardener 6x6 with OSB Roof", 3029, "eibxgsy7p"],
              ["Gardener 6x9 with OSB Roof", 3459, "2lolr3ygl"],
              ["Gardener 6x12 with OSB Roof", 3779, "eibxjqat1"],
              ["Gardener 8x10 with OSB Roof", 4169, "eibxjvx2t"],
              ["Gardener 8x12 with OSB Roof", 4319, "eibxkj3g5"],
              ["Gardener 8x16 with OSB Roof", 5129, "eibxkvqk5"],
            ],
          },
          {
            i: "10",
            t: "Cedarshed Haida Cabin & Storage Shed",
            h: "cedarshed-haida-cabin-storage-shed",
            v: "Cedarshed",
            p: 3939.99,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-haida-storage-shed-fully-assembled.webp?v=1714406713",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′",
              w: "Yes",
            },
            c: 4639.99,
            q: [
              ["Haida 9x6 with Cedar Roof Shingles", 4559.99, "2mcrgr8l1"],
              ["Haida 12x8 with Cedar Roof Shingles", 5549.99, "2mcrgrxv9"],
              ["Haida 12x10 with Cedar Roof Shingles", 5919.99, "2mcrgsn5h"],
              ["Haida 9x6 with Metal Roof", 4399.99, "fs726hkj9"],
              ["Haida 12x8 with Metal Roof", 5379.99, "fs726i9th"],
              ["Haida 12x10 with Metal Roof", 5549.99, "fs726iz3p"],
              ["Haida 9x6 with OSB Roof", 3939.99, "eibzpbh2t"],
              ["Haida 12x8 with OSB Roof", 4799.99, "eibzpsbw5"],
              ["Haida 12x10 with OSB Roof", 4899.99, "eibzql4j9"],
            ],
          },
          {
            i: "11",
            t: "Cedarshed Hobbyhouse Prefab Shed Kits",
            h: "cedarshed-hobbyhouse-prefab-shed-kits",
            v: "Cedarshed",
            p: 3669,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-hobbyhouse-she-shed-kit-main.webp?v=1714589468",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB; skylight roof variants shown",
              f: "5/8″ plywood over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′",
              w: "Yes",
            },
            c: 4489,
            q: [
              ["Hobbyhouse 9' x 6' with Cedar & Skylight Roof", 4079, "bembid06t"],
              ["Hobbyhouse 10' x 8' with Cedar & Skylight Roof", 4769, "bembidph1"],
              ["Hobbyhouse 12' x 8' with Cedar & Skylight Roof", 5179, "bembieer9"],
              ["Hobbyhouse 12' x 10' with Cedar & Skylight Roof", 5529, "bembif41h"],
              ["Hobbyhouse 9' x 6' with OSB & Skylight Roof", 3669, "eic109zjp"],
              ["Hobbyhouse 10' x 8' with OSB & Skylight Roof", 4159, "eic10q52t"],
              ["Hobbyhouse 12' x 8' with OSB & Skylight Roof", 5349, "eic11b7lh"],
              ["Hobbyhouse 12' x 10' with OSB & Skylight Roof", 4619, "eic11wzed"],
            ],
          },
          {
            i: "12",
            t: "Cedarshed Lean To Storage Bayside Shed",
            h: "cedarshed-lean-to-storage-shed",
            v: "Cedarshed",
            p: 2059,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-lean-to-shingles-roof.png?v=1713987560",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "Not listed",
              w: "Yes",
            },
            c: 2374,
            q: [
              ["Bayside 6x3 with Cedar Roof Shingles / Double Doors", 2339, "dyf9r1ulx"],
              ["Bayside 6x3 with Cedar Roof Shingles / Dutch Door with Window", 2189, "dzqsa6vqt"],
              [
                "Bayside 6x3 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2488,
                "dzqsv1oad",
              ],
              [
                "Bayside 6x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2498,
                "feinsygj9",
              ],
              ["Bayside 6x4 with Cedar Roof Shingles / Double Doors", 2709, "fv4w66n1x"],
              ["Bayside 6x4 with Cedar Roof Shingles / Dutch Door with Window", 2709, "fv4w67cc5"],
              [
                "Bayside 6x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2858,
                "fv4w681md",
              ],
              [
                "Bayside 6x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2868,
                "fv4w68qwl",
              ],
              ["Bayside 8x3 with Cedar Roof Shingles / Double Doors", 2709, "dyf9rd35h"],
              ["Bayside 8x3 with Cedar Roof Shingles / Dutch Door with Window", 2709, "dzqsb3w39"],
              [
                "Bayside 8x3 with Cedar Roof Shingles / Sliding Door (no window) $149",
                2858,
                "dzqsvxzcl",
              ],
              [
                "Bayside 8x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                2868,
                "feinsz5th",
              ],
              ["Bayside 8x4 with Cedar Roof Shingles / Double Doors", 2879, "dzqsevfw5"],
              ["Bayside 8x4 with Cedar Roof Shingles / Dutch Door with Window", 2879, "dyf9rkt9x"],
              [
                "Bayside 8x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                3028,
                "dzqswx3jp",
              ],
              [
                "Bayside 8x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                3038,
                "feinszv3p",
              ],
              ["Bayside 12x4 with Cedar Roof Shingles / Double Doors", 3739, "e043fnqd1"],
              ["Bayside 12x4 with Cedar Roof Shingles / Dutch Door with Window", 3739, "dyf9rmx4l"],
              [
                "Bayside 12x4 with Cedar Roof Shingles / Sliding Door (no window) $149",
                3888,
                "dzqsx9qnp",
              ],
              [
                "Bayside 12x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",
                3898,
                "feint0kdx",
              ],
              ["Bayside 6x3 with Metal Roof / Double Doors", 2299, "fs7uyz29h"],
              ["Bayside 6x3 with Metal Roof / Dutch Door with Window", 2299, "fs7uyzrjp"],
              ["Bayside 6x3 with Metal Roof / Sliding Door (no window) $149", 2448, "fs7uz0gtx"],
              [
                "Bayside 6x3 with Metal Roof / Double Doors with One Fixed Window $159",
                2458,
                "fs7uz1645",
              ],
              ["Bayside 6x4 with Metal Roof / Double Doors", 2539, "fv4w69g6t"],
              ["Bayside 6x4 with Metal Roof / Dutch Door with Window", 2539, "fv4w6a5h1"],
              ["Bayside 6x4 with Metal Roof / Sliding Door (no window) $149", 2688, "fv4w6aur9"],
              [
                "Bayside 6x4 with Metal Roof / Double Doors with One Fixed Window $159",
                2698,
                "fv4w6bk1h",
              ],
              ["Bayside 8x3 with Metal Roof / Double Doors", 2539, "fs7uz1ved"],
              ["Bayside 8x3 with Metal Roof / Dutch Door with Window", 2539, "fs7uz2kol"],
              ["Bayside 8x3 with Metal Roof / Sliding Door (no window) $149", 2688, "fs7uz39yt"],
              [
                "Bayside 8x3 with Metal Roof / Double Doors with One Fixed Window $159",
                2698,
                "fs7uz3z91",
              ],
              ["Bayside 8x4 with Metal Roof / Double Doors", 2749.99, "fs7uz4oj9"],
              ["Bayside 8x4 with Metal Roof / Dutch Door with Window", 2749.99, "fs7uz5dth"],
              ["Bayside 8x4 with Metal Roof / Sliding Door (no window) $149", 2899, "fs7uz633p"],
              [
                "Bayside 8x4 with Metal Roof / Double Doors with One Fixed Window $159",
                2909,
                "fs7uz6sdx",
              ],
              ["Bayside 12x4 with Metal Roof / Double Doors", 3419, "fs7uz7ho5"],
              ["Bayside 12x4 with Metal Roof / Dutch Door with Window", 3419, "fs7uz86yd"],
              ["Bayside 12x4 with Metal Roof / Sliding Door (no window) $149", 3569, "fs7uz8w8l"],
              [
                "Bayside 12x4 with Metal Roof / Double Doors with One Fixed Window $159",
                3579,
                "fs7uz9lit",
              ],
              ["Bayside 6x3 with OSB Roof / Double Doors", 2059, "eic4p2245"],
              ["Bayside 6x3 with OSB Roof / Dutch Door with Window", 2059, "eic4pl0s5"],
              ["Bayside 6x3 with OSB Roof / Sliding Door (no window) $149", 2209, "eic4q1vlh"],
              [
                "Bayside 6x3 with OSB Roof / Double Doors with One Fixed Window $159",
                2219,
                "feint19o5",
              ],
              ["Bayside 6x4 with OSB Roof / Double Doors", 2429, "fv4w6c9bp"],
              ["Bayside 6x4 with OSB Roof / Dutch Door with Window", 2429, "fv4w6cylx"],
              ["Bayside 6x4 with OSB Roof / Sliding Door (no window) $149", 2579, "fv4w6dnw5"],
              [
                "Bayside 6x4 with OSB Roof / Double Doors with One Fixed Window $159",
                2589,
                "fv4w6ed6d",
              ],
              ["Bayside 8x3 with OSB Roof / Double Doors", 2429, "eic4s8jed"],
              ["Bayside 8x3 with OSB Roof / Dutch Door with Window", 2429, "eic4sv0hh"],
              ["Bayside 8x3 with OSB Roof / Sliding Door (no window) $149", 2579, "eic4t5jqt"],
              [
                "Bayside 8x3 with OSB Roof / Double Doors with One Fixed Window $159",
                2589,
                "feint1yyd",
              ],
              ["Bayside 8x4 with OSB Roof / Double Doors", 2489, "eic4u2k39"],
              ["Bayside 8x4 with OSB Roof / Dutch Door with Window", 2489, "eic4um81h"],
              ["Bayside 8x4 with OSB Roof / Sliding Door (no window) $149", 2639, "eic4v3s51"],
              [
                "Bayside 8x4 with OSB Roof / Double Doors with One Fixed Window $159",
                2649,
                "feint2o8l",
              ],
              ["Bayside 12x4 with OSB Roof / Double Doors", 3279, "eic4vq985"],
              ["Bayside 12x4 with OSB Roof / Dutch Door with Window", 3279, "eic4wjr5h"],
              ["Bayside 12x4 with OSB Roof / Sliding Door (no window) $149", 3428, "eic4x688l"],
              [
                "Bayside 12x4 with OSB Roof / Double Doors with One Fixed Window $159",
                3438,
                "feint3dit",
              ],
            ],
          },
          {
            i: "13",
            t: "Cedarshed Longhouse Gable Style Double Door Shed Kit",
            h: "cedarshed-longhouse-double-door-shed",
            v: "Cedarshed",
            p: 4309,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-longhouse-double-door-shed-kit.webp?v=1714066930",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 4719.99,
            q: [
              ["Longhouse 12x6 with Cedar Roof Shingles", 4899, "2mc6cqhpx"],
              ["Longhouse 12x8 with Cedar Roof Shingles", 5299, "2mc6cr705"],
              ["Longhouse 16x8 with Cedar Roof Shingles", 6199, "2mc6crwad"],
              ["Longhouse 12x10 with Cedar Roof Shingles", 6099, "2mc6cslkl"],
              ["Longhouse 16x10 with Cedar Roof Shingles", 6899, "2mc6ctaut"],
              ["Longhouse 12x6 with Metal Roof", 4399, "fs72awaph"],
              ["Longhouse 12x8 with Metal Roof", 5199, "fs72awzzp"],
              ["Longhouse 16x8 with Metal Roof", 6099, "fs72axp9x"],
              ["Longhouse 12x10 with Metal Roof", 5899, "fs72az3ud"],
              ["Longhouse 16x10 with Metal Roof", 6599, "fs72ayek5"],
              ["Longhouse 12x6 with OSB Roof", 4309, "eibynz7lh"],
              ["Longhouse 12x8 with OSB Roof", 4599, "eibyo20qd"],
              ["Longhouse 16x8 with OSB Roof", 5399, "eibyoohth"],
              ["Longhouse 12x10 with OSB Roof", 5199, "eibyop73p"],
              ["Longhouse 16x10 with OSB Roof", 5699, "eibyp14xh"],
            ],
          },
          {
            i: "14",
            t: "Cedarshed Rancher Large Shed Kit and Storage Solution",
            h: "cedarshed-large-rancher-shed-kit-storage-solution",
            v: "Cedarshed",
            p: 2989,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-rancher-shed-kit-and-storage-solution.webp?v=1713988928",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles, metal, or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "6′, 7′ optional",
              w: "Yes",
            },
            c: 3259.99,
            q: [
              ["RANCHER 6x6 with Cedar Roof Shingles", 3469, "2louk0myd"],
              ["RANCHER 6x9 with Cedar Roof Shingles", 3979, "2louk1c8l"],
              ["RANCHER 6x12 with Cedar Roof Shingles", 4759, "2louk21it"],
              ["RANCHER 8x8 with Cedar Roof Shingles", 4319, "en18u7ar9"],
              ["RANCHER 8x10 with Cedar Roof Shingles", 4979, "2louk2qt1"],
              ["RANCHER 8x12 with Cedar Roof Shingles", 5179, "2louk3g39"],
              ["RANCHER 8x16 with Cedar Roof Shingles", 6479, "2louk45dh"],
              ["RANCHER 10x10 with Cedar Roof Shingles", 5279, "2louk4unp"],
              ["RANCHER 10x12 with Cedar Roof Shingles", 5679, "2louk5jxx"],
              ["RANCHER 10x16 with Cedar Roof Shingles", 6579, "2louk6985"],
              ["RANCHER 10x20 with Cedar Roof Shingles", 7879, "2louk6yid"],
              ["RANCHER 6x6 with Metal Roof", 3329, "fs7vugmk5"],
              ["RANCHER 6x9 with Metal Roof", 3859, "fs7vuhbud"],
              ["RANCHER 6x12 with Metal Roof", 4679, "fs7vui14l"],
              ["RANCHER 8x8 with Metal Roof", 4239, "fs7vuiqet"],
              ["RANCHER 8x10 with Metal Roof", 4699, "fs7vujfp1"],
              ["RANCHER 8x12 with Metal Roof", 4899, "fs7vuk4z9"],
              ["RANCHER 8x16 with Metal Roof", 6019, "fs7vuku9h"],
              ["RANCHER 10x10 with Metal Roof", 4899, "fs7vuljjp"],
              ["RANCHER 10x12 with Metal Roof", 5299, "fs7vum8tx"],
              ["RANCHER 10x16 with Metal Roof", 6319, "fs7vumy45"],
              ["RANCHER 10x20 with Metal Roof", 7519, "fs7vunned"],
              ["RANCHER 6x6 with OSB Roof", 2989, "eiby3rlf9"],
              ["RANCHER 6x9 with OSB Roof", 3379, "eiby48g8l"],
              ["RANCHER 6x12 with OSB Roof", 4139, "eiby4zub9"],
              ["RANCHER 8x8 with OSB Roof", 3739, "en18v6eyd"],
              ["RANCHER 8x10 with OSB Roof", 4139, "eiby5i3p1"],
              ["RANCHER 8x12 with OSB Roof", 4269, "eiby5yyid"],
              ["RANCHER 8x16 with OSB Roof", 5309, "euwz88hth"],
              ["RANCHER 10x10 with OSB Roof", 4269, "eiby6a71x"],
              ["RANCHER 10x12 with OSB Roof", 4559, "eiby6r1v9"],
              ["RANCHER 10x16 with OSB Roof", 5469, "eibya0cad"],
              ["RANCHER 10x20 with OSB Roof", 6349, "eibyb5s1h"],
            ],
          },
          {
            i: "15",
            t: "Cedarshed Ranchhouse Prefab Cottage Kit",
            h: "cedarshed-ranchhouses-prefab-cottage-kits",
            v: "Cedarshed",
            p: 6899,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-ranchhouse-prefab-cottage-kit-main.webp?v=1714156975",
            s: {
              m: "100% Western Red Cedar",
              r: "Cedar shingles or OSB, varies by variant",
              f: "Plywood floor over 2×4 cedar joists; varies/removable",
              l: "About 2 weeks production + 1 week delivery",
              h: "7′",
              w: "Yes",
            },
            c: 7399,
            q: [
              ["Ranchhouse 12x12 with Cedar Roof Shingles", 7899, "beokkv22d"],
              ["Ranchhouse 16x12 with Cedar Roof Shingles", 10299, "beokkvrcl"],
              ["Ranchhouse 12x14 with Cedar Roof Shingles", 7999, "beokkwgmt"],
              ["Ranchhouse 16x14 with Cedar Roof Shingles", 10499, "beokkx5x1"],
              ["Ranchhouse 12x12 with Metal Roof", 7899, "fws1glu7p"],
              ["Ranchhouse 16x12 with Metal Roof", 10399, "fws1gmjhx"],
              ["Ranchhouse 12x14 with Metal Roof", 7999, "fws1gn8s5"],
              ["Ranchhouse 16x14 with Metal Roof", 10499, "fws1gny2d"],
              ["Ranchhouse 12x12 with OSB Roof", 6999, "eic0j85dh"],
              ["Ranchhouse 16x12 with OSB Roof", 8899, "eic0k3r5h"],
              ["Ranchhouse 12x14 with OSB Roof", 6899, "eic0ktqnp"],
              ["Ranchhouse 16x14 with OSB Roof", 8999, "eic0l8hmd"],
            ],
          },
          {
            i: "16",
            t: "EZ-Fit Craftsman Storage Shed Kit",
            h: "ez-fit-craftsman-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2399,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-craftsman-shed-kit-main.jpg?v=1740682952",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "Not listed; sidewall height extension available",
              w: "Yes",
            },
            c: 2699,
            q: [
              ["8x8", 2399, "dyzebcjed"],
              ["8x10", 2599, "dyzebd8ol"],
              ["8x12", 2949, "dyzebfcj9"],
              ["10x10", 2949, "dyzebgr3p"],
              ["10x12", 3299, "dyzebi5o5"],
              ["10x14", 3599, "dyzebjk8l"],
              ["10x16", 3799, "dyzeblo39"],
              ["10x20", 4399, "dyzebn2np"],
              ["12x16", 4549, "dyzebpvsl"],
              ["12x20", 5099, "dyzebrad1"],
              ["12x24", 5549, "dyzebte7p"],
            ],
          },
          {
            i: "17",
            t: "EZ-Fit Heritage Shed Kit",
            h: "ez-fit-heritage-outdoor-garden-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2699,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/Heritageedited_1000x1000_60818b49-2519-4b67-a58a-e05892b7e1e5.jpg?v=1660745179",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 2999,
            q: [
              ["8x8'", 2699, "fq5f9btpx"],
              ["8x10'", 2899, "fq5f9cj05"],
              ["8x12'", 3299, "i5n4219"],
              ["10x10'", 3299, "fq5f9d8ad"],
              ["10x12'", 3699, "i5n4231"],
              ["10x14", 3999, "i5n424t"],
              ["10x16'", 4299, "i5n426l"],
              ["10x20'", 4899, "i5n428d"],
              ["12x16'", 5099, "i5n42a5"],
              ["12x20'", 5699, "i5n42bx"],
              ["12x24'", 6199, "i5n42dp"],
            ],
          },
          {
            i: "18",
            t: "EZ-Fit Heritage Shed Kit - QUICK-SHIP",
            h: "ez-fit-heritage-shed-kit-quick-ship",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-heritage-shed-double-doors.webp?v=1740001927",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpwanxjjp"],
              ["10x12", 3699, "fpwany8tx"],
            ],
          },
          {
            i: "19",
            t: "EZ-Fit Homestead Shed Kit",
            h: "ez-fit-homestead-garden-tool-shed-kit",
            v: "EZ-Fit Sheds",
            p: 2699,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/products/HomesteadEZfit-937503.jpg?v=1695738402",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 2999,
            q: [
              ["8x8", 2699, "i5nhowd"],
              ["8x10'", 2899, "i5ni00d"],
              ["8x12'", 3299, "i5ng7nx"],
              ["10x10'", 3299, "i5ni8wd"],
              ["10x12'", 3699, "i5ng7pp"],
              ["10x14'", 3999, "i5ng7rh"],
              ["10x16'", 4299, "i5ng7t9"],
              ["10x20'", 4899, "i5ng7v1"],
              ["12x16'", 5099, "i5ng7wt"],
              ["12x20'", 5699, "i5ng7yl"],
              ["12x24'", 6199, "i5ng80d"],
            ],
          },
          {
            i: "20",
            t: "EZ-Fit Homestead Shed Kit - QUICK-SHIP",
            h: "ez-fit-homestead-shed-kit-quick-ship",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-homestead-shed-kit-red.jpg?v=1740001269",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpv59456d"],
              ["10x12", 3699, "fpv594ugl"],
            ],
          },
          {
            i: "21",
            t: "EZ-Fit Riverside Shed Kit",
            h: "ez-fit-riverside-shed-kit",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-riverside-shed-kit-main.jpg?v=1732738736",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "6′6″; sidewall height extension available",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12'", 3299, "i4ch4p9"],
              ["10x12'", 3699, "i55brpp"],
              ["10x14'", 3999, "i55brt9"],
              ["10x16'", 4299, "i55brwt"],
              ["10x20'", 4899, "i55bs0d"],
              ["12x16'", 5099, "i55bs3x"],
              ["12x20'", 5699, "i55bs5p"],
              ["12x24'", 6199, "i55bs99"],
            ],
          },
          {
            i: "22",
            t: "EZ-Fit Riverside Shed Kit - QUICK-SHIP",
            h: "ez-fit-10x14-riverside-shed-kit",
            v: "EZ-Fit Sheds",
            p: 3299,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-quickship-riverside-storage-shed.jpg?v=1756400548",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "3 business days production + 2–9 business days shipping",
              h: "6′6″; no sidewall height upgrade",
              w: "Yes",
            },
            c: 3599,
            q: [
              ["8x12", 3299, "fpsnwh1yt"],
              ["10x12", 3699, "fpsnwhr91"],
              ["10x14", 3999, "fpsnwigj9"],
              ["10x16", 4299, "fpsnwj5th"],
              ["10x20", 4899, "fpsnwjv3p"],
              ["12x24", 6199, "fpsnwkkdx"],
            ],
          },
          {
            i: "23",
            t: "EZ-Fit Skyview Shed Kit",
            h: "ez-fit-skyview-shed-kit",
            v: "EZ-Fit Sheds",
            p: 4399,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-skyview-shed-kit-main.jpg?v=1743006556",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "6′6″ sidewalls; no sidewall height upgrade",
              w: "Yes",
            },
            c: 4699,
            q: [
              ["8x12'", 4399, "fqnlcoo51"],
              ["10x12'", 4699, "fqnlcpdf9"],
              ["10x16'", 5399, "fqnlcq2ph"],
              ["10x20'", 5999, "fqnlcqrzp"],
            ],
          },
          {
            i: "24",
            t: "EZ-Fit Woodsman Shed Kit",
            h: "ez-fit-woodsman-shed-kit",
            v: "EZ-Fit Sheds",
            p: 4199,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-woodsman-shed-kit-main.jpg?v=1740410859",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Pre-cut roof system",
              f: "Floor not included; optional floor kit available",
              l: "15 business days production + 2–9 business days shipping",
              h: "7′ sidewalls; sidewall height extension available",
              w: "Yes",
            },
            c: 4499,
            q: [
              ["8x8", 4199, "fq0gjy4vp"],
              ["8x12", 4699, "fq0gjyu5x"],
              ["10x10", 4799, "fq0gjzjg5"],
              ["10x12", 5199, "fq0gk08qd"],
              ["10x14", 5599, "fq0gk0y0l"],
              ["10x16", 5899, "fq0gk1nat"],
            ],
          },
          {
            i: "25",
            t: "Little Cottage Co. Classic 4' Gambrel Barn Shed Kit",
            h: "little-cottage-company-classic-gambrel-barn-4-sidewall-shed",
            v: "Little Cottage Co.",
            p: 2229,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-kit-sidewall-main.jpg?v=1759413523",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "4′ sidewalls",
              w: "No",
            },
            c: 2349,
            q: [
              ["8ft x 8ft", 2229, "e0ua6fdit"],
              ["8ft x 10ft", 2349, "e0ua6g2t1"],
              ["8ft x 12ft", 2419, "e0ua6gs39"],
              ["8ft x 14ft", 2539, "e0ua6hhdh"],
              ["8ft x 16ft", 2979, "e0ua6i6np"],
              ["10ft x 10ft", 2479, "e0ua6ivxx"],
              ["10ft x 12ft", 2929, "e0ua6jl85"],
              ["10ft x 14ft", 3049, "e0ua6kaid"],
              ["10ft x 16ft", 3169, "e0ua6kzsl"],
              ["10ft x 18ft", 3439, "e0ua6lp2t"],
              ["10ft x 20ft", 3699, "e0ua6med1"],
              ["12ft x 12ft", 3229, "e0ua6n3n9"],
              ["12ft x 14ft", 3379, "e0ua6nsxh"],
              ["12ft x 16ft", 3509, "e0ua6oi7p"],
              ["12ft x 18ft", 3959, "e0ua6p7hx"],
              ["12ft x 20ft", 4079, "e0ua6pws5"],
              ["12ft x 24ft", 4639, "e0ua6qm2d"],
            ],
          },
          {
            i: "26",
            t: "Little Cottage Co. Classic Five-Corner 10x10 Shed Kit",
            h: "little-cottage-company-classic-five-corner-10x10-shed",
            v: "Little Cottage Co.",
            p: 3339,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x10-classic-five-corner-shed-main.jpg?v=1759425555",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "6–8 weeks production + 2–9 days shipping",
              h: "72″ sidewalls",
              w: "No",
            },
            c: 3519,
            q: [
              ["Without Floor Kit", 3339, "e08lrj22d"],
              ["With Floor Kit", 4249, "e08lrjrcl"],
            ],
          },
          {
            i: "27",
            t: "Little Cottage Co. Classic Gable Shed Kit",
            h: "little-cottage-company-classic-gable-shed",
            v: "Little Cottage Co.",
            p: 2359,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-classic-gable-storage-shed-isolated.jpg?v=1759252363",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2489,
            q: [
              ["8ft x 8ft", 2359, "e0ubook6t"],
              ["8ft x 10ft", 2549, "e0ubop9h1"],
              ["8ft x 12ft", 2679, "e0ubopyr9"],
              ["8ft x 14ft", 3159, "e0uboqo1h"],
              ["8ft x 16ft", 3289, "e0ubordbp"],
              ["10ft x 10ft", 2719, "e0ubos2lx"],
              ["10ft x 12ft", 3199, "e0ubosrw5"],
              ["10ft x 14ft", 3359, "e0uboth6d"],
              ["10ft x 16ft", 3499, "e0ubou6gl"],
              ["10ft x 18ft", 3829, "e0ubouvqt"],
              ["10ft x 20ft", 4129, "e0ubovl11"],
              ["12ft x 12ft", 3379, "e0ubowab9"],
              ["12ft x 14ft", 3549, "e0ubowzlh"],
              ["12ft x 16ft", 4029, "e0uboxovp"],
              ["12ft x 18ft", 4209, "e0uboye5x"],
              ["12ft x 20ft", 4339, "e0uboz3g5"],
              ["12ft x 24ft", 4789, "e0ubozsqd"],
            ],
          },
          {
            i: "28",
            t: "Little Cottage Co. Classic Gambrel Barn 6' Sidewall Kit",
            h: "little-cottage-company-classic-gambrel-barn-6-sidewall-shed",
            v: "Little Cottage Co.",
            p: 2509,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-6-sidewall-main.jpg?v=1759345324",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′ sidewalls",
              w: "No",
            },
            c: 2649,
            q: [
              ["8ft x 8ft", 2509, "e0uavjz91"],
              ["8ft x 10ft", 2679, "e0uavkoj9"],
              ["8ft x 12ft", 2829, "e0uavldth"],
              ["8ft x 14ft", 3329, "e0uavm33p"],
              ["8ft x 16ft", 3479, "e0uavmsdx"],
              ["10ft x 10ft", 2979, "e0uavnho5"],
              ["10ft x 12ft", 3489, "e0uavo6yd"],
              ["10ft x 14ft", 3629, "e0uavow8l"],
              ["10ft x 16ft", 3709, "e0uavplit"],
              ["10ft x 18ft", 4099, "e0uavqat1"],
              ["10ft x 20ft", 4409, "e0uavr039"],
              ["12ft x 12ft", 3749, "e0uavrpdh"],
              ["12ft x 14ft", 3879, "e0uavsenp"],
              ["12ft x 16ft", 4399, "e0uavt3xx"],
              ["12ft x 18ft", 4559, "e0uavtt85"],
              ["12ft x 20ft", 4729, "e0uavuiid"],
              ["12ft x 24ft", 5349, "e0uavv7sl"],
            ],
          },
          {
            i: "29",
            t: "Little Cottage Co. Classic Gambrel Large Barn",
            h: "little-cottage-co-classic-gambrel-large-barn",
            v: "Little Cottage Co.",
            p: 4559,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-co-classic-gambrel-barn.jpg?v=1759352547",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Floor not included; optional kit available",
              l: "Not listed",
              h: "76″ sidewalls",
              w: "No",
            },
            c: 4819,
            q: [
              ["14ft x 18ft", 4559, "fum704eut"],
              ["14ft x 20ft", 4749, "fum705451"],
              ["14ft x 22ft", 4999, "fum705tf9"],
              ["14ft x 24ft", 5239, "fum706iph"],
              ["14ft x 26ft", 5459, "fum7077zp"],
              ["14ft x 28ft", 6089, "fum707x9x"],
              ["14ft x 30ft", 6199, "fum708mk5"],
              ["14ft x 32ft", 6409, "fum709bud"],
              ["16ft x 18ft", 5139, "fum70a14l"],
              ["16ft x 20ft", 5459, "fum70aqet"],
              ["16ft x 22ft", 5789, "fum70bfp1"],
              ["16ft x 24ft", 6009, "fum70c4z9"],
              ["16ft x 26ft", 6249, "fum70cu9h"],
              ["16ft x 28ft", 6569, "fum70djjp"],
              ["16ft x 30ft", 6799, "fum70e8tx"],
              ["16ft x 32ft", 7039, "fum70ey45"],
              ["16ft x 34ft", 7569, "fum70fned"],
            ],
          },
          {
            i: "30",
            t: "Little Cottage Co. Classic Workshop & Garden Shed",
            h: "little-cottage-company-classic-workshop-shed",
            v: "Little Cottage Co.",
            p: 2469,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/classic-workshop-storage-shed-kit-front.jpg?v=1759256527",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2599,
            q: [
              ["8ft x 8ft", 2469, "e0ub6r48l"],
              ["8ft x 10ft", 2659, "e0ub6rtit"],
              ["8ft x 12ft", 2899, "e0ub6sit1"],
              ["8ft x 14ft", 3379, "e0ub6t839"],
              ["8ft x 16ft", 3519, "e0ub6txdh"],
              ["10ft x 10ft", 2819, "e0ub6umnp"],
              ["10ft x 12ft", 3419, "e0ub6vbxx"],
              ["10ft x 14ft", 3559, "e0ub6w185"],
              ["10ft x 16ft", 3719, "e0ub6wqid"],
              ["10ft x 18ft", 4039, "e0ub6xfsl"],
              ["10ft x 20ft", 4339, "e0ub6y52t"],
              ["12ft x 12ft", 3609, "e0ub6yud1"],
              ["12ft x 14ft", 3779, "e0ub6zjn9"],
              ["12ft x 16ft", 4249, "e0ub708xh"],
              ["12ft x 18ft", 4429, "e0ub70y7p"],
              ["12ft x 20ft", 4569, "e0ub71nhx"],
              ["12ft x 24ft", 5169, "e0ub72cs5"],
            ],
          },
          {
            i: "31",
            t: "Little Cottage Co. Colonial Five-Corner 10x10 Shed Kit",
            h: "little-cottage-company-colonial-five-corner-10x10-shed",
            v: "Little Cottage Co.",
            p: 4419,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/colonial-five-corner-storage-shed-main.jpg?v=1759425560",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "2–4 weeks production + 2–9 days shipping",
              h: "72″ sidewalls",
              w: "No",
            },
            c: 4659,
            q: [
              ["Without Floor Kit", 4419, "e0605wzed"],
              ["With Floor Kit", 5369, "e0605xool"],
            ],
          },
          {
            i: "32",
            t: "Little Cottage Co. Colonial Pinehurst Storage Shed Kit",
            h: "little-cottage-company-colonial-pinehurst-shed-kit",
            v: "Little Cottage Co.",
            p: 2499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x12-colonial-pinehurst-main_9c9bdbdf-1916-43a7-989a-039f99fa1095.jpg?v=1759419491",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2639,
            q: [
              ["8ft x 8ft", 2499, "e0uh7tyr9"],
              ["8ft x 10ft", 2979, "e0uh7uo1h"],
              ["8ft x 12ft", 3109, "e0uh7vdbp"],
              ["8ft x 14ft", 3569, "e0uh7w2lx"],
              ["8ft x 16ft", 3709, "e0uh7wrw5"],
              ["10ft x 10ft", 3349, "e0uh7xh6d"],
              ["10ft x 12ft", 3839, "e0uh7y6gl"],
              ["10ft x 14ft", 4249, "e0uh7yvqt"],
              ["10ft x 16ft", 4379, "e0uh7zl11"],
              ["10ft x 18ft", 4849, "e0uh80ab9"],
              ["10ft x 20ft", 4979, "e0uh80zlh"],
              ["12ft x 12ft", 4099, "e0uh81ovp"],
              ["12ft x 14ft", 4569, "e0uh82e5x"],
              ["12ft x 16ft", 5009, "e0uh833g5"],
              ["12ft x 18ft", 5169, "e0uh83sqd"],
              ["12ft x 20ft", 5329, "e0uh84i0l"],
              ["12ft x 24ft", 5859, "e0uh857at"],
            ],
          },
          {
            i: "33",
            t: "Little Cottage Co. Colonial Williamsburg Shed Kit",
            h: "little-cottage-company-colonial-williamsburg-storage-shed-kit",
            v: "Little Cottage Co.",
            p: 2649,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-colonial-williamsburg-main.jpg?v=1759419524",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping",
              h: "6′4.5″ sidewalls",
              w: "No",
            },
            c: 2789,
            q: [
              ["8ft x 8ft", 2649, "e0ug111rp"],
              ["8ft x 10ft", 3149, "e0ug11r1x"],
              ["8ft x 12ft", 3329, "e0ug12gc5"],
              ["8ft x 14ft", 3799, "e0ug135md"],
              ["8ft x 16ft", 3949, "e0ug13uwl"],
              ["10ft x 10ft", 3479, "e0ug14k6t"],
              ["10ft x 12ft", 4009, "e0ug159h1"],
              ["10ft x 14ft", 4439, "e0ug15yr9"],
              ["10ft x 16ft", 4609, "e0ug16o1h"],
              ["10ft x 18ft", 5079, "e0ug17dbp"],
              ["10ft x 20ft", 5249, "e0ug182lx"],
              ["12ft x 12ft", 4189, "e0ug18rw5"],
              ["12ft x 14ft", 4649, "e0ug19h6d"],
              ["12ft x 16ft", 5119, "e0ug1a6gl"],
              ["12ft x 18ft", 5219, "e0ug1avqt"],
              ["12ft x 20ft", 5389, "e0ug1bl11"],
              ["12ft x 24ft", 6079, "e0ug1cab9"],
            ],
          },
          {
            i: "34",
            t: "Little Cottage Co. Star Barn Kit",
            h: "little-cottage-company-star-barn",
            v: "Little Cottage Co.",
            p: 9189,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-star-barn-storage-shed-kit.jpg?v=1718301285",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional treated-joist + plywood floor kit",
              l: "6–8 weeks production + 2–9 days shipping",
              h: "76″ sidewalls",
              w: "No",
            },
            c: 9669,
            q: [
              ["10ft x 14ft", 9189, "e0uq6pk51"],
              ["10ft x 16ft", 10349, "e0uq6q9f9"],
              ["10ft x 18ft", 11639, "e0uq6qyph"],
              ["10ft x 20ft", 12919, "eywq204dx"],
            ],
          },
          {
            i: "35",
            t: "Little Cottage Co. Value Gable Shed",
            h: "little-cottage-company-value-gable-shed-kit",
            v: "Little Cottage Co.",
            p: 1569,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-value-gable-shed-kit-front.jpg?v=1759245611",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′3″ sidewalls",
              w: "No",
            },
            c: 1649,
            q: [
              ["8ft x 8ft", 1569, "e0uc725o5"],
              ["8ft x 10ft", 1729, "e0uc72uyd"],
              ["8ft x 12ft", 1889, "e0uc73k8l"],
              ["8ft x 14ft", 2059, "e0uc749it"],
              ["8ft x 16ft", 2219, "e0uc74yt1"],
              ["10ft x 10ft", 1949, "e0uc75o39"],
              ["10ft x 12ft", 2109, "e0uc76ddh"],
              ["10ft x 14ft", 2299, "e0uc772np"],
              ["10ft x 16ft", 2459, "e0uc77rxx"],
              ["10ft x 18ft", 2659, "e0uc78h85"],
              ["10ft x 20ft", 2839, "e0uc796id"],
              ["12ft x 12ft", 2309, "e0uc79vsl"],
              ["12ft x 14ft", 2499, "e0uc7al2t"],
              ["12ft x 16ft", 2709, "e0uc7bad1"],
              ["12ft x 18ft", 2879, "e0uc7bzn9"],
              ["12ft x 20ft", 3089, "e0uc7coxh"],
              ["12ft x 24ft", 3489, "e0uc7de7p"],
            ],
          },
          {
            i: "36",
            t: "Little Cottage Co. Value Gambrel Barn 4' Sidewalls",
            h: "little-cottage-company-value-gambrel-barn-4-sidewall-kit",
            v: "Little Cottage Co.",
            p: 1479,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-main.jpg?v=1759508554",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Floor not included; optional kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "3′9.5″ sidewalls",
              w: "No",
            },
            c: 1569,
            q: [
              ["8ft x 8ft", 1479, "e0ucrkb3p"],
              ["8ft x 10ft", 1599, "e0ucrl0dx"],
              ["8ft x 12ft", 1739, "e0ucrlpo5"],
              ["8ft x 14ft", 1889, "e0ucrmeyd"],
              ["8ft x 16ft", 2079, "e0ucrn48l"],
              ["10ft x 10ft", 1799, "e0ucrntit"],
              ["10ft x 12ft", 1989, "e0ucroit1"],
              ["10ft x 14ft", 2109, "e0ucrp839"],
              ["10ft x 16ft", 2259, "e0ucrpxdh"],
              ["10ft x 18ft", 2409, "e0ucrqmnp"],
              ["10ft x 20ft", 2559, "e0ucrrbxx"],
              ["12ft x 12ft", 2229, "e0ucrs185"],
              ["12ft x 14ft", 2409, "e0ucrsqid"],
              ["12ft x 16ft", 2569, "e0ucrtfsl"],
              ["12ft x 18ft", 2739, "e0ucru52t"],
              ["12ft x 20ft", 2909, "e0ucruud1"],
              ["12ft x 24ft", 3259, "e0ucrvjn9"],
            ],
          },
          {
            i: "37",
            t: "Little Cottage Co. Value Gambrel Barn 6' Sidewalls",
            h: "little-cottage-company-value-gambrel-barn-6-sidewall-kit",
            v: "Little Cottage Co.",
            p: 1679,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-6-sidewalls.jpg?v=1759324155",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gambrel roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′ sidewalls",
              w: "No",
            },
            c: 1769,
            q: [
              ["8ft x 8ft", 1679, "e0ucis9bp"],
              ["8ft x 10ft", 1869, "e0ucisylx"],
              ["8ft x 12ft", 2029, "e0ucitnw5"],
              ["8ft x 14ft", 2219, "e0uciud6d"],
              ["8ft x 16ft", 2469, "e0uciv2gl"],
              ["10ft x 10ft", 2069, "e0ucivrqt"],
              ["10ft x 12ft", 2259, "e0uciwh11"],
              ["10ft x 14ft", 2439, "e0ucix6b9"],
              ["10ft x 16ft", 2619, "e0ucixvlh"],
              ["10ft x 18ft", 2869, "e0uciykvp"],
              ["10ft x 20ft", 3059, "e0uciza5x"],
              ["12ft x 12ft", 2579, "e0ucizzg5"],
              ["12ft x 14ft", 2799, "e0ucj0oqd"],
              ["12ft x 16ft", 2999, "e0ucj1e0l"],
              ["12ft x 18ft", 3199, "e0ucj23at"],
              ["12ft x 20ft", 3419, "e0ucj2sl1"],
              ["12ft x 24ft", 3809, "e0ucj3hv9"],
            ],
          },
          {
            i: "38",
            t: "Little Cottage Co. Value Workshop Shed",
            h: "little-cottage-company-value-workshop-shed-kit",
            v: "Little Cottage Co.",
            p: 1749,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/value-workshop-8x10-front.jpg?v=1759247323",
            s: {
              m: "LP SmartSide engineered wood",
              r: "Gable roof",
              f: "Optional floor kit available",
              l: "5–10 business days production + 2–9 days shipping",
              h: "6′3″ sidewalls",
              w: "No",
            },
            c: 1839,
            q: [
              ["8ft x 8ft", 1749, "e0uem39dh"],
              ["8ft x 10ft", 1919, "e0uem3ynp"],
              ["8ft x 12ft", 2209, "e0uem4nxx"],
              ["8ft x 14ft", 2389, "e0uem5d85"],
              ["8ft x 16ft", 2559, "e0uem62id"],
              ["10ft x 10ft", 2139, "e0uem6rsl"],
              ["10ft x 12ft", 2439, "e0uem7h2t"],
              ["10ft x 14ft", 2629, "e0uem86d1"],
              ["10ft x 16ft", 2759, "e0uem8vn9"],
              ["10ft x 18ft", 2999, "e0uem9kxh"],
              ["10ft x 20ft", 3169, "e0uemaa7p"],
              ["12ft x 12ft", 2649, "e0uemazhx"],
              ["12ft x 14ft", 2829, "e0uemce2d"],
              ["12ft x 16ft", 3029, "e0uemd3cl"],
              ["12ft x 18ft", 3209, "e0uemdsmt"],
              ["12ft x 20ft", 3409, "e0uemehx1"],
              ["12ft x 24ft", 3809, "e0uemf779"],
            ],
          },
          {
            i: "39",
            t: "Outdoor Living Today 12x8 Saltbox Studio",
            h: "outdoor-living-today-12x8-saltbox-studio",
            v: "Outdoor Living Today",
            p: 13499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-12x8-saltbox-studio.webp?v=1769027284",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar roof system",
              f: "Wood floor/base components listed",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "Not listed",
              w: "No",
            },
            c: 15499,
          },
          {
            i: "40",
            t: "Outdoor Living Today 6x3 Oscar Waste Management Shed",
            h: "outdoor-living-today-6x3-oscar-waste-management-shed",
            v: "Outdoor Living Today",
            p: 1599,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/6x3-oscar-waste-management-shed-main.jpg?v=1711556132",
            s: {
              m: "Western Red Cedar wood",
              f: "Wood floor/base components listed",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              r: "Cedar roof system",
              h: "Not listed",
              w: "No",
            },
            c: 2289,
          },
          {
            i: "41",
            t: "Outdoor Living Today 6x4 SpaceMaster Wood Storage Shed with Double Doors",
            h: "outdoor-living-today-6x4-spacemaster-wood-storage-shed-with-double-doors",
            v: "Outdoor Living Today",
            p: 2199,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/olt-spacemaster-6x4-storage-garden-shed.jpg?v=1710522333",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar shingles or Galvalume metal, varies by variant",
              f: "Pre-assembled Western Red Cedar floor included",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "64″ min / 77.75″ max interior height",
              w: "No",
            },
            c: 2799,
            q: [
              ["Metal", 2199, "f9eqdon5h"],
              ["Cedar", 2199, "f9eqdpcfp"],
            ],
          },
          {
            i: "42",
            t: "Outdoor Living Today 9x9 Penthouse Cedar Garden Shed",
            h: "outdoor-living-today-9x9-penthouse-cedar-garden-shed",
            v: "Outdoor Living Today",
            p: 7499,
            g: "https://cdn.shopify.com/s/files/1/1890/0221/files/9x9-penthouse-cedar-garden-shed-main.webp?v=1710799316",
            s: {
              m: "Western Red Cedar wood",
              r: "Cedar shingles included",
              f: "5/8″ plywood floor over 2×4 cedar joists",
              l: "7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping",
              h: "Not listed",
              w: "No",
            },
            c: 9299,
          },
        ],
        S = [null, null],
        V = [0, 0],
        A = 0,
        R = document.getElementById("hs-shed-compare"),
        E = document.getElementById("hsScOverlay"),
        L = document.getElementById("hsScList"),
        Q = document.getElementById("hsScSearch"),
        C = document.getElementById("hsScCompare"),
        X = document.getElementById("hsScClose"),
        B = [document.getElementById("hsScSlot1"), document.getElementById("hsScSlot2")];
      function e(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
      }
      function m(n) {
        if (n == null || n === "") return '<span class="hs-sc-na">Not listed</span>';
        var x = Number(n);
        if (!isFinite(x)) return e(n);
        return "$" + x.toLocaleString(undefined, { maximumFractionDigits: x % 1 ? 2 : 0 });
      }
      function qs(v) {
        return Array.isArray(v) ? v[0] : v.s;
      }
      function qp(v) {
        return Array.isArray(v) ? v[1] : v.p;
      }
      function qid(v) {
        var x = Array.isArray(v) ? v[2] : v.i;
        return x ? parseInt(x, 36) : "";
      }
      function pr(p, i) {
        var q = p.q || [];
        return q.length > 1 && q[i] ? qp(q[i]) : p.p;
      }
      function cp(p) {
        return p.c;
      }
      function ph(p, i) {
        var q = p.q || [],
          id = q.length > 1 && q[i] ? qid(q[i]) : "";
        return (
          "/products/" +
          encodeURIComponent(p.h) +
          (id ? "?variant=" + encodeURIComponent(String(id)) : "")
        );
      }
      function priceHtml(p, i) {
        var a = pr(p, i),
          b = cp(p),
          h = m(a);
        if (b && Number(b) > Number(a)) h += '<span class="hs-sc-compare-at">' + m(b) + "</span>";
        return h;
      }
      function minVi(p) {
        var q = p.q || [],
          mi = 0,
          mp = Infinity;
        if (q.length < 2) return 0;
        q.forEach(function (v, i) {
          var n = Number(qp(v));
          if (isFinite(n) && n < mp) {
            mp = n;
            mi = i;
          }
        });
        return mi;
      }
      function card(p, slot) {
        var q = p.q || [],
          vi = V[slot] || 0;
        if (q.length > 1 && !q[vi]) vi = V[slot] = minVi(p);
        var sel = "";
        if (q.length > 1)
          sel =
            '<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize' +
            slot +
            '">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize' +
            slot +
            '" class="hs-sc-size-select" data-slot="' +
            slot +
            '">' +
            q
              .map(function (v, i) {
                return (
                  '<option value="' +
                  i +
                  '"' +
                  (i === vi ? " selected" : "") +
                  ">" +
                  e(qs(v)) +
                  " - " +
                  e(m(qp(v)).replace(/<[^>]+>/g, "")) +
                  "</option>"
                );
              })
              .join("") +
            '</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';
        return (
          '<img class="hs-sc-fi" loading="lazy" src="' +
          e(p.g || "") +
          '" alt="' +
          e(p.t) +
          '"><div class="hs-sc-brand">' +
          e(p.v || "") +
          '</div><div class="hs-sc-title">' +
          e(p.t || "") +
          '</div><div class="hs-sc-price" data-price-slot="' +
          slot +
          '">' +
          priceHtml(p, vi) +
          '</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="' +
          slot +
          '" href="' +
          ph(p, vi) +
          '" target="_blank">View product</a>' +
          sel +
          '<button type="button" class="hs-sc-change" data-change="' +
          slot +
          '">Change shed</button>'
        );
      }
      function empty(slot) {
        return (
          '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your ' +
          (slot ? "second" : "first") +
          " shed</span>"
        );
      }
      function renderSlots() {
        for (var i = 0; i < 2; i++) {
          B[i].className = "hs-sc-slot" + (S[i] ? " hs-sc-filled" : "");
          B[i].innerHTML = S[i] ? card(S[i], i) : empty(i);
        }
        renderCompare();
      }
      function val(p, k) {
        return p && p.s && p.s[k] ? e(p.s[k]) : '<span class="hs-sc-na">Not listed</span>';
      }
      function roofv(p, slot) {
        var q = p && (p.q || []),
          vi = V[slot] || 0,
          l = q.length > 1 && q[vi] ? String(qs(q[vi])) : "";
        if (/OSB Roof/i.test(l)) return "OSB roof";
        if (/Metal Roof/i.test(l)) return "Metal roof";
        return val(p, "r");
      }
      function renderCompare() {
        if (!S[0] && !S[1]) {
          C.innerHTML = "";
          return;
        }
        var n0 = S[0] ? e(S[0].t) : "Select a shed",
          n1 = S[1] ? e(S[1].t) : "Select a shed";
        var rows = [
          ["Material", val(S[0], "m"), val(S[1], "m")],
          ["Roof type", roofv(S[0], 0), roofv(S[1], 1)],
          ["Floor kit", val(S[0], "f"), val(S[1], "f")],
          ["Wall height", val(S[0], "h"), val(S[1], "h")],
          ["Custom door and window placement", val(S[0], "w"), val(S[1], "w")],
          ["Lead time", val(S[0], "l"), val(S[1], "l")],
        ];
        C.innerHTML =
          '<div class="hs-sc-compare-table" role="table" aria-label="Selected shed comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n0 +
          '</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">' +
          n1 +
          "</div>" +
          rows
            .map(function (r) {
              return (
                '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">' +
                r[0] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[1] +
                '</div><div class="hs-sc-ct-cell" role="cell">' +
                r[2] +
                "</div>"
              );
            })
            .join("") +
          "</div>";
      }
      function open(slot) {
        A = slot;
        E.classList.add("hs-sc-is-open");
        E.setAttribute("aria-hidden", "false");
        document.body.classList.add("hs-sc-lock");
        Q.value = "";
        list("");
        setTimeout(function () {
          Q.focus();
        }, 30);
      }
      function close() {
        E.classList.remove("hs-sc-is-open");
        E.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hs-sc-lock");
      }
      function list(term) {
        term = (term || "").toLowerCase();
        var items = P.filter(function (p) {
          return (
            !term ||
            (p.t || "").toLowerCase().indexOf(term) > -1 ||
            (p.v || "").toLowerCase().indexOf(term) > -1
          );
        });
        L.innerHTML =
          items
            .map(function (p) {
              return (
                '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="' +
                e(p.i) +
                '"><img loading="lazy" src="' +
                e(p.g || "") +
                '" alt="' +
                e(p.t) +
                '"><div class="hs-sc-pi-brand">' +
                e(p.v || "") +
                '</div><div class="hs-sc-pi-title">' +
                e(p.t || "") +
                '</div><div class="hs-sc-pi-price">From ' +
                m(p.p) +
                "</div></div>"
              );
            })
            .join("") || '<p class="hs-sc-na">No sheds found.</p>';
      }
      B.forEach(function (b, i) {
        b.addEventListener("click", function (ev) {
          if (ev.target.closest(".hs-sc-change")) {
            open(i);
            return;
          }
          if (!S[i]) open(i);
        });
      });
      R.addEventListener("change", function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains("hs-sc-size-select")) {
          var slot = Number(el.getAttribute("data-slot")),
            p = S[slot];
          V[slot] = Number(el.value) || 0;
          var price = R.querySelector('[data-price-slot="' + slot + '"]'),
            link = R.querySelector('[data-link-slot="' + slot + '"]');
          if (price && p) price.innerHTML = priceHtml(p, V[slot]);
          if (link && p) link.setAttribute("href", ph(p, V[slot]));
          renderCompare();
        }
      });
      L.addEventListener("click", function (ev) {
        var it = ev.target.closest(".hs-sc-picker-item");
        if (!it) return;
        var id = it.getAttribute("data-id"),
          p = P.find(function (x) {
            return String(x.i) === String(id);
          });
        if (p) {
          S[A] = p;
          V[A] = minVi(p);
          close();
          renderSlots();
        }
      });
      L.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          var it = ev.target.closest(".hs-sc-picker-item");
          if (it) {
            ev.preventDefault();
            it.click();
          }
        }
      });
      Q.addEventListener("input", function () {
        list(Q.value);
      });
      X.addEventListener("click", close);
      E.addEventListener("click", function (ev) {
        if (ev.target === E) close();
      });
      document.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape" && E.classList.contains("hs-sc-is-open")) close();
      });
      function curh() {
        var m = String(location.pathname || "").match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).replace(/\/$/, "") : "";
      }
      function initCurrent() {
        var h = curh(),
          p =
            h &&
            P.find(function (x) {
              return String(x.h) === h;
            });
        if (p) {
          S[0] = p;
          V[0] = minVi(p);
        }
      }
      initCurrent();
      renderSlots();

      // ===== Live price refresh (lazy fetch with optimistic render) =====
      // Paste this inside the main comparison-tool IIFE, replacing the original final:
      // initCurrent();
      // renderSlots();
      // })();
      //
      // This refreshes live Shopify storefront pricing from /products/{handle}.js.
      // It updates product price, compare-at price, variant prices, and variant IDs.
      // It does not add brand-new products or brand-new variants to the baked-in catalog.

      var LIVE = {}; // handle -> { done: true, loading: false }

      function toBase36(n) {
        return Number(n).toString(36);
      }

      function centsToDollars(v) {
        var n = Number(v);
        return isFinite(n) ? n / 100 : null;
      }

      function variantId36(v) {
        return Array.isArray(v) ? v[2] : v && v.i;
      }

      function variantIdNum(v) {
        var x = variantId36(v);
        return x ? parseInt(x, 36) : null;
      }

      function findLiveVariant(data, oldVariant) {
        var oldTitle = qs(oldVariant);
        var oldIdNum = variantIdNum(oldVariant);

        return (
          data.variants.find(function (v) {
            return oldIdNum && String(v.id) === String(oldIdNum);
          }) ||
          data.variants.find(function (v) {
            return v.title === oldTitle || v.public_title === oldTitle || v.name === oldTitle;
          }) ||
          null
        );
      }

      function fetchLive(p, cb) {
        if (!p || !p.h) return;

        if (LIVE[p.h] && LIVE[p.h].done) {
          cb && cb();
          return;
        }

        if (LIVE[p.h] && LIVE[p.h].loading) {
          setTimeout(function () {
            fetchLive(p, cb);
          }, 80);
          return;
        }

        LIVE[p.h] = { loading: true, done: false };

        try {
          fetch('/products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data || !data.variants || !data.variants.length) {
                LIVE[p.h] = { loading: false, done: true };
                cb && cb();
                return;
              }

              var oldQ = p.q || [];
              var newQ = oldQ.map(function (oldVariant) {
                var match = findLiveVariant(data, oldVariant);
                if (!match) return oldVariant;

                var livePrice = centsToDollars(match.price);
                return [qs(oldVariant), livePrice != null ? livePrice : qp(oldVariant), toBase36(match.id)];
              });

              // If this product had no baked-in variant dropdown, use the storefront product-level price.
              if (!newQ.length && data.price != null) {
                var topPrice = centsToDollars(data.price);
                if (topPrice != null) p.p = topPrice;
              }

              // If variants are present, use the lowest live variant price as the product's displayed From price.
              if (newQ.length) {
                var minPrice = Infinity;
                newQ.forEach(function (v) {
                  var price = Number(qp(v));
                  if (isFinite(price) && price < minPrice) minPrice = price;
                });
                if (isFinite(minPrice)) p.p = minPrice;
                p.q = newQ;
              }

              // Update compare-at price too. Prefer product-level compare_at_price, then max variant compare_at_price.
              var liveCompareAt = centsToDollars(data.compare_at_price);
              if (liveCompareAt == null) {
                data.variants.forEach(function (v) {
                  var ca = centsToDollars(v.compare_at_price);
                  if (ca != null && (liveCompareAt == null || ca > liveCompareAt)) liveCompareAt = ca;
                });
              }
              if (liveCompareAt != null) p.c = liveCompareAt;

              LIVE[p.h] = { loading: false, done: true };
              cb && cb();
            })
            .catch(function () {
              LIVE[p.h] = { loading: false, done: false };
            });
        } catch (e) {
          LIVE[p.h] = { loading: false, done: false };
        }
      }

      function refreshSlot(slot, preferMinVariant) {
        var p = S[slot];
        if (!p) return;

        var beforeIndex = V[slot] || 0;
        var beforeVariant = p.q && p.q[beforeIndex] ? p.q[beforeIndex] : null;
        var beforeTitle = beforeVariant ? qs(beforeVariant) : null;
        var beforeId = beforeVariant ? variantId36(beforeVariant) : null;

        fetchLive(p, function () {
          if (preferMinVariant) {
            V[slot] = minVi(p);
          } else if (p.q && p.q.length && beforeVariant) {
            var matchedIndex = p.q.findIndex(function (v) {
              return (beforeId && variantId36(v) === beforeId) || (beforeTitle && qs(v) === beforeTitle);
            });
            V[slot] = matchedIndex > -1 ? matchedIndex : Math.min(beforeIndex, p.q.length - 1);
          }
          renderSlots();
        });
      }

      // Refresh slot 1, the auto-loaded current product, shortly after load.
      if (S[0]) {
        setTimeout(function () {
          refreshSlot(0, true);
        }, 50);
      }

      // Hook into the modal-pick handler. The original picker handler stays intact;
      // this runs one tick later, after S[A] has been updated.
      L.addEventListener('click', function (ev) {
        var it = ev.target.closest('.hs-sc-picker-item');
        if (!it) return;
        setTimeout(function () {
          refreshSlot(A, true);
        }, 0);
      });

      // Preserve a user's selected variant when they change the dropdown and live data is not fetched yet.
      R.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.classList && el.classList.contains('hs-sc-size-select')) {
          var slot = Number(el.getAttribute('data-slot'));
          setTimeout(function () {
            refreshSlot(slot, false);
          }, 0);
        }
      });

      // Background-prefetch picker product prices once the modal opens.
      var _origOpen = open;
      open = function (slot) {
        _origOpen(slot);
        var i = 0;
        function prefetchNext() {
          if (i >= P.length) return;
          var p = P[i++];
          if (p && p.h && !(LIVE[p.h] && LIVE[p.h].done)) {
            fetchLive(p, function () {
              if (E.classList.contains('hs-sc-is-open')) list(Q.value);
            });
          }
          setTimeout(prefetchNext, 60);
        }
        prefetchNext();
      };
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-shed-comparison-tool-saltbox-assets"] && !Shopify.designMode) return;
  try {
    (function(){var P=[{"i":"1","t":"Cedarshed Boathouse Canoe & Kayak Storage Shed Kit","h":"cedarshed-boathouse-canoe-kayak-storage-shed","v":"Cedarshed","p":4209,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-canoe-and-kayak-storage-shed.jpg?v=1714160020","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":4909.99,"q":[["Boathouse 12x6 with Cedar Roof Shingles",4479,"2mcfpi59x"],["Boathouse 12x8 with Cedar Roof Shingles",5099,"2mcfpiuk5"],["Boathouse 16x8 with Cedar Roof Shingles",6279,"2mcfpjjud"],["Boathouse 12x10 with Cedar Roof Shingles",5379,"2mcfpk94l"],["Boathouse 16x10 with Cedar Roof Shingles",6279,"2mcfpkyet"],["Boathouse 12x6 with Metal Roof",4479,"fs71ao2et"],["Boathouse 12x8 with Metal Roof",5099,"fs71aorp1"],["Boathouse 16x8 with Metal Roof",6039,"fs71apgz9"],["Boathouse 12x10 with Metal Roof",5299,"fs71aq69h"],["Boathouse 16x10 with Metal Roof",6149,"fs71aqvjp"],["Boathouse 12x6 with OSB Roof",4209,"eibyq5645"],["Boathouse 12x8 with OSB Roof",4559,"eibyqx9h1"],["Boathouse 16x8 with OSB Roof",4999,"eibyr4ab9"],["Boathouse 12x10 with OSB Roof",4649,"eibyr8i0l"],["Boathouse 16x10 with OSB Roof",5379,"eibyrdf05"]]},{"i":"2","t":"Cedarshed Cabana Backyard & Pool Shed","h":"cedarshed-cabana-backyard-shed","v":"Cedarshed","p":3459,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cabana-backyard-pool-shed-main.jpg?v=1713808378","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":3799.99,"q":[["Cabana 9x6 with Cedar Roof Shingles",4119,"2lp23erzp"],["Cabana 10x8 with Cedar Roof Shingles",4939,"2lp23fh9x"],["Cabana 12x8 with Cedar Roof Shingles",5239,"2lp23g6k5"],["Cabana 12x10 with Cedar Roof Shingles",5549,"2lp23gvud"],["Cabana 9x6 with Metal Roof",3949,"fs71k1vzp"],["Cabana 10x8 with Metal Roof",4729,"fs71k2l9x"],["Cabana 12x8 with Metal Roof",5119,"fs71k3ak5"],["Cabana 12x10 with Metal Roof",5509,"fs71k3zud"],["Cabana 9x6 with OSB Roof",3459,"eibx4gdh1"],["Cabana 10x8 with OSB Roof",4159,"eibx4mp11"],["Cabana 12x8 with OSB Roof",4459,"eibx4q7g5"],["Cabana 12x10 with OSB Roof",4749,"eibx4uf5h"]]},{"i":"3","t":"Cedarshed Cedar House Storage Shed","h":"cedarshed-cedarhouse-storage-shed","v":"Cedarshed","p":4029,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cedar-house-storage-shed-main.webp?v=1714519762","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":4849,"q":[["CEDARHOUSE 10x8 with Cedar Roof Shingles",4649,"2loo3nv3p"],["CEDARHOUSE 10x10 with Cedar Roof Shingles",4929,"2loo3p9o5"],["CEDARHOUSE 10x12 with Cedar Roof Shingles",5549,"2loo3qo8l"],["CEDARHOUSE 10x16 with Cedar Roof Shingles",6449,"2loo3s2t1"],["CEDARHOUSE 10x20 with Cedar Roof Shingles",7629,"2loo3ss39"],["CEDARHOUSE 10x8 with Metal Roof",4539,"fs7wllkj9"],["CEDARHOUSE 10x10 with Metal Roof",4779,"fs7wlm9th"],["CEDARHOUSE 10x12 with Metal Roof",5499,"fs7wlmz3p"],["CEDARHOUSE 10x16 with Metal Roof",6079,"fs7wlnodx"],["CEDARHOUSE 10x20 with Metal Roof",7349,"fs7wlodo5"],["CEDARHOUSE 10x8 with OSB Roof",4029,"eibxumwj9"],["CEDARHOUSE 10x10 with OSB Roof",4199,"eibxv2cs5"],["CEDARHOUSE 10x12 with OSB Roof",4839,"eibxv5v79"],["CEDARHOUSE 10x16 with OSB Roof",5299,"eibxvbhh1"],["CEDARHOUSE 10x20 with OSB Roof",6279,"eibxvdlbp"]]},{"i":"4","t":"Cedarshed Cookhouse BBQ Shed","h":"cedarshed-cookhouse-cooking-bbq-sheds","v":"Cedarshed","p":6819,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-cookhouse-bbq-shed-main.webp?v=1714587118","s":{"m":"100% Western Red Cedar","r":"Cedar shingles or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"7′","w":"Yes"},"c":8099,"q":[["Cookhouse 12x10 with Cedar Roof Shingles",7449,"benb0nwhh"],["Cookhouse 16x12 with Cedar Roof Shingles",8799,"benb0olrp"],["Cookhouse 16x14 with Cedar Roof Shingles",8979,"benb0pb1x"],["Cookhouse 12x10 with OSB Roof",6819,"eic096g51"],["Cookhouse 16x12 with OSB Roof",7539,"eic09jsj9"],["Cookhouse 16x14 with OSB Roof",7629,"eic0baat1"]]},{"i":"5","t":"Cedarshed DIY 4x4 Green Pod Wooden Garbage Can & Recycling Bin Shed Kits","h":"cedarshed-green-pod-garbage-recycling-shed","v":"Cedarshed","p":2279.99,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-wooden-garbage-can-shed-kit.webp?v=1714414026","s":{"m":"100% Western Red Cedar","r":"Tongue-and-groove roof panels; OSB version available","f":"Not listed","l":"About 2 weeks production + 1 week delivery","h":"Not listed","w":"Yes"},"c":2899.99},{"i":"6","t":"Cedarshed Farmhouse Shed Kit","h":"cedarshed-farmhouse-shed-kits","v":"Cedarshed","p":7499,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-farmhouse-shed-kit-main.webp?v=1714409778","s":{"m":"100% Western Red Cedar","r":"Cedar shingles or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"7′","w":"Yes"},"c":8749,"q":[["Farmhouse 16x12 with Cedar Roof Shingles",8979,"beoltxfzp"],["Farmhouse 16x14 with Cedar Roof Shingles",9879,"beolty59x"],["Farmhouse 20x12 with Cedar Roof Shingles",10699,"beoltyuk5"],["Farmhouse 20x14 with Cedar Roof Shingles",11599,"beoltzjud"],["Farmhouse 16x12 with Metal Roof",8979,"fwsubo1f9"],["Farmhouse 16x14 with Metal Roof",9879,"fwsuboqph"],["Farmhouse 20x12 with Metal Roof",10699,"fwsubpfzp"],["Farmhouse 20x14 with Metal Roof",11599,"fwsubq59x"],["Farmhouse 16x12 with OSB Roof",7499,"eic0t3j1x"],["Farmhouse 16x14 with OSB Roof",7719,"eic0tkdv9"],["Farmhouse 20x12 with OSB Roof",8979,"eic0ttik5"],["Farmhouse 20x14 with OSB Roof",9419,"eic0u5gdx"]]},{"i":"7","t":"Cedarshed Gable Style Beach House Shed","h":"cedarshed-gable-style-beach-house-shed-kit","v":"Cedarshed","p":4079,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gable-style-beach-house-shed.webp?v=1714495934","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":4889.99,"q":[["Beachhouse 9x6 with Cedar Roof Shingles",4799,"bf0wwsz05"],["Beachhouse 10x8 with Cedar Roof Shingles",5549,"bf0wwtoad"],["Beachhouse 12x8 with Cedar Roof Shingles",6199,"bf0wwudkl"],["Beachhouse 9x6 with Metal Roof",4649,"fs70t3yut"],["Beachhouse 10x8 with Metal Roof",5379,"fs70t4o51"],["Beachhouse 12x8 with Metal Roof",5979,"fs70t5df9"],["Beachhouse 9x6 with OSB Roof",4079,"eibzeopbp"],["Beachhouse 10x8 with OSB Roof",4979,"eibzfpxdh"],["Beachhouse 12x8 with OSB Roof",5379,"eibzgr5f9"]]},{"i":"8","t":"Cedarshed Garden Hutch","h":"cedarshed-garden-hutch","v":"Cedarshed","p":1779,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardeners-hutch-storage-shed-main.webp?v=1714512776","s":{"m":"100% Western Red Cedar","r":"Not listed","f":"Not listed","l":"About 2 weeks production + 1 week delivery","h":"Not listed","w":"Yes"},"c":1959},{"i":"9","t":"Cedarshed Gardener Small Gable Shed Kit","h":"cedarshed-gardener-small-gable-shed-kit","v":"Cedarshed","p":3029,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-gardener-small-gable-shed-kit.webp?v=1714149172","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":3299.99,"q":[["Gardener 6x6 with Cedar Roof Shingles",3229,"2lolr396d"],["Gardener 6x9 with Cedar Roof Shingles",3739,"eibxitzqt"],["Gardener 6x12 with Cedar Roof Shingles",4549,"2lolr4nqt"],["Gardener 8x10 with Cedar Roof Shingles",4549,"2lolr5d11"],["Gardener 8x12 with Cedar Roof Shingles",4949,"2lolr62b9"],["Gardener 8x16 with Cedar Roof Shingles",5929,"2lolr6rlh"],["Gardener 6x6 with Metal Roof",3279,"fs721wit1"],["Gardener 6x9 with Metal Roof",3769,"fs721xxdh"],["Gardener 6x12 with Metal Roof",4319,"fs721x839"],["Gardener 8x10 with Metal Roof",4569,"fs721ymnp"],["Gardener 8x12 with Metal Roof",4969,"fs721zbxx"],["Gardener 8x16 with Metal Roof",5849,"fs7220185"],["Gardener 6x6 with OSB Roof",3029,"eibxgsy7p"],["Gardener 6x9 with OSB Roof",3459,"2lolr3ygl"],["Gardener 6x12 with OSB Roof",3779,"eibxjqat1"],["Gardener 8x10 with OSB Roof",4169,"eibxjvx2t"],["Gardener 8x12 with OSB Roof",4319,"eibxkj3g5"],["Gardener 8x16 with OSB Roof",5129,"eibxkvqk5"]]},{"i":"10","t":"Cedarshed Haida Cabin & Storage Shed","h":"cedarshed-haida-cabin-storage-shed","v":"Cedarshed","p":3939.99,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-haida-storage-shed-fully-assembled.webp?v=1714406713","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′","w":"Yes"},"c":4639.99,"q":[["Haida 9x6 with Cedar Roof Shingles",4559.99,"2mcrgr8l1"],["Haida 12x8 with Cedar Roof Shingles",5549.99,"2mcrgrxv9"],["Haida 12x10 with Cedar Roof Shingles",5919.99,"2mcrgsn5h"],["Haida 9x6 with Metal Roof",4399.99,"fs726hkj9"],["Haida 12x8 with Metal Roof",5379.99,"fs726i9th"],["Haida 12x10 with Metal Roof",5549.99,"fs726iz3p"],["Haida 9x6 with OSB Roof",3939.99,"eibzpbh2t"],["Haida 12x8 with OSB Roof",4799.99,"eibzpsbw5"],["Haida 12x10 with OSB Roof",4899.99,"eibzql4j9"]]},{"i":"11","t":"Cedarshed Hobbyhouse Prefab Shed Kits","h":"cedarshed-hobbyhouse-prefab-shed-kits","v":"Cedarshed","p":3669,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-hobbyhouse-she-shed-kit-main.webp?v=1714589468","s":{"m":"100% Western Red Cedar","r":"Cedar shingles or OSB; skylight roof variants shown","f":"5/8″ plywood over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′","w":"Yes"},"c":4489,"q":[["Hobbyhouse 9' x 6' with Cedar & Skylight Roof",4079,"bembid06t"],["Hobbyhouse 10' x 8' with Cedar & Skylight Roof",4769,"bembidph1"],["Hobbyhouse 12' x 8' with Cedar & Skylight Roof",5179,"bembieer9"],["Hobbyhouse 12' x 10' with Cedar & Skylight Roof",5529,"bembif41h"],["Hobbyhouse 9' x 6' with OSB & Skylight Roof",3669,"eic109zjp"],["Hobbyhouse 10' x 8' with OSB & Skylight Roof",4159,"eic10q52t"],["Hobbyhouse 12' x 8' with OSB & Skylight Roof",5349,"eic11b7lh"],["Hobbyhouse 12' x 10' with OSB & Skylight Roof",4619,"eic11wzed"]]},{"i":"12","t":"Cedarshed Lean To Storage Bayside Shed","h":"cedarshed-lean-to-storage-shed","v":"Cedarshed","p":2059,"g":"https://cdn.shopify.com/s/files/1/1890/0221/products/cedarshed-lean-to-shingles-roof.png?v=1713987560","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"Not listed","w":"Yes"},"c":2374,"q":[["Bayside 6x3 with Cedar Roof Shingles / Double Doors",2339,"dyf9r1ulx"],["Bayside 6x3 with Cedar Roof Shingles / Dutch Door with Window",2189,"dzqsa6vqt"],["Bayside 6x3 with Cedar Roof Shingles / Sliding Door (no window) $149",2488,"dzqsv1oad"],["Bayside 6x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",2498,"feinsygj9"],["Bayside 6x4 with Cedar Roof Shingles / Double Doors",2709,"fv4w66n1x"],["Bayside 6x4 with Cedar Roof Shingles / Dutch Door with Window",2709,"fv4w67cc5"],["Bayside 6x4 with Cedar Roof Shingles / Sliding Door (no window) $149",2858,"fv4w681md"],["Bayside 6x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",2868,"fv4w68qwl"],["Bayside 8x3 with Cedar Roof Shingles / Double Doors",2709,"dyf9rd35h"],["Bayside 8x3 with Cedar Roof Shingles / Dutch Door with Window",2709,"dzqsb3w39"],["Bayside 8x3 with Cedar Roof Shingles / Sliding Door (no window) $149",2858,"dzqsvxzcl"],["Bayside 8x3 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",2868,"feinsz5th"],["Bayside 8x4 with Cedar Roof Shingles / Double Doors",2879,"dzqsevfw5"],["Bayside 8x4 with Cedar Roof Shingles / Dutch Door with Window",2879,"dyf9rkt9x"],["Bayside 8x4 with Cedar Roof Shingles / Sliding Door (no window) $149",3028,"dzqswx3jp"],["Bayside 8x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",3038,"feinszv3p"],["Bayside 12x4 with Cedar Roof Shingles / Double Doors",3739,"e043fnqd1"],["Bayside 12x4 with Cedar Roof Shingles / Dutch Door with Window",3739,"dyf9rmx4l"],["Bayside 12x4 with Cedar Roof Shingles / Sliding Door (no window) $149",3888,"dzqsx9qnp"],["Bayside 12x4 with Cedar Roof Shingles / Double Doors with One Fixed Window $159",3898,"feint0kdx"],["Bayside 6x3 with Metal Roof / Double Doors",2299,"fs7uyz29h"],["Bayside 6x3 with Metal Roof / Dutch Door with Window",2299,"fs7uyzrjp"],["Bayside 6x3 with Metal Roof / Sliding Door (no window) $149",2448,"fs7uz0gtx"],["Bayside 6x3 with Metal Roof / Double Doors with One Fixed Window $159",2458,"fs7uz1645"],["Bayside 6x4 with Metal Roof / Double Doors",2539,"fv4w69g6t"],["Bayside 6x4 with Metal Roof / Dutch Door with Window",2539,"fv4w6a5h1"],["Bayside 6x4 with Metal Roof / Sliding Door (no window) $149",2688,"fv4w6aur9"],["Bayside 6x4 with Metal Roof / Double Doors with One Fixed Window $159",2698,"fv4w6bk1h"],["Bayside 8x3 with Metal Roof / Double Doors",2539,"fs7uz1ved"],["Bayside 8x3 with Metal Roof / Dutch Door with Window",2539,"fs7uz2kol"],["Bayside 8x3 with Metal Roof / Sliding Door (no window) $149",2688,"fs7uz39yt"],["Bayside 8x3 with Metal Roof / Double Doors with One Fixed Window $159",2698,"fs7uz3z91"],["Bayside 8x4 with Metal Roof / Double Doors",2749.99,"fs7uz4oj9"],["Bayside 8x4 with Metal Roof / Dutch Door with Window",2749.99,"fs7uz5dth"],["Bayside 8x4 with Metal Roof / Sliding Door (no window) $149",2899,"fs7uz633p"],["Bayside 8x4 with Metal Roof / Double Doors with One Fixed Window $159",2909,"fs7uz6sdx"],["Bayside 12x4 with Metal Roof / Double Doors",3419,"fs7uz7ho5"],["Bayside 12x4 with Metal Roof / Dutch Door with Window",3419,"fs7uz86yd"],["Bayside 12x4 with Metal Roof / Sliding Door (no window) $149",3569,"fs7uz8w8l"],["Bayside 12x4 with Metal Roof / Double Doors with One Fixed Window $159",3579,"fs7uz9lit"],["Bayside 6x3 with OSB Roof / Double Doors",2059,"eic4p2245"],["Bayside 6x3 with OSB Roof / Dutch Door with Window",2059,"eic4pl0s5"],["Bayside 6x3 with OSB Roof / Sliding Door (no window) $149",2209,"eic4q1vlh"],["Bayside 6x3 with OSB Roof / Double Doors with One Fixed Window $159",2219,"feint19o5"],["Bayside 6x4 with OSB Roof / Double Doors",2429,"fv4w6c9bp"],["Bayside 6x4 with OSB Roof / Dutch Door with Window",2429,"fv4w6cylx"],["Bayside 6x4 with OSB Roof / Sliding Door (no window) $149",2579,"fv4w6dnw5"],["Bayside 6x4 with OSB Roof / Double Doors with One Fixed Window $159",2589,"fv4w6ed6d"],["Bayside 8x3 with OSB Roof / Double Doors",2429,"eic4s8jed"],["Bayside 8x3 with OSB Roof / Dutch Door with Window",2429,"eic4sv0hh"],["Bayside 8x3 with OSB Roof / Sliding Door (no window) $149",2579,"eic4t5jqt"],["Bayside 8x3 with OSB Roof / Double Doors with One Fixed Window $159",2589,"feint1yyd"],["Bayside 8x4 with OSB Roof / Double Doors",2489,"eic4u2k39"],["Bayside 8x4 with OSB Roof / Dutch Door with Window",2489,"eic4um81h"],["Bayside 8x4 with OSB Roof / Sliding Door (no window) $149",2639,"eic4v3s51"],["Bayside 8x4 with OSB Roof / Double Doors with One Fixed Window $159",2649,"feint2o8l"],["Bayside 12x4 with OSB Roof / Double Doors",3279,"eic4vq985"],["Bayside 12x4 with OSB Roof / Dutch Door with Window",3279,"eic4wjr5h"],["Bayside 12x4 with OSB Roof / Sliding Door (no window) $149",3428,"eic4x688l"],["Bayside 12x4 with OSB Roof / Double Doors with One Fixed Window $159",3438,"feint3dit"]]},{"i":"13","t":"Cedarshed Longhouse Gable Style Double Door Shed Kit","h":"cedarshed-longhouse-double-door-shed","v":"Cedarshed","p":4309,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-longhouse-double-door-shed-kit.webp?v=1714066930","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":4719.99,"q":[["Longhouse 12x6 with Cedar Roof Shingles",4899,"2mc6cqhpx"],["Longhouse 12x8 with Cedar Roof Shingles",5299,"2mc6cr705"],["Longhouse 16x8 with Cedar Roof Shingles",6199,"2mc6crwad"],["Longhouse 12x10 with Cedar Roof Shingles",6099,"2mc6cslkl"],["Longhouse 16x10 with Cedar Roof Shingles",6899,"2mc6ctaut"],["Longhouse 12x6 with Metal Roof",4399,"fs72awaph"],["Longhouse 12x8 with Metal Roof",5199,"fs72awzzp"],["Longhouse 16x8 with Metal Roof",6099,"fs72axp9x"],["Longhouse 12x10 with Metal Roof",5899,"fs72az3ud"],["Longhouse 16x10 with Metal Roof",6599,"fs72ayek5"],["Longhouse 12x6 with OSB Roof",4309,"eibynz7lh"],["Longhouse 12x8 with OSB Roof",4599,"eibyo20qd"],["Longhouse 16x8 with OSB Roof",5399,"eibyoohth"],["Longhouse 12x10 with OSB Roof",5199,"eibyop73p"],["Longhouse 16x10 with OSB Roof",5699,"eibyp14xh"]]},{"i":"14","t":"Cedarshed Rancher Large Shed Kit and Storage Solution","h":"cedarshed-large-rancher-shed-kit-storage-solution","v":"Cedarshed","p":2989,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-rancher-shed-kit-and-storage-solution.webp?v=1713988928","s":{"m":"100% Western Red Cedar","r":"Cedar shingles, metal, or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"6′, 7′ optional","w":"Yes"},"c":3259.99,"q":[["RANCHER 6x6 with Cedar Roof Shingles",3469,"2louk0myd"],["RANCHER 6x9 with Cedar Roof Shingles",3979,"2louk1c8l"],["RANCHER 6x12 with Cedar Roof Shingles",4759,"2louk21it"],["RANCHER 8x8 with Cedar Roof Shingles",4319,"en18u7ar9"],["RANCHER 8x10 with Cedar Roof Shingles",4979,"2louk2qt1"],["RANCHER 8x12 with Cedar Roof Shingles",5179,"2louk3g39"],["RANCHER 8x16 with Cedar Roof Shingles",6479,"2louk45dh"],["RANCHER 10x10 with Cedar Roof Shingles",5279,"2louk4unp"],["RANCHER 10x12 with Cedar Roof Shingles",5679,"2louk5jxx"],["RANCHER 10x16 with Cedar Roof Shingles",6579,"2louk6985"],["RANCHER 10x20 with Cedar Roof Shingles",7879,"2louk6yid"],["RANCHER 6x6 with Metal Roof",3329,"fs7vugmk5"],["RANCHER 6x9 with Metal Roof",3859,"fs7vuhbud"],["RANCHER 6x12 with Metal Roof",4679,"fs7vui14l"],["RANCHER 8x8 with Metal Roof",4239,"fs7vuiqet"],["RANCHER 8x10 with Metal Roof",4699,"fs7vujfp1"],["RANCHER 8x12 with Metal Roof",4899,"fs7vuk4z9"],["RANCHER 8x16 with Metal Roof",6019,"fs7vuku9h"],["RANCHER 10x10 with Metal Roof",4899,"fs7vuljjp"],["RANCHER 10x12 with Metal Roof",5299,"fs7vum8tx"],["RANCHER 10x16 with Metal Roof",6319,"fs7vumy45"],["RANCHER 10x20 with Metal Roof",7519,"fs7vunned"],["RANCHER 6x6 with OSB Roof",2989,"eiby3rlf9"],["RANCHER 6x9 with OSB Roof",3379,"eiby48g8l"],["RANCHER 6x12 with OSB Roof",4139,"eiby4zub9"],["RANCHER 8x8 with OSB Roof",3739,"en18v6eyd"],["RANCHER 8x10 with OSB Roof",4139,"eiby5i3p1"],["RANCHER 8x12 with OSB Roof",4269,"eiby5yyid"],["RANCHER 8x16 with OSB Roof",5309,"euwz88hth"],["RANCHER 10x10 with OSB Roof",4269,"eiby6a71x"],["RANCHER 10x12 with OSB Roof",4559,"eiby6r1v9"],["RANCHER 10x16 with OSB Roof",5469,"eibya0cad"],["RANCHER 10x20 with OSB Roof",6349,"eibyb5s1h"]]},{"i":"15","t":"Cedarshed Ranchhouse Prefab Cottage Kit","h":"cedarshed-ranchhouses-prefab-cottage-kits","v":"Cedarshed","p":6899,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/cedarshed-ranchhouse-prefab-cottage-kit-main.webp?v=1714156975","s":{"m":"100% Western Red Cedar","r":"Cedar shingles or OSB, varies by variant","f":"Plywood floor over 2×4 cedar joists; varies/removable","l":"About 2 weeks production + 1 week delivery","h":"7′","w":"Yes"},"c":7399,"q":[["Ranchhouse 12x12 with Cedar Roof Shingles",7899,"beokkv22d"],["Ranchhouse 16x12 with Cedar Roof Shingles",10299,"beokkvrcl"],["Ranchhouse 12x14 with Cedar Roof Shingles",7999,"beokkwgmt"],["Ranchhouse 16x14 with Cedar Roof Shingles",10499,"beokkx5x1"],["Ranchhouse 12x12 with Metal Roof",7899,"fws1glu7p"],["Ranchhouse 16x12 with Metal Roof",10399,"fws1gmjhx"],["Ranchhouse 12x14 with Metal Roof",7999,"fws1gn8s5"],["Ranchhouse 16x14 with Metal Roof",10499,"fws1gny2d"],["Ranchhouse 12x12 with OSB Roof",6999,"eic0j85dh"],["Ranchhouse 16x12 with OSB Roof",8899,"eic0k3r5h"],["Ranchhouse 12x14 with OSB Roof",6899,"eic0ktqnp"],["Ranchhouse 16x14 with OSB Roof",8999,"eic0l8hmd"]]},{"i":"16","t":"EZ-Fit Craftsman Storage Shed Kit","h":"ez-fit-craftsman-shed-kit","v":"EZ-Fit Sheds","p":2399,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-craftsman-shed-kit-main.jpg?v=1740682952","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"Not listed; sidewall height extension available","w":"Yes"},"c":2699,"q":[["8x8",2399,"dyzebcjed"],["8x10",2599,"dyzebd8ol"],["8x12",2949,"dyzebfcj9"],["10x10",2949,"dyzebgr3p"],["10x12",3299,"dyzebi5o5"],["10x14",3599,"dyzebjk8l"],["10x16",3799,"dyzeblo39"],["10x20",4399,"dyzebn2np"],["12x16",4549,"dyzebpvsl"],["12x20",5099,"dyzebrad1"],["12x24",5549,"dyzebte7p"]]},{"i":"17","t":"EZ-Fit Heritage Shed Kit","h":"ez-fit-heritage-outdoor-garden-shed-kit","v":"EZ-Fit Sheds","p":2699,"g":"https://cdn.shopify.com/s/files/1/1890/0221/products/Heritageedited_1000x1000_60818b49-2519-4b67-a58a-e05892b7e1e5.jpg?v=1660745179","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"6′6″; sidewall height extension available","w":"Yes"},"c":2999,"q":[["8x8'",2699,"fq5f9btpx"],["8x10'",2899,"fq5f9cj05"],["8x12'",3299,"i5n4219"],["10x10'",3299,"fq5f9d8ad"],["10x12'",3699,"i5n4231"],["10x14",3999,"i5n424t"],["10x16'",4299,"i5n426l"],["10x20'",4899,"i5n428d"],["12x16'",5099,"i5n42a5"],["12x20'",5699,"i5n42bx"],["12x24'",6199,"i5n42dp"]]},{"i":"18","t":"EZ-Fit Heritage Shed Kit - QUICK-SHIP","h":"ez-fit-heritage-shed-kit-quick-ship","v":"EZ-Fit Sheds","p":3299,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-heritage-shed-double-doors.webp?v=1740001927","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"3 business days production + 2–9 business days shipping","h":"6′6″; no sidewall height upgrade","w":"Yes"},"c":3599,"q":[["8x12",3299,"fpwanxjjp"],["10x12",3699,"fpwany8tx"]]},{"i":"19","t":"EZ-Fit Homestead Shed Kit","h":"ez-fit-homestead-garden-tool-shed-kit","v":"EZ-Fit Sheds","p":2699,"g":"https://cdn.shopify.com/s/files/1/1890/0221/products/HomesteadEZfit-937503.jpg?v=1695738402","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"6′6″; sidewall height extension available","w":"Yes"},"c":2999,"q":[["8x8",2699,"i5nhowd"],["8x10'",2899,"i5ni00d"],["8x12'",3299,"i5ng7nx"],["10x10'",3299,"i5ni8wd"],["10x12'",3699,"i5ng7pp"],["10x14'",3999,"i5ng7rh"],["10x16'",4299,"i5ng7t9"],["10x20'",4899,"i5ng7v1"],["12x16'",5099,"i5ng7wt"],["12x20'",5699,"i5ng7yl"],["12x24'",6199,"i5ng80d"]]},{"i":"20","t":"EZ-Fit Homestead Shed Kit - QUICK-SHIP","h":"ez-fit-homestead-shed-kit-quick-ship","v":"EZ-Fit Sheds","p":3299,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-homestead-shed-kit-red.jpg?v=1740001269","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"3 business days production + 2–9 business days shipping","h":"6′6″; no sidewall height upgrade","w":"Yes"},"c":3599,"q":[["8x12",3299,"fpv59456d"],["10x12",3699,"fpv594ugl"]]},{"i":"21","t":"EZ-Fit Riverside Shed Kit","h":"ez-fit-riverside-shed-kit","v":"EZ-Fit Sheds","p":3299,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-riverside-shed-kit-main.jpg?v=1732738736","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"6′6″; sidewall height extension available","w":"Yes"},"c":3599,"q":[["8x12'",3299,"i4ch4p9"],["10x12'",3699,"i55brpp"],["10x14'",3999,"i55brt9"],["10x16'",4299,"i55brwt"],["10x20'",4899,"i55bs0d"],["12x16'",5099,"i55bs3x"],["12x20'",5699,"i55bs5p"],["12x24'",6199,"i55bs99"]]},{"i":"22","t":"EZ-Fit Riverside Shed Kit - QUICK-SHIP","h":"ez-fit-10x14-riverside-shed-kit","v":"EZ-Fit Sheds","p":3299,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-quickship-riverside-storage-shed.jpg?v=1756400548","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"3 business days production + 2–9 business days shipping","h":"6′6″; no sidewall height upgrade","w":"Yes"},"c":3599,"q":[["8x12",3299,"fpsnwh1yt"],["10x12",3699,"fpsnwhr91"],["10x14",3999,"fpsnwigj9"],["10x16",4299,"fpsnwj5th"],["10x20",4899,"fpsnwjv3p"],["12x24",6199,"fpsnwkkdx"]]},{"i":"23","t":"EZ-Fit Skyview Shed Kit","h":"ez-fit-skyview-shed-kit","v":"EZ-Fit Sheds","p":4399,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-skyview-shed-kit-main.jpg?v=1743006556","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"6′6″ sidewalls; no sidewall height upgrade","w":"Yes"},"c":4699,"q":[["8x12'",4399,"fqnlcoo51"],["10x12'",4699,"fqnlcpdf9"],["10x16'",5399,"fqnlcq2ph"],["10x20'",5999,"fqnlcqrzp"]]},{"i":"24","t":"EZ-Fit Woodsman Shed Kit","h":"ez-fit-woodsman-shed-kit","v":"EZ-Fit Sheds","p":4199,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/ez-fit-woodsman-shed-kit-main.jpg?v=1740410859","s":{"m":"LP SmartSide engineered wood","r":"Pre-cut roof system","f":"Floor not included; optional floor kit available","l":"8 business days production + 2–9 business days shipping","h":"7′ sidewalls; sidewall height extension available","w":"Yes"},"c":4499,"q":[["8x8",4199,"fq0gjy4vp"],["8x12",4699,"fq0gjyu5x"],["10x10",4799,"fq0gjzjg5"],["10x12",5199,"fq0gk08qd"],["10x14",5599,"fq0gk0y0l"],["10x16",5899,"fq0gk1nat"]]},{"i":"25","t":"Little Cottage Co. Classic 4' Gambrel Barn Shed Kit","h":"little-cottage-company-classic-gambrel-barn-4-sidewall-shed","v":"Little Cottage Co.","p":2229,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-kit-sidewall-main.jpg?v=1759413523","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping","h":"4′ sidewalls","w":"No"},"c":2349,"q":[["8ft x 8ft",2229,"e0ua6fdit"],["8ft x 10ft",2349,"e0ua6g2t1"],["8ft x 12ft",2419,"e0ua6gs39"],["8ft x 14ft",2539,"e0ua6hhdh"],["8ft x 16ft",2979,"e0ua6i6np"],["10ft x 10ft",2479,"e0ua6ivxx"],["10ft x 12ft",2929,"e0ua6jl85"],["10ft x 14ft",3049,"e0ua6kaid"],["10ft x 16ft",3169,"e0ua6kzsl"],["10ft x 18ft",3439,"e0ua6lp2t"],["10ft x 20ft",3699,"e0ua6med1"],["12ft x 12ft",3229,"e0ua6n3n9"],["12ft x 14ft",3379,"e0ua6nsxh"],["12ft x 16ft",3509,"e0ua6oi7p"],["12ft x 18ft",3959,"e0ua6p7hx"],["12ft x 20ft",4079,"e0ua6pws5"],["12ft x 24ft",4639,"e0ua6qm2d"]]},{"i":"26","t":"Little Cottage Co. Classic Five-Corner 10x10 Shed Kit","h":"little-cottage-company-classic-five-corner-10x10-shed","v":"Little Cottage Co.","p":3339,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x10-classic-five-corner-shed-main.jpg?v=1759425555","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"6–8 weeks production + 2–9 days shipping","h":"72″ sidewalls","w":"No"},"c":3519,"q":[["Without Floor Kit",3339,"e08lrj22d"],["With Floor Kit",4249,"e08lrjrcl"]]},{"i":"27","t":"Little Cottage Co. Classic Gable Shed Kit","h":"little-cottage-company-classic-gable-shed","v":"Little Cottage Co.","p":2359,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-classic-gable-storage-shed-isolated.jpg?v=1759252363","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping","h":"6′4.5″ sidewalls","w":"No"},"c":2489,"q":[["8ft x 8ft",2359,"e0ubook6t"],["8ft x 10ft",2549,"e0ubop9h1"],["8ft x 12ft",2679,"e0ubopyr9"],["8ft x 14ft",3159,"e0uboqo1h"],["8ft x 16ft",3289,"e0ubordbp"],["10ft x 10ft",2719,"e0ubos2lx"],["10ft x 12ft",3199,"e0ubosrw5"],["10ft x 14ft",3359,"e0uboth6d"],["10ft x 16ft",3499,"e0ubou6gl"],["10ft x 18ft",3829,"e0ubouvqt"],["10ft x 20ft",4129,"e0ubovl11"],["12ft x 12ft",3379,"e0ubowab9"],["12ft x 14ft",3549,"e0ubowzlh"],["12ft x 16ft",4029,"e0uboxovp"],["12ft x 18ft",4209,"e0uboye5x"],["12ft x 20ft",4339,"e0uboz3g5"],["12ft x 24ft",4789,"e0ubozsqd"]]},{"i":"28","t":"Little Cottage Co. Classic Gambrel Barn 6' Sidewall Kit","h":"little-cottage-company-classic-gambrel-barn-6-sidewall-shed","v":"Little Cottage Co.","p":2509,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/classic-gambrel-barn-shed-6-sidewall-main.jpg?v=1759345324","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping","h":"6′ sidewalls","w":"No"},"c":2649,"q":[["8ft x 8ft",2509,"e0uavjz91"],["8ft x 10ft",2679,"e0uavkoj9"],["8ft x 12ft",2829,"e0uavldth"],["8ft x 14ft",3329,"e0uavm33p"],["8ft x 16ft",3479,"e0uavmsdx"],["10ft x 10ft",2979,"e0uavnho5"],["10ft x 12ft",3489,"e0uavo6yd"],["10ft x 14ft",3629,"e0uavow8l"],["10ft x 16ft",3709,"e0uavplit"],["10ft x 18ft",4099,"e0uavqat1"],["10ft x 20ft",4409,"e0uavr039"],["12ft x 12ft",3749,"e0uavrpdh"],["12ft x 14ft",3879,"e0uavsenp"],["12ft x 16ft",4399,"e0uavt3xx"],["12ft x 18ft",4559,"e0uavtt85"],["12ft x 20ft",4729,"e0uavuiid"],["12ft x 24ft",5349,"e0uavv7sl"]]},{"i":"29","t":"Little Cottage Co. Classic Gambrel Large Barn","h":"little-cottage-co-classic-gambrel-large-barn","v":"Little Cottage Co.","p":4559,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/little-cottage-co-classic-gambrel-barn.jpg?v=1759352547","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Floor not included; optional kit available","l":"Not listed","h":"76″ sidewalls","w":"No"},"c":4819,"q":[["14ft x 18ft",4559,"fum704eut"],["14ft x 20ft",4749,"fum705451"],["14ft x 22ft",4999,"fum705tf9"],["14ft x 24ft",5239,"fum706iph"],["14ft x 26ft",5459,"fum7077zp"],["14ft x 28ft",6089,"fum707x9x"],["14ft x 30ft",6199,"fum708mk5"],["14ft x 32ft",6409,"fum709bud"],["16ft x 18ft",5139,"fum70a14l"],["16ft x 20ft",5459,"fum70aqet"],["16ft x 22ft",5789,"fum70bfp1"],["16ft x 24ft",6009,"fum70c4z9"],["16ft x 26ft",6249,"fum70cu9h"],["16ft x 28ft",6569,"fum70djjp"],["16ft x 30ft",6799,"fum70e8tx"],["16ft x 32ft",7039,"fum70ey45"],["16ft x 34ft",7569,"fum70fned"]]},{"i":"30","t":"Little Cottage Co. Classic Workshop & Garden Shed","h":"little-cottage-company-classic-workshop-shed","v":"Little Cottage Co.","p":2469,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/classic-workshop-storage-shed-kit-front.jpg?v=1759256527","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days production + 2–9 days shipping","h":"6′4.5″ sidewalls","w":"No"},"c":2599,"q":[["8ft x 8ft",2469,"e0ub6r48l"],["8ft x 10ft",2659,"e0ub6rtit"],["8ft x 12ft",2899,"e0ub6sit1"],["8ft x 14ft",3379,"e0ub6t839"],["8ft x 16ft",3519,"e0ub6txdh"],["10ft x 10ft",2819,"e0ub6umnp"],["10ft x 12ft",3419,"e0ub6vbxx"],["10ft x 14ft",3559,"e0ub6w185"],["10ft x 16ft",3719,"e0ub6wqid"],["10ft x 18ft",4039,"e0ub6xfsl"],["10ft x 20ft",4339,"e0ub6y52t"],["12ft x 12ft",3609,"e0ub6yud1"],["12ft x 14ft",3779,"e0ub6zjn9"],["12ft x 16ft",4249,"e0ub708xh"],["12ft x 18ft",4429,"e0ub70y7p"],["12ft x 20ft",4569,"e0ub71nhx"],["12ft x 24ft",5169,"e0ub72cs5"]]},{"i":"31","t":"Little Cottage Co. Colonial Five-Corner 10x10 Shed Kit","h":"little-cottage-company-colonial-five-corner-10x10-shed","v":"Little Cottage Co.","p":4419,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/colonial-five-corner-storage-shed-main.jpg?v=1759425560","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"2–4 weeks production + 2–9 days shipping","h":"72″ sidewalls","w":"No"},"c":4659,"q":[["Without Floor Kit",4419,"e0605wzed"],["With Floor Kit",5369,"e0605xool"]]},{"i":"32","t":"Little Cottage Co. Colonial Pinehurst Storage Shed Kit","h":"little-cottage-company-colonial-pinehurst-shed-kit","v":"Little Cottage Co.","p":2499,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x12-colonial-pinehurst-main_9c9bdbdf-1916-43a7-989a-039f99fa1095.jpg?v=1759419491","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping","h":"6′4.5″ sidewalls","w":"No"},"c":2639,"q":[["8ft x 8ft",2499,"e0uh7tyr9"],["8ft x 10ft",2979,"e0uh7uo1h"],["8ft x 12ft",3109,"e0uh7vdbp"],["8ft x 14ft",3569,"e0uh7w2lx"],["8ft x 16ft",3709,"e0uh7wrw5"],["10ft x 10ft",3349,"e0uh7xh6d"],["10ft x 12ft",3839,"e0uh7y6gl"],["10ft x 14ft",4249,"e0uh7yvqt"],["10ft x 16ft",4379,"e0uh7zl11"],["10ft x 18ft",4849,"e0uh80ab9"],["10ft x 20ft",4979,"e0uh80zlh"],["12ft x 12ft",4099,"e0uh81ovp"],["12ft x 14ft",4569,"e0uh82e5x"],["12ft x 16ft",5009,"e0uh833g5"],["12ft x 18ft",5169,"e0uh83sqd"],["12ft x 20ft",5329,"e0uh84i0l"],["12ft x 24ft",5859,"e0uh857at"]]},{"i":"33","t":"Little Cottage Co. Colonial Williamsburg Shed Kit","h":"little-cottage-company-colonial-williamsburg-storage-shed-kit","v":"Little Cottage Co.","p":2649,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x16-colonial-williamsburg-main.jpg?v=1759419524","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional treated-joist + plywood floor kit","l":"5–10 business days pre-cut; 4–6 weeks panelized + 2–9 days shipping","h":"6′4.5″ sidewalls","w":"No"},"c":2789,"q":[["8ft x 8ft",2649,"e0ug111rp"],["8ft x 10ft",3149,"e0ug11r1x"],["8ft x 12ft",3329,"e0ug12gc5"],["8ft x 14ft",3799,"e0ug135md"],["8ft x 16ft",3949,"e0ug13uwl"],["10ft x 10ft",3479,"e0ug14k6t"],["10ft x 12ft",4009,"e0ug159h1"],["10ft x 14ft",4439,"e0ug15yr9"],["10ft x 16ft",4609,"e0ug16o1h"],["10ft x 18ft",5079,"e0ug17dbp"],["10ft x 20ft",5249,"e0ug182lx"],["12ft x 12ft",4189,"e0ug18rw5"],["12ft x 14ft",4649,"e0ug19h6d"],["12ft x 16ft",5119,"e0ug1a6gl"],["12ft x 18ft",5219,"e0ug1avqt"],["12ft x 20ft",5389,"e0ug1bl11"],["12ft x 24ft",6079,"e0ug1cab9"]]},{"i":"34","t":"Little Cottage Co. Star Barn Kit","h":"little-cottage-company-star-barn","v":"Little Cottage Co.","p":9189,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-star-barn-storage-shed-kit.jpg?v=1718301285","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Optional treated-joist + plywood floor kit","l":"6–8 weeks production + 2–9 days shipping","h":"76″ sidewalls","w":"No"},"c":9669,"q":[["10ft x 14ft",9189,"e0uq6pk51"],["10ft x 16ft",10349,"e0uq6q9f9"],["10ft x 18ft",11639,"e0uq6qyph"],["10ft x 20ft",12919,"eywq204dx"]]},{"i":"35","t":"Little Cottage Co. Value Gable Shed","h":"little-cottage-company-value-gable-shed-kit","v":"Little Cottage Co.","p":1569,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/8x8-value-gable-shed-kit-front.jpg?v=1759245611","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional floor kit available","l":"5–10 business days production + 2–9 days shipping","h":"6′3″ sidewalls","w":"No"},"c":1649,"q":[["8ft x 8ft",1569,"e0uc725o5"],["8ft x 10ft",1729,"e0uc72uyd"],["8ft x 12ft",1889,"e0uc73k8l"],["8ft x 14ft",2059,"e0uc749it"],["8ft x 16ft",2219,"e0uc74yt1"],["10ft x 10ft",1949,"e0uc75o39"],["10ft x 12ft",2109,"e0uc76ddh"],["10ft x 14ft",2299,"e0uc772np"],["10ft x 16ft",2459,"e0uc77rxx"],["10ft x 18ft",2659,"e0uc78h85"],["10ft x 20ft",2839,"e0uc796id"],["12ft x 12ft",2309,"e0uc79vsl"],["12ft x 14ft",2499,"e0uc7al2t"],["12ft x 16ft",2709,"e0uc7bad1"],["12ft x 18ft",2879,"e0uc7bzn9"],["12ft x 20ft",3089,"e0uc7coxh"],["12ft x 24ft",3489,"e0uc7de7p"]]},{"i":"36","t":"Little Cottage Co. Value Gambrel Barn 4' Sidewalls","h":"little-cottage-company-value-gambrel-barn-4-sidewall-kit","v":"Little Cottage Co.","p":1479,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-main.jpg?v=1759508554","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Floor not included; optional kit available","l":"5–10 business days production + 2–9 days shipping","h":"3′9.5″ sidewalls","w":"No"},"c":1569,"q":[["8ft x 8ft",1479,"e0ucrkb3p"],["8ft x 10ft",1599,"e0ucrl0dx"],["8ft x 12ft",1739,"e0ucrlpo5"],["8ft x 14ft",1889,"e0ucrmeyd"],["8ft x 16ft",2079,"e0ucrn48l"],["10ft x 10ft",1799,"e0ucrntit"],["10ft x 12ft",1989,"e0ucroit1"],["10ft x 14ft",2109,"e0ucrp839"],["10ft x 16ft",2259,"e0ucrpxdh"],["10ft x 18ft",2409,"e0ucrqmnp"],["10ft x 20ft",2559,"e0ucrrbxx"],["12ft x 12ft",2229,"e0ucrs185"],["12ft x 14ft",2409,"e0ucrsqid"],["12ft x 16ft",2569,"e0ucrtfsl"],["12ft x 18ft",2739,"e0ucru52t"],["12ft x 20ft",2909,"e0ucruud1"],["12ft x 24ft",3259,"e0ucrvjn9"]]},{"i":"37","t":"Little Cottage Co. Value Gambrel Barn 6' Sidewalls","h":"little-cottage-company-value-gambrel-barn-6-sidewall-kit","v":"Little Cottage Co.","p":1679,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/10x14-value-gambrel-barn-6-sidewalls.jpg?v=1759324155","s":{"m":"LP SmartSide engineered wood","r":"Gambrel roof","f":"Optional floor kit available","l":"5–10 business days production + 2–9 days shipping","h":"6′ sidewalls","w":"No"},"c":1769,"q":[["8ft x 8ft",1679,"e0ucis9bp"],["8ft x 10ft",1869,"e0ucisylx"],["8ft x 12ft",2029,"e0ucitnw5"],["8ft x 14ft",2219,"e0uciud6d"],["8ft x 16ft",2469,"e0uciv2gl"],["10ft x 10ft",2069,"e0ucivrqt"],["10ft x 12ft",2259,"e0uciwh11"],["10ft x 14ft",2439,"e0ucix6b9"],["10ft x 16ft",2619,"e0ucixvlh"],["10ft x 18ft",2869,"e0uciykvp"],["10ft x 20ft",3059,"e0uciza5x"],["12ft x 12ft",2579,"e0ucizzg5"],["12ft x 14ft",2799,"e0ucj0oqd"],["12ft x 16ft",2999,"e0ucj1e0l"],["12ft x 18ft",3199,"e0ucj23at"],["12ft x 20ft",3419,"e0ucj2sl1"],["12ft x 24ft",3809,"e0ucj3hv9"]]},{"i":"38","t":"Little Cottage Co. Value Workshop Shed","h":"little-cottage-company-value-workshop-shed-kit","v":"Little Cottage Co.","p":1749,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/value-workshop-8x10-front.jpg?v=1759247323","s":{"m":"LP SmartSide engineered wood","r":"Gable roof","f":"Optional floor kit available","l":"5–10 business days production + 2–9 days shipping","h":"6′3″ sidewalls","w":"No"},"c":1839,"q":[["8ft x 8ft",1749,"e0uem39dh"],["8ft x 10ft",1919,"e0uem3ynp"],["8ft x 12ft",2209,"e0uem4nxx"],["8ft x 14ft",2389,"e0uem5d85"],["8ft x 16ft",2559,"e0uem62id"],["10ft x 10ft",2139,"e0uem6rsl"],["10ft x 12ft",2439,"e0uem7h2t"],["10ft x 14ft",2629,"e0uem86d1"],["10ft x 16ft",2759,"e0uem8vn9"],["10ft x 18ft",2999,"e0uem9kxh"],["10ft x 20ft",3169,"e0uemaa7p"],["12ft x 12ft",2649,"e0uemazhx"],["12ft x 14ft",2829,"e0uemce2d"],["12ft x 16ft",3029,"e0uemd3cl"],["12ft x 18ft",3209,"e0uemdsmt"],["12ft x 20ft",3409,"e0uemehx1"],["12ft x 24ft",3809,"e0uemf779"]]},{"i":"39","t":"Outdoor Living Today 12x8 Saltbox Studio","h":"outdoor-living-today-12x8-saltbox-studio","v":"Outdoor Living Today","p":13499,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/outdoor-living-today-12x8-saltbox-studio.webp?v=1769027284","s":{"m":"Western Red Cedar wood","r":"Cedar roof system","f":"Wood floor/base components listed","l":"7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping","h":"Not listed","w":"No"},"c":15499},{"i":"40","t":"Outdoor Living Today 6x3 Oscar Waste Management Shed","h":"outdoor-living-today-6x3-oscar-waste-management-shed","v":"Outdoor Living Today","p":1599,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/6x3-oscar-waste-management-shed-main.jpg?v=1711556132","s":{"m":"Western Red Cedar wood","f":"Wood floor/base components listed","l":"7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping","r":"Cedar roof system","h":"Not listed","w":"No"},"c":2289},{"i":"41","t":"Outdoor Living Today 6x4 SpaceMaster Wood Storage Shed with Double Doors","h":"outdoor-living-today-6x4-spacemaster-wood-storage-shed-with-double-doors","v":"Outdoor Living Today","p":2199,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/olt-spacemaster-6x4-storage-garden-shed.jpg?v=1710522333","s":{"m":"Western Red Cedar wood","r":"Cedar shingles or Galvalume metal, varies by variant","f":"Pre-assembled Western Red Cedar floor included","l":"7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping","h":"64″ min / 77.75″ max interior height","w":"No"},"c":2799,"q":[["Metal",2199,"f9eqdon5h"],["Cedar",2199,"f9eqdpcfp"]]},{"i":"42","t":"Outdoor Living Today 9x9 Penthouse Cedar Garden Shed","h":"outdoor-living-today-9x9-penthouse-cedar-garden-shed","v":"Outdoor Living Today","p":7499,"g":"https://cdn.shopify.com/s/files/1/1890/0221/files/9x9-penthouse-cedar-garden-shed-main.webp?v=1710799316","s":{"m":"Western Red Cedar wood","r":"Cedar shingles included","f":"5/8″ plywood floor over 2×4 cedar joists","l":"7 days production + 5–7 days West Coast shipping / 7–10 days East Coast shipping","h":"Not listed","w":"No"},"c":9299}],S=[null,null],V=[0,0],A=0,R=document.getElementById('hs-shed-compare'),E=document.getElementById('hsScOverlay'),L=document.getElementById('hsScList'),Q=document.getElementById('hsScSearch'),C=document.getElementById('hsScCompare'),X=document.getElementById('hsScClose'),B=[document.getElementById('hsScSlot1'),document.getElementById('hsScSlot2')];function e(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}function m(n){if(n==null||n==='')return '<span class="hs-sc-na">Not listed</span>';var x=Number(n);if(!isFinite(x))return e(n);return '$'+x.toLocaleString(undefined,{maximumFractionDigits:x%1?2:0})}function qs(v){return Array.isArray(v)?v[0]:v.s}function qp(v){return Array.isArray(v)?v[1]:v.p}function qid(v){var x=Array.isArray(v)?v[2]:v.i;return x?parseInt(x,36):''}function pr(p,i){var q=p.q||[];return q.length>1&&q[i]?qp(q[i]):p.p}function cp(p){return p.c}function ph(p,i){var q=p.q||[],id=q.length>1&&q[i]?qid(q[i]):'';return '/products/'+encodeURIComponent(p.h)+(id?'?variant='+encodeURIComponent(String(id)):'')}function priceHtml(p,i){var a=pr(p,i),b=cp(p),h=m(a);if(b&&Number(b)>Number(a))h+='<span class="hs-sc-compare-at">'+m(b)+'</span>';return h}function minVi(p){var q=p.q||[],mi=0,mp=Infinity;if(q.length<2)return 0;q.forEach(function(v,i){var n=Number(qp(v));if(isFinite(n)&&n<mp){mp=n;mi=i}});return mi}function card(p,slot){var q=p.q||[],vi=V[slot]||0;if(q.length>1&&!q[vi])vi=V[slot]=minVi(p);var sel='';if(q.length>1)sel='<div class="hs-sc-size-box"><label class="hs-sc-size-label" for="hsScSize'+slot+'">Size / configuration</label><div class="hs-sc-select-wrap"><select id="hsScSize'+slot+'" class="hs-sc-size-select" data-slot="'+slot+'">'+q.map(function(v,i){return '<option value="'+i+'"'+(i===vi?' selected':'')+'>'+e(qs(v))+' - '+e(m(qp(v)).replace(/<[^>]+>/g,''))+'</option>'}).join('')+'</select></div><div class="hs-sc-size-note">Change option to update price/link.</div></div>';return '<img class="hs-sc-fi" loading="lazy" src="'+e(p.g||'')+'" alt="'+e(p.t)+'"><div class="hs-sc-brand">'+e(p.v||'')+'</div><div class="hs-sc-title">'+e(p.t||'')+'</div><div class="hs-sc-price" data-price-slot="'+slot+'">'+priceHtml(p,vi)+'</div><a class="hs-sc-view hs-sc-card-view" data-link-slot="'+slot+'" href="'+ph(p,vi)+'" target="_blank">View product</a>'+sel+'<button type="button" class="hs-sc-change" data-change="'+slot+'">Change shed</button>'}function empty(slot){return '<div class="hs-sc-plus">+</div><span class="hs-sc-lbl">Add your '+(slot?'second':'first')+' shed</span>'}function renderSlots(){for(var i=0;i<2;i++){B[i].className='hs-sc-slot'+(S[i]?' hs-sc-filled':'');B[i].innerHTML=S[i]?card(S[i],i):empty(i)}renderCompare()}function val(p,k){return p&&p.s&&p.s[k]?e(p.s[k]):'<span class="hs-sc-na">Not listed</span>'}function roofv(p,slot){var q=p&&(p.q||[]),vi=V[slot]||0,l=q.length>1&&q[vi]?String(qs(q[vi])):'';if(/OSB Roof/i.test(l))return 'OSB roof';if(/Metal Roof/i.test(l))return 'Metal roof';return val(p,'r')}function renderCompare(){if(!S[0]&&!S[1]){C.innerHTML='';return}var n0=S[0]?e(S[0].t):'Select a shed',n1=S[1]?e(S[1].t):'Select a shed';var rows=[['Material',val(S[0],'m'),val(S[1],'m')],['Roof type',roofv(S[0],0),roofv(S[1],1)],['Floor kit',val(S[0],'f'),val(S[1],'f')],['Wall height',val(S[0],'h'),val(S[1],'h')],['Custom door and window placement',val(S[0],'w'),val(S[1],'w')],['Lead time',val(S[0],'l'),val(S[1],'l')]];C.innerHTML='<div class="hs-sc-compare-table" role="table" aria-label="Selected shed comparison"><div class="hs-sc-ct-cell hs-sc-ct-head" role="columnheader">Specification</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">'+n0+'</div><div class="hs-sc-ct-cell hs-sc-ct-head hs-sc-ct-prod" role="columnheader">'+n1+'</div>'+rows.map(function(r){return '<div class="hs-sc-ct-cell hs-sc-ct-key" role="rowheader">'+r[0]+'</div><div class="hs-sc-ct-cell" role="cell">'+r[1]+'</div><div class="hs-sc-ct-cell" role="cell">'+r[2]+'</div>'}).join('')+'</div>'}function open(slot){A=slot;E.classList.add('hs-sc-is-open');E.setAttribute('aria-hidden','false');document.body.classList.add('hs-sc-lock');Q.value='';list('');setTimeout(function(){Q.focus()},30)}function close(){E.classList.remove('hs-sc-is-open');E.setAttribute('aria-hidden','true');document.body.classList.remove('hs-sc-lock')}function list(term){term=(term||'').toLowerCase();var items=P.filter(function(p){return !term||(p.t||'').toLowerCase().indexOf(term)>-1||(p.v||'').toLowerCase().indexOf(term)>-1});L.innerHTML=items.map(function(p){return '<div class="hs-sc-picker-item" tabindex="0" role="button" data-id="'+e(p.i)+'"><img loading="lazy" src="'+e(p.g||'')+'" alt="'+e(p.t)+'"><div class="hs-sc-pi-brand">'+e(p.v||'')+'</div><div class="hs-sc-pi-title">'+e(p.t||'')+'</div><div class="hs-sc-pi-price">From '+m(p.p)+'</div></div>'}).join('')||'<p class="hs-sc-na">No sheds found.</p>'}B.forEach(function(b,i){b.addEventListener('click',function(ev){if(ev.target.closest('.hs-sc-change')){open(i);return}if(!S[i])open(i)})});R.addEventListener('change',function(ev){var el=ev.target;if(el.classList&&el.classList.contains('hs-sc-size-select')){var slot=Number(el.getAttribute('data-slot')),p=S[slot];V[slot]=Number(el.value)||0;var price=R.querySelector('[data-price-slot="'+slot+'"]'),link=R.querySelector('[data-link-slot="'+slot+'"]');if(price&&p)price.innerHTML=priceHtml(p,V[slot]);if(link&&p)link.setAttribute('href',ph(p,V[slot]));renderCompare()}});L.addEventListener('click',function(ev){var it=ev.target.closest('.hs-sc-picker-item');if(!it)return;var id=it.getAttribute('data-id'),p=P.find(function(x){return String(x.i)===String(id)});if(p){S[A]=p;V[A]=minVi(p);close();renderSlots()}});L.addEventListener('keydown',function(ev){if(ev.key==='Enter'||ev.key===' '){var it=ev.target.closest('.hs-sc-picker-item');if(it){ev.preventDefault();it.click()}}});Q.addEventListener('input',function(){list(Q.value)});X.addEventListener('click',close);E.addEventListener('click',function(ev){if(ev.target===E)close()});document.addEventListener('keydown',function(ev){if(ev.key==='Escape'&&E.classList.contains('hs-sc-is-open'))close()});function curh(){var m=String(location.pathname||'').match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]).replace(/\/$/,''):''}function initCurrent(){var h=curh(),p=h&&P.find(function(x){return String(x.h)===h});if(p){S[0]=p;V[0]=minVi(p)}}initCurrent();renderSlots();})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
  var marker = 'hs-product-gallery-deferred-loader-v1';

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    if (gallery.dataset.hsProductGalleryDeferredLoader === marker) return;

    var viewer = gallery.querySelector('[data-gallery-viewer]');
    if (!viewer || !viewer.querySelector('img[data-hs-product-gallery-src]')) return;

    gallery.dataset.hsProductGalleryDeferredLoader = marker;
    var figures = Array.prototype.slice.call(viewer.querySelectorAll('[data-gallery-figure]'));

    function loadFigure(figure) {
      if (!figure) return;

      var image = figure.querySelector('img[data-hs-product-gallery-src]');
      if (image) {
        var source = image.getAttribute('data-hs-product-gallery-src');
        var sourceSet = image.getAttribute('data-hs-product-gallery-srcset');
        var sizes = image.getAttribute('data-hs-product-gallery-sizes');

        image.setAttribute('loading', 'eager');
        if (sizes) image.setAttribute('sizes', sizes);
        if (sourceSet) image.setAttribute('srcset', sourceSet);
        if (source) image.setAttribute('src', source);
        image.removeAttribute('data-hs-product-gallery-src');
        image.removeAttribute('data-hs-product-gallery-srcset');
        image.removeAttribute('data-hs-product-gallery-sizes');
      }

      var background = figure.querySelector('[data-hs-product-gallery-background]');
      if (background) {
        background.style.backgroundImage = 'url("' + background.getAttribute('data-hs-product-gallery-background') + '")';
        background.removeAttribute('data-hs-product-gallery-background');
      }
    }

    function loadIndex(index) {
      if (!figures.length || index === null || index === undefined) return;
      var normalized = (Number(index) + figures.length) % figures.length;
      loadFigure(figures[normalized]);
    }

    function selectedIndex() {
      for (var index = 0; index < figures.length; index += 1) {
        if (figures[index].getAttribute('data-gallery-selected') === 'true') return index;
      }
      return 0;
    }

    function loadFromThumbnail(event) {
      var thumbnail = event.target.closest('[data-gallery-thumbnail]');
      if (!thumbnail || !gallery.contains(thumbnail)) return;
      loadIndex(thumbnail.getAttribute('data-gallery-index'));
    }

    gallery.addEventListener('pointerover', loadFromThumbnail, { passive: true });
    gallery.addEventListener('focusin', loadFromThumbnail);
    gallery.addEventListener('touchstart', loadFromThumbnail, { passive: true });
    gallery.addEventListener('click', loadFromThumbnail);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.target.getAttribute('data-gallery-selected') === 'true') {
            loadFigure(record.target);
          }
        });
      });
      figures.forEach(function (figure) {
        observer.observe(figure, {
          attributes: true,
          attributeFilter: ['data-gallery-selected', 'aria-hidden', 'class']
        });
      });
    }

    function preloadAdjacent() {
      loadIndex(selectedIndex() + 1);
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadAdjacent, { timeout: 2500 });
    } else {
      window.setTimeout(preloadAdjacent, 1800);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
